var bu = Object.defineProperty;
var wu = (e, t, r) => t in e ? bu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var rr = (e, t, r) => wu(e, typeof t != "symbol" ? t + "" : t, r);
import { jsxs as T, jsx as s, Fragment as de } from "react/jsx-runtime";
import * as Z from "react";
import ur, { useState as Y, useRef as We, useEffect as le, useMemo as ye, useCallback as te, createContext as Su, useContext as Au, useSyncExternalStore as Cu, Fragment as Iu, memo as Tu, forwardRef as Ou, useId as Pu, useImperativeHandle as Ru, useLayoutEffect as Nu } from "react";
import { c as ao, B as at, N as co, R as so, g as Gr, u as Mu, E as Eu } from "./dom-dataset-CJ7GyQ2E.js";
import { Slot as Is } from "@radix-ui/react-slot";
import { m as we, B as $u, q as hr, V as qi, u as me, r as ku, I as pr, k as mr, j as Ts, C as _u, E as Lu } from "./index-D9llIWB5.js";
import * as Os from "@radix-ui/react-separator";
import * as Te from "@radix-ui/react-toast";
import { WrapText as Du, PencilRuler as Bu, FlipHorizontal as zu, FlipVertical as ju, CropIcon as qu, ChevronUp as Fu, Paperclip as Hu, Eye as Uu, Settings as Wu, ZoomOut as Gu, ZoomIn as Vu, BookMarked as Xu, Sigma as Yu, SmilePlusIcon as Ku, Replace as Yo, SmilePlus as Ju, Frame as Zu, Columns2 as Ko, PanelRight as Qu, PanelLeft as ed, Clipboard as td, Copy as rd, GripVertical as nd, Plus as Ps, Columns4 as id, Columns3 as od, Heading6 as ad, Heading5 as cd, Heading4 as sd, Heading3 as ld, Heading2 as ud, Heading1 as dd, ChevronsUpDown as fd, Trash as hd, Trash2 as pd, TableCellsSplit as md, TableCellsMerge as gd, BetweenVerticalEnd as vd, BetweenVerticalStart as xd, BetweenHorizonalStart as yd, BetweenHorizonalEnd as bd, Unlink as wd, Pencil as Sd, Sparkles as Ad, Table as Cd, Minimize as Id, Maximize as Td, Video as Od, ImageUp as Pd, Link as Rd, ListTodo as Nd, ListOrdered as Md, List as Ed, IndentDecrease as $d, IndentIncrease as kd, Type as _d, CodeXml as Ld, Code as Dd, Superscript as Bd, Subscript as zd, ChevronDown as jd, Undo2 as qd, Redo2 as Fd, PaintRoller as Hd, Eraser as Ud, Minus as Wd, Strikethrough as Gd, Quote as Vd, Underline as Xd, Italic as Yd, LoaderCircle as Kd, Bold as Jd, X as Rs, ChevronRight as Zd, Check as Ns, Circle as Qd } from "lucide-react";
import * as Ut from "@radix-ui/react-tooltip";
import * as Ms from "@radix-ui/react-toggle";
import { TextAlignRightIcon as ef, TextAlignLeftIcon as tf, TextAlignJustifyIcon as rf, TextAlignCenterIcon as nf } from "@radix-ui/react-icons";
import * as Lt from "@radix-ui/react-popover";
import * as Es from "@radix-ui/react-label";
import * as Pe from "@radix-ui/react-dialog";
import { O as Wt, Q as of, z as af, S as cf, a as lo, P as uo, T as Gt, A as sf, R as lf, U as uf, N as Vt, n as $s, m as Ct, b as df, D as ff, V as gr, W as hf, E as pf } from "./index-Drmyqk9P.js";
import { Resizable as mf } from "re-resizable";
import gf from "react-image-crop";
import * as dt from "@radix-ui/react-tabs";
import * as Fi from "@radix-ui/react-checkbox";
import vf, { sticky as xf } from "tippy.js";
import { HexColorPicker as yf } from "react-colorful";
import * as Hi from "@radix-ui/react-switch";
import * as ce from "@radix-ui/react-dropdown-menu";
var ks = typeof global == "object" && global && global.Object === Object && global, bf = typeof self == "object" && self && self.Object === Object && self, Be = ks || bf || Function("return this")(), Le = Be.Symbol, _s = Object.prototype, wf = _s.hasOwnProperty, Sf = _s.toString, Nt = Le ? Le.toStringTag : void 0;
function Af(e) {
  var t = wf.call(e, Nt), r = e[Nt];
  try {
    e[Nt] = void 0;
    var n = !0;
  } catch {
  }
  var i = Sf.call(e);
  return n && (t ? e[Nt] = r : delete e[Nt]), i;
}
var Cf = Object.prototype, If = Cf.toString;
function Tf(e) {
  return If.call(e);
}
var Of = "[object Null]", Pf = "[object Undefined]", Jo = Le ? Le.toStringTag : void 0;
function ct(e) {
  return e == null ? e === void 0 ? Pf : Of : Jo && Jo in Object(e) ? Af(e) : Tf(e);
}
function Ge(e) {
  return e != null && typeof e == "object";
}
var Rf = "[object Symbol]";
function Ar(e) {
  return typeof e == "symbol" || Ge(e) && ct(e) == Rf;
}
function Ls(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var De = Array.isArray, Zo = Le ? Le.prototype : void 0, Qo = Zo ? Zo.toString : void 0;
function vr(e) {
  if (typeof e == "string")
    return e;
  if (De(e))
    return Ls(e, vr) + "";
  if (Ar(e))
    return Qo ? Qo.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Nf = /\s/;
function Mf(e) {
  for (var t = e.length; t-- && Nf.test(e.charAt(t)); )
    ;
  return t;
}
var Ef = /^\s+/;
function $f(e) {
  return e && e.slice(0, Mf(e) + 1).replace(Ef, "");
}
function ot(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ea = NaN, kf = /^[-+]0x[0-9a-f]+$/i, _f = /^0b[01]+$/i, Lf = /^0o[0-7]+$/i, Df = parseInt;
function wt(e) {
  if (typeof e == "number")
    return e;
  if (Ar(e))
    return ea;
  if (ot(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ot(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = $f(e);
  var r = _f.test(e);
  return r || Lf.test(e) ? Df(e.slice(2), r ? 2 : 8) : kf.test(e) ? ea : +e;
}
var Bf = 1 / 0, zf = 17976931348623157e292;
function jf(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = wt(e), e === Bf || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * zf;
  }
  return e === e ? e : 0;
}
function qf(e) {
  var t = jf(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
function fo(e) {
  return e;
}
var Ff = "[object AsyncFunction]", Hf = "[object Function]", Uf = "[object GeneratorFunction]", Wf = "[object Proxy]";
function Ds(e) {
  if (!ot(e))
    return !1;
  var t = ct(e);
  return t == Hf || t == Uf || t == Ff || t == Wf;
}
var Vr = Be["__core-js_shared__"], ta = function() {
  var e = /[^.]+$/.exec(Vr && Vr.keys && Vr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Gf(e) {
  return !!ta && ta in e;
}
var Vf = Function.prototype, Xf = Vf.toString;
function ft(e) {
  if (e != null) {
    try {
      return Xf.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Yf = /[\\^$.*+?()[\]{}|]/g, Kf = /^\[object .+?Constructor\]$/, Jf = Function.prototype, Zf = Object.prototype, Qf = Jf.toString, eh = Zf.hasOwnProperty, th = RegExp(
  "^" + Qf.call(eh).replace(Yf, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function rh(e) {
  if (!ot(e) || Gf(e))
    return !1;
  var t = Ds(e) ? th : Kf;
  return t.test(ft(e));
}
function nh(e, t) {
  return e == null ? void 0 : e[t];
}
function ht(e, t) {
  var r = nh(e, t);
  return rh(r) ? r : void 0;
}
var Ui = ht(Be, "WeakMap");
function ih(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var oh = 800, ah = 16, ch = Date.now;
function sh(e) {
  var t = 0, r = 0;
  return function() {
    var n = ch(), i = ah - (n - r);
    if (r = n, i > 0) {
      if (++t >= oh)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function lh(e) {
  return function() {
    return e;
  };
}
var ra = function() {
  try {
    var e = ht(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), uh = ra ? function(e, t) {
  return ra(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: lh(t),
    writable: !0
  });
} : fo, dh = sh(uh);
function fh(e, t, r, n) {
  for (var i = e.length, o = r + -1; ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function hh(e) {
  return e !== e;
}
function ph(e, t, r) {
  for (var n = r - 1, i = e.length; ++n < i; )
    if (e[n] === t)
      return n;
  return -1;
}
function mh(e, t, r) {
  return t === t ? ph(e, t, r) : fh(e, hh, r);
}
function gh(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && mh(e, t, 0) > -1;
}
var vh = 9007199254740991, xh = /^(?:0|[1-9]\d*)$/;
function Bs(e, t) {
  var r = typeof e;
  return t = t ?? vh, !!t && (r == "number" || r != "symbol" && xh.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function zs(e, t) {
  return e === t || e !== e && t !== t;
}
var na = Math.max;
function yh(e, t, r) {
  return t = na(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, i = -1, o = na(n.length - t, 0), a = Array(o); ++i < o; )
      a[i] = n[t + i];
    i = -1;
    for (var c = Array(t + 1); ++i < t; )
      c[i] = n[i];
    return c[t] = r(a), ih(e, this, c);
  };
}
function bh(e, t) {
  return dh(yh(e, t, fo), e + "");
}
var wh = 9007199254740991;
function ho(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= wh;
}
function js(e) {
  return e != null && ho(e.length) && !Ds(e);
}
var Sh = Object.prototype;
function Ah(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Sh;
  return e === r;
}
function Ch(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Ih = "[object Arguments]";
function ia(e) {
  return Ge(e) && ct(e) == Ih;
}
var qs = Object.prototype, Th = qs.hasOwnProperty, Oh = qs.propertyIsEnumerable, po = ia(/* @__PURE__ */ function() {
  return arguments;
}()) ? ia : function(e) {
  return Ge(e) && Th.call(e, "callee") && !Oh.call(e, "callee");
};
function Ph() {
  return !1;
}
var Fs = typeof exports == "object" && exports && !exports.nodeType && exports, oa = Fs && typeof module == "object" && module && !module.nodeType && module, Rh = oa && oa.exports === Fs, aa = Rh ? Be.Buffer : void 0, Nh = aa ? aa.isBuffer : void 0, Wi = Nh || Ph, Mh = "[object Arguments]", Eh = "[object Array]", $h = "[object Boolean]", kh = "[object Date]", _h = "[object Error]", Lh = "[object Function]", Dh = "[object Map]", Bh = "[object Number]", zh = "[object Object]", jh = "[object RegExp]", qh = "[object Set]", Fh = "[object String]", Hh = "[object WeakMap]", Uh = "[object ArrayBuffer]", Wh = "[object DataView]", Gh = "[object Float32Array]", Vh = "[object Float64Array]", Xh = "[object Int8Array]", Yh = "[object Int16Array]", Kh = "[object Int32Array]", Jh = "[object Uint8Array]", Zh = "[object Uint8ClampedArray]", Qh = "[object Uint16Array]", ep = "[object Uint32Array]", ae = {};
ae[Gh] = ae[Vh] = ae[Xh] = ae[Yh] = ae[Kh] = ae[Jh] = ae[Zh] = ae[Qh] = ae[ep] = !0;
ae[Mh] = ae[Eh] = ae[Uh] = ae[$h] = ae[Wh] = ae[kh] = ae[_h] = ae[Lh] = ae[Dh] = ae[Bh] = ae[zh] = ae[jh] = ae[qh] = ae[Fh] = ae[Hh] = !1;
function tp(e) {
  return Ge(e) && ho(e.length) && !!ae[ct(e)];
}
function mo(e) {
  return function(t) {
    return e(t);
  };
}
var Hs = typeof exports == "object" && exports && !exports.nodeType && exports, kt = Hs && typeof module == "object" && module && !module.nodeType && module, rp = kt && kt.exports === Hs, Xr = rp && ks.process, xr = function() {
  try {
    var e = kt && kt.require && kt.require("util").types;
    return e || Xr && Xr.binding && Xr.binding("util");
  } catch {
  }
}(), ca = xr && xr.isTypedArray, Us = ca ? mo(ca) : tp, np = Object.prototype, ip = np.hasOwnProperty;
function op(e, t) {
  var r = De(e), n = !r && po(e), i = !r && !n && Wi(e), o = !r && !n && !i && Us(e), a = r || n || i || o, c = a ? Ch(e.length, String) : [], l = c.length;
  for (var u in e)
    ip.call(e, u) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Bs(u, l))) && c.push(u);
  return c;
}
function ap(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var cp = ap(Object.keys, Object), sp = Object.prototype, lp = sp.hasOwnProperty;
function up(e) {
  if (!Ah(e))
    return cp(e);
  var t = [];
  for (var r in Object(e))
    lp.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Ws(e) {
  return js(e) ? op(e) : up(e);
}
var dp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fp = /^\w*$/;
function go(e, t) {
  if (De(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Ar(e) ? !0 : fp.test(e) || !dp.test(e) || t != null && e in Object(t);
}
var Dt = ht(Object, "create");
function hp() {
  this.__data__ = Dt ? Dt(null) : {}, this.size = 0;
}
function pp(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var mp = "__lodash_hash_undefined__", gp = Object.prototype, vp = gp.hasOwnProperty;
function xp(e) {
  var t = this.__data__;
  if (Dt) {
    var r = t[e];
    return r === mp ? void 0 : r;
  }
  return vp.call(t, e) ? t[e] : void 0;
}
var yp = Object.prototype, bp = yp.hasOwnProperty;
function wp(e) {
  var t = this.__data__;
  return Dt ? t[e] !== void 0 : bp.call(t, e);
}
var Sp = "__lodash_hash_undefined__";
function Ap(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Dt && t === void 0 ? Sp : t, this;
}
function lt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
lt.prototype.clear = hp;
lt.prototype.delete = pp;
lt.prototype.get = xp;
lt.prototype.has = wp;
lt.prototype.set = Ap;
function Cp() {
  this.__data__ = [], this.size = 0;
}
function Cr(e, t) {
  for (var r = e.length; r--; )
    if (zs(e[r][0], t))
      return r;
  return -1;
}
var Ip = Array.prototype, Tp = Ip.splice;
function Op(e) {
  var t = this.__data__, r = Cr(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Tp.call(t, r, 1), --this.size, !0;
}
function Pp(e) {
  var t = this.__data__, r = Cr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Rp(e) {
  return Cr(this.__data__, e) > -1;
}
function Np(e, t) {
  var r = this.__data__, n = Cr(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Ve(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ve.prototype.clear = Cp;
Ve.prototype.delete = Op;
Ve.prototype.get = Pp;
Ve.prototype.has = Rp;
Ve.prototype.set = Np;
var Bt = ht(Be, "Map");
function Mp() {
  this.size = 0, this.__data__ = {
    hash: new lt(),
    map: new (Bt || Ve)(),
    string: new lt()
  };
}
function Ep(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ir(e, t) {
  var r = e.__data__;
  return Ep(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function $p(e) {
  var t = Ir(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function kp(e) {
  return Ir(this, e).get(e);
}
function _p(e) {
  return Ir(this, e).has(e);
}
function Lp(e, t) {
  var r = Ir(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Xe(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Xe.prototype.clear = Mp;
Xe.prototype.delete = $p;
Xe.prototype.get = kp;
Xe.prototype.has = _p;
Xe.prototype.set = Lp;
var Dp = "Expected a function";
function vo(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Dp);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, n);
    return r.cache = o.set(i, a) || o, a;
  };
  return r.cache = new (vo.Cache || Xe)(), r;
}
vo.Cache = Xe;
var Bp = 500;
function zp(e) {
  var t = vo(e, function(n) {
    return r.size === Bp && r.clear(), n;
  }), r = t.cache;
  return t;
}
var jp = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qp = /\\(\\)?/g, Fp = zp(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(jp, function(r, n, i, o) {
    t.push(i ? o.replace(qp, "$1") : n || r);
  }), t;
});
function Gi(e) {
  return e == null ? "" : vr(e);
}
function Gs(e, t) {
  return De(e) ? e : go(e, t) ? [e] : Fp(Gi(e));
}
function Tr(e) {
  if (typeof e == "string" || Ar(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Vs(e, t) {
  t = Gs(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Tr(t[r++])];
  return r && r == n ? e : void 0;
}
function Hp(e, t, r) {
  var n = e == null ? void 0 : Vs(e, t);
  return n === void 0 ? r : n;
}
function Xs(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var sa = Le ? Le.isConcatSpreadable : void 0;
function Up(e) {
  return De(e) || po(e) || !!(sa && e && e[sa]);
}
function Wp(e, t, r, n, i) {
  var o = -1, a = e.length;
  for (r || (r = Up), i || (i = []); ++o < a; ) {
    var c = e[o];
    r(c) && Xs(i, c);
  }
  return i;
}
function Gp(e, t, r) {
  var n = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), r = r > i ? i : r, r < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++n < i; )
    o[n] = e[n + t];
  return o;
}
function Vp(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, r >= n ? e : Gp(e, t, r);
}
var Xp = "\\ud800-\\udfff", Yp = "\\u0300-\\u036f", Kp = "\\ufe20-\\ufe2f", Jp = "\\u20d0-\\u20ff", Zp = Yp + Kp + Jp, Qp = "\\ufe0e\\ufe0f", em = "\\u200d", tm = RegExp("[" + em + Xp + Zp + Qp + "]");
function xo(e) {
  return tm.test(e);
}
function rm(e) {
  return e.split("");
}
var Ys = "\\ud800-\\udfff", nm = "\\u0300-\\u036f", im = "\\ufe20-\\ufe2f", om = "\\u20d0-\\u20ff", am = nm + im + om, cm = "\\ufe0e\\ufe0f", sm = "[" + Ys + "]", Vi = "[" + am + "]", Xi = "\\ud83c[\\udffb-\\udfff]", lm = "(?:" + Vi + "|" + Xi + ")", Ks = "[^" + Ys + "]", Js = "(?:\\ud83c[\\udde6-\\uddff]){2}", Zs = "[\\ud800-\\udbff][\\udc00-\\udfff]", um = "\\u200d", Qs = lm + "?", el = "[" + cm + "]?", dm = "(?:" + um + "(?:" + [Ks, Js, Zs].join("|") + ")" + el + Qs + ")*", fm = el + Qs + dm, hm = "(?:" + [Ks + Vi + "?", Vi, Js, Zs, sm].join("|") + ")", pm = RegExp(Xi + "(?=" + Xi + ")|" + hm + fm, "g");
function mm(e) {
  return e.match(pm) || [];
}
function gm(e) {
  return xo(e) ? mm(e) : rm(e);
}
function vm(e, t, r) {
  return e === e && (r !== void 0 && (e = e <= r ? e : r), t !== void 0 && (e = e >= t ? e : t)), e;
}
function tl(e, t, r) {
  return r === void 0 && (r = t, t = void 0), r !== void 0 && (r = wt(r), r = r === r ? r : 0), t !== void 0 && (t = wt(t), t = t === t ? t : 0), vm(wt(e), t, r);
}
function xm() {
  this.__data__ = new Ve(), this.size = 0;
}
function ym(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function bm(e) {
  return this.__data__.get(e);
}
function wm(e) {
  return this.__data__.has(e);
}
var Sm = 200;
function Am(e, t) {
  var r = this.__data__;
  if (r instanceof Ve) {
    var n = r.__data__;
    if (!Bt || n.length < Sm - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Xe(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Ue(e) {
  var t = this.__data__ = new Ve(e);
  this.size = t.size;
}
Ue.prototype.clear = xm;
Ue.prototype.delete = ym;
Ue.prototype.get = bm;
Ue.prototype.has = wm;
Ue.prototype.set = Am;
function Cm(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (o[i++] = a);
  }
  return o;
}
function Im() {
  return [];
}
var Tm = Object.prototype, Om = Tm.propertyIsEnumerable, la = Object.getOwnPropertySymbols, Pm = la ? function(e) {
  return e == null ? [] : (e = Object(e), Cm(la(e), function(t) {
    return Om.call(e, t);
  }));
} : Im;
function Rm(e, t, r) {
  var n = t(e);
  return De(e) ? n : Xs(n, r(e));
}
function ua(e) {
  return Rm(e, Ws, Pm);
}
var Yi = ht(Be, "DataView"), Ki = ht(Be, "Promise"), Ji = ht(Be, "Set"), da = "[object Map]", Nm = "[object Object]", fa = "[object Promise]", ha = "[object Set]", pa = "[object WeakMap]", ma = "[object DataView]", Mm = ft(Yi), Em = ft(Bt), $m = ft(Ki), km = ft(Ji), _m = ft(Ui), nt = ct;
(Yi && nt(new Yi(new ArrayBuffer(1))) != ma || Bt && nt(new Bt()) != da || Ki && nt(Ki.resolve()) != fa || Ji && nt(new Ji()) != ha || Ui && nt(new Ui()) != pa) && (nt = function(e) {
  var t = ct(e), r = t == Nm ? e.constructor : void 0, n = r ? ft(r) : "";
  if (n)
    switch (n) {
      case Mm:
        return ma;
      case Em:
        return da;
      case $m:
        return fa;
      case km:
        return ha;
      case _m:
        return pa;
    }
  return t;
});
var ga = Be.Uint8Array, Lm = "__lodash_hash_undefined__";
function Dm(e) {
  return this.__data__.set(e, Lm), this;
}
function Bm(e) {
  return this.__data__.has(e);
}
function zt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Xe(); ++t < r; )
    this.add(e[t]);
}
zt.prototype.add = zt.prototype.push = Dm;
zt.prototype.has = Bm;
function zm(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function rl(e, t) {
  return e.has(t);
}
var jm = 1, qm = 2;
function nl(e, t, r, n, i, o) {
  var a = r & jm, c = e.length, l = t.length;
  if (c != l && !(a && l > c))
    return !1;
  var u = o.get(e), f = o.get(t);
  if (u && f)
    return u == t && f == e;
  var d = -1, h = !0, p = r & qm ? new zt() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < c; ) {
    var m = e[d], g = t[d];
    if (n)
      var y = a ? n(g, m, d, t, e, o) : n(m, g, d, e, t, o);
    if (y !== void 0) {
      if (y)
        continue;
      h = !1;
      break;
    }
    if (p) {
      if (!zm(t, function(w, S) {
        if (!rl(p, S) && (m === w || i(m, w, r, n, o)))
          return p.push(S);
      })) {
        h = !1;
        break;
      }
    } else if (!(m === g || i(m, g, r, n, o))) {
      h = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), h;
}
function Fm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function Hm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Um = 1, Wm = 2, Gm = "[object Boolean]", Vm = "[object Date]", Xm = "[object Error]", Ym = "[object Map]", Km = "[object Number]", Jm = "[object RegExp]", Zm = "[object Set]", Qm = "[object String]", eg = "[object Symbol]", tg = "[object ArrayBuffer]", rg = "[object DataView]", va = Le ? Le.prototype : void 0, Yr = va ? va.valueOf : void 0;
function ng(e, t, r, n, i, o, a) {
  switch (r) {
    case rg:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case tg:
      return !(e.byteLength != t.byteLength || !o(new ga(e), new ga(t)));
    case Gm:
    case Vm:
    case Km:
      return zs(+e, +t);
    case Xm:
      return e.name == t.name && e.message == t.message;
    case Jm:
    case Qm:
      return e == t + "";
    case Ym:
      var c = Fm;
    case Zm:
      var l = n & Um;
      if (c || (c = Hm), e.size != t.size && !l)
        return !1;
      var u = a.get(e);
      if (u)
        return u == t;
      n |= Wm, a.set(e, t);
      var f = nl(c(e), c(t), n, i, o, a);
      return a.delete(e), f;
    case eg:
      if (Yr)
        return Yr.call(e) == Yr.call(t);
  }
  return !1;
}
var ig = 1, og = Object.prototype, ag = og.hasOwnProperty;
function cg(e, t, r, n, i, o) {
  var a = r & ig, c = ua(e), l = c.length, u = ua(t), f = u.length;
  if (l != f && !a)
    return !1;
  for (var d = l; d--; ) {
    var h = c[d];
    if (!(a ? h in t : ag.call(t, h)))
      return !1;
  }
  var p = o.get(e), m = o.get(t);
  if (p && m)
    return p == t && m == e;
  var g = !0;
  o.set(e, t), o.set(t, e);
  for (var y = a; ++d < l; ) {
    h = c[d];
    var w = e[h], S = t[h];
    if (n)
      var b = a ? n(S, w, h, t, e, o) : n(w, S, h, e, t, o);
    if (!(b === void 0 ? w === S || i(w, S, r, n, o) : b)) {
      g = !1;
      break;
    }
    y || (y = h == "constructor");
  }
  if (g && !y) {
    var A = e.constructor, R = t.constructor;
    A != R && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof R == "function" && R instanceof R) && (g = !1);
  }
  return o.delete(e), o.delete(t), g;
}
var sg = 1, xa = "[object Arguments]", ya = "[object Array]", nr = "[object Object]", lg = Object.prototype, ba = lg.hasOwnProperty;
function ug(e, t, r, n, i, o) {
  var a = De(e), c = De(t), l = a ? ya : nt(e), u = c ? ya : nt(t);
  l = l == xa ? nr : l, u = u == xa ? nr : u;
  var f = l == nr, d = u == nr, h = l == u;
  if (h && Wi(e)) {
    if (!Wi(t))
      return !1;
    a = !0, f = !1;
  }
  if (h && !f)
    return o || (o = new Ue()), a || Us(e) ? nl(e, t, r, n, i, o) : ng(e, t, l, r, n, i, o);
  if (!(r & sg)) {
    var p = f && ba.call(e, "__wrapped__"), m = d && ba.call(t, "__wrapped__");
    if (p || m) {
      var g = p ? e.value() : e, y = m ? t.value() : t;
      return o || (o = new Ue()), i(g, y, r, n, o);
    }
  }
  return h ? (o || (o = new Ue()), cg(e, t, r, n, i, o)) : !1;
}
function yo(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !Ge(e) && !Ge(t) ? e !== e && t !== t : ug(e, t, r, n, yo, i);
}
var dg = 1, fg = 2;
function hg(e, t, r, n) {
  var i = r.length, o = i;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var a = r[i];
    if (a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    a = r[i];
    var c = a[0], l = e[c], u = a[1];
    if (a[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var f = new Ue(), d;
      if (!(d === void 0 ? yo(u, l, dg | fg, n, f) : d))
        return !1;
    }
  }
  return !0;
}
function il(e) {
  return e === e && !ot(e);
}
function pg(e) {
  for (var t = Ws(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, il(i)];
  }
  return t;
}
function ol(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function mg(e) {
  var t = pg(e);
  return t.length == 1 && t[0][2] ? ol(t[0][0], t[0][1]) : function(r) {
    return r === e || hg(r, e, t);
  };
}
function gg(e, t) {
  return e != null && t in Object(e);
}
function vg(e, t, r) {
  t = Gs(t, e);
  for (var n = -1, i = t.length, o = !1; ++n < i; ) {
    var a = Tr(t[n]);
    if (!(o = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && ho(i) && Bs(a, i) && (De(e) || po(e)));
}
function xg(e, t) {
  return e != null && vg(e, t, gg);
}
var yg = 1, bg = 2;
function wg(e, t) {
  return go(e) && il(t) ? ol(Tr(e), t) : function(r) {
    var n = Hp(r, e);
    return n === void 0 && n === t ? xg(r, e) : yo(t, n, yg | bg);
  };
}
function al(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Sg(e) {
  return function(t) {
    return Vs(t, e);
  };
}
function Ag(e) {
  return go(e) ? al(Tr(e)) : Sg(e);
}
function Cg(e) {
  return typeof e == "function" ? e : e == null ? fo : typeof e == "object" ? De(e) ? wg(e[0], e[1]) : mg(e) : Ag(e);
}
var Kr = function() {
  return Be.Date.now();
}, Ig = "Expected a function", Tg = Math.max, Og = Math.min;
function Or(e, t, r) {
  var n, i, o, a, c, l, u = 0, f = !1, d = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Ig);
  t = wt(t) || 0, ot(r) && (f = !!r.leading, d = "maxWait" in r, o = d ? Tg(wt(r.maxWait) || 0, t) : o, h = "trailing" in r ? !!r.trailing : h);
  function p(M) {
    var E = n, O = i;
    return n = i = void 0, u = M, a = e.apply(O, E), a;
  }
  function m(M) {
    return u = M, c = setTimeout(w, t), f ? p(M) : a;
  }
  function g(M) {
    var E = M - l, O = M - u, C = t - E;
    return d ? Og(C, o - O) : C;
  }
  function y(M) {
    var E = M - l, O = M - u;
    return l === void 0 || E >= t || E < 0 || d && O >= o;
  }
  function w() {
    var M = Kr();
    if (y(M))
      return S(M);
    c = setTimeout(w, g(M));
  }
  function S(M) {
    return c = void 0, h && n ? p(M) : (n = i = void 0, a);
  }
  function b() {
    c !== void 0 && clearTimeout(c), u = 0, n = l = i = c = void 0;
  }
  function A() {
    return c === void 0 ? a : S(Kr());
  }
  function R() {
    var M = Kr(), E = y(M);
    if (n = arguments, i = this, l = M, E) {
      if (c === void 0)
        return m(l);
      if (d)
        return clearTimeout(c), c = setTimeout(w, t), p(l);
    }
    return c === void 0 && (c = setTimeout(w, t)), a;
  }
  return R.cancel = b, R.flush = A, R;
}
function Jr(e) {
  return Ge(e) && js(e);
}
var Pg = 200;
function Rg(e, t, r, n) {
  var i = -1, o = gh, a = !0, c = e.length, l = [], u = t.length;
  if (!c)
    return l;
  r && (t = Ls(t, mo(r))), t.length >= Pg && (o = rl, a = !1, t = new zt(t));
  e:
    for (; ++i < c; ) {
      var f = e[i], d = r == null ? f : r(f);
      if (f = f !== 0 ? f : 0, a && d === d) {
        for (var h = u; h--; )
          if (t[h] === d)
            continue e;
        l.push(f);
      } else o(t, d, n) || l.push(f);
    }
  return l;
}
function Ng(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Mg = bh(function(e, t) {
  var r = Ng(t);
  return Jr(r) && (r = void 0), Jr(e) ? Rg(e, Wp(t, 1, Jr), Cg(r)) : [];
}), Eg = "[object Number]";
function yr(e) {
  return typeof e == "number" || Ge(e) && ct(e) == Eg;
}
var $g = "[object RegExp]";
function kg(e) {
  return Ge(e) && ct(e) == $g;
}
var wa = xr && xr.isRegExp, _g = wa ? mo(wa) : kg, Lg = al("length"), cl = "\\ud800-\\udfff", Dg = "\\u0300-\\u036f", Bg = "\\ufe20-\\ufe2f", zg = "\\u20d0-\\u20ff", jg = Dg + Bg + zg, qg = "\\ufe0e\\ufe0f", Fg = "[" + cl + "]", Zi = "[" + jg + "]", Qi = "\\ud83c[\\udffb-\\udfff]", Hg = "(?:" + Zi + "|" + Qi + ")", sl = "[^" + cl + "]", ll = "(?:\\ud83c[\\udde6-\\uddff]){2}", ul = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ug = "\\u200d", dl = Hg + "?", fl = "[" + qg + "]?", Wg = "(?:" + Ug + "(?:" + [sl, ll, ul].join("|") + ")" + fl + dl + ")*", Gg = fl + dl + Wg, Vg = "(?:" + [sl + Zi + "?", Zi, ll, ul, Fg].join("|") + ")", Sa = RegExp(Qi + "(?=" + Qi + ")|" + Vg + Gg, "g");
function Xg(e) {
  for (var t = Sa.lastIndex = 0; Sa.test(e); )
    ++t;
  return t;
}
function Yg(e) {
  return xo(e) ? Xg(e) : Lg(e);
}
var Kg = "Expected a function";
function jt(e, t, r) {
  var n = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Kg);
  return ot(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), Or(e, t, {
    leading: n,
    maxWait: t,
    trailing: i
  });
}
var Jg = 30, Zg = "...", Qg = /\w*$/;
function ev(e, t) {
  var r = Jg, n = Zg;
  if (ot(t)) {
    var i = "separator" in t ? t.separator : i;
    r = "length" in t ? qf(t.length) : r, n = "omission" in t ? vr(t.omission) : n;
  }
  e = Gi(e);
  var o = e.length;
  if (xo(e)) {
    var a = gm(e);
    o = a.length;
  }
  if (r >= o)
    return e;
  var c = r - Yg(n);
  if (c < 1)
    return n;
  var l = a ? Vp(a, 0, c).join("") : e.slice(0, c);
  if (i === void 0)
    return l + n;
  if (a && (c += l.length - c), _g(i)) {
    if (e.slice(c).search(i)) {
      var u, f = l;
      for (i.global || (i = RegExp(i.source, Gi(Qg.exec(i)) + "g")), i.lastIndex = 0; u = i.exec(f); )
        var d = u.index;
      l = l.slice(0, d === void 0 ? c : d);
    }
  } else if (e.indexOf(vr(i), c) != c) {
    var h = l.lastIndexOf(i);
    h > -1 && (l = l.slice(0, h));
  }
  return l + n;
}
const bo = "-", tv = (e) => {
  const t = nv(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (a) => {
      const c = a.split(bo);
      return c[0] === "" && c.length !== 1 && c.shift(), hl(c, t) || rv(a);
    },
    getConflictingClassGroupIds: (a, c) => {
      const l = r[a] || [];
      return c && n[a] ? [...l, ...n[a]] : l;
    }
  };
}, hl = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), i = n ? hl(e.slice(1), n) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(bo);
  return (a = t.validators.find(({
    validator: c
  }) => c(o))) == null ? void 0 : a.classGroupId;
}, Aa = /^\[(.+)\]$/, rv = (e) => {
  if (Aa.test(e)) {
    const t = Aa.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, nv = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return ov(Object.entries(e.classGroups), r).forEach(([o, a]) => {
    eo(a, n, o, t);
  }), n;
}, eo = (e, t, r, n) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : Ca(t, i);
      o.classGroupId = r;
      return;
    }
    if (typeof i == "function") {
      if (iv(i)) {
        eo(i(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: r
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      eo(a, Ca(t, o), r, n);
    });
  });
}, Ca = (e, t) => {
  let r = e;
  return t.split(bo).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, iv = (e) => e.isThemeGetter, ov = (e, t) => t ? e.map(([r, n]) => {
  const i = n.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, c]) => [t + a, c])) : o);
  return [r, i];
}) : e, av = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const i = (o, a) => {
    r.set(o, a), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let a = r.get(o);
      if (a !== void 0)
        return a;
      if ((a = n.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      r.has(o) ? r.set(o, a) : i(o, a);
    }
  };
}, pl = "!", cv = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, i = t[0], o = t.length, a = (c) => {
    const l = [];
    let u = 0, f = 0, d;
    for (let y = 0; y < c.length; y++) {
      let w = c[y];
      if (u === 0) {
        if (w === i && (n || c.slice(y, y + o) === t)) {
          l.push(c.slice(f, y)), f = y + o;
          continue;
        }
        if (w === "/") {
          d = y;
          continue;
        }
      }
      w === "[" ? u++ : w === "]" && u--;
    }
    const h = l.length === 0 ? c : c.substring(f), p = h.startsWith(pl), m = p ? h.substring(1) : h, g = d && d > f ? d - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: m,
      maybePostfixModifierPosition: g
    };
  };
  return r ? (c) => r({
    className: c,
    parseClassName: a
  }) : a;
}, sv = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, lv = (e) => ({
  cache: av(e.cacheSize),
  parseClassName: cv(e),
  ...tv(e)
}), uv = /\s+/, dv = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: i
  } = t, o = [], a = e.trim().split(uv);
  let c = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      modifiers: f,
      hasImportantModifier: d,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = r(u);
    let m = !!p, g = n(m ? h.substring(0, p) : h);
    if (!g) {
      if (!m) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (g = n(h), !g) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      m = !1;
    }
    const y = sv(f).join(":"), w = d ? y + pl : y, S = w + g;
    if (o.includes(S))
      continue;
    o.push(S);
    const b = i(g, m);
    for (let A = 0; A < b.length; ++A) {
      const R = b[A];
      o.push(w + R);
    }
    c = u + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function fv() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = ml(t)) && (n && (n += " "), n += r);
  return n;
}
const ml = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = ml(e[n])) && (r && (r += " "), r += t);
  return r;
};
function hv(e, ...t) {
  let r, n, i, o = a;
  function a(l) {
    const u = t.reduce((f, d) => d(f), e());
    return r = lv(u), n = r.cache.get, i = r.cache.set, o = c, c(l);
  }
  function c(l) {
    const u = n(l);
    if (u)
      return u;
    const f = dv(l, r);
    return i(l, f), f;
  }
  return function() {
    return o(fv.apply(null, arguments));
  };
}
const oe = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, gl = /^\[(?:([a-z-]+):)?(.+)\]$/i, pv = /^\d+\/\d+$/, mv = /* @__PURE__ */ new Set(["px", "full", "screen"]), gv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, vv = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, xv = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, yv = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, bv = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, He = (e) => St(e) || mv.has(e) || pv.test(e), tt = (e) => It(e, "length", Pv), St = (e) => !!e && !Number.isNaN(Number(e)), Zr = (e) => It(e, "number", St), Mt = (e) => !!e && Number.isInteger(Number(e)), wv = (e) => e.endsWith("%") && St(e.slice(0, -1)), H = (e) => gl.test(e), rt = (e) => gv.test(e), Sv = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Av = (e) => It(e, Sv, vl), Cv = (e) => It(e, "position", vl), Iv = /* @__PURE__ */ new Set(["image", "url"]), Tv = (e) => It(e, Iv, Nv), Ov = (e) => It(e, "", Rv), Et = () => !0, It = (e, t, r) => {
  const n = gl.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, Pv = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  vv.test(e) && !xv.test(e)
), vl = () => !1, Rv = (e) => yv.test(e), Nv = (e) => bv.test(e), Mv = () => {
  const e = oe("colors"), t = oe("spacing"), r = oe("blur"), n = oe("brightness"), i = oe("borderColor"), o = oe("borderRadius"), a = oe("borderSpacing"), c = oe("borderWidth"), l = oe("contrast"), u = oe("grayscale"), f = oe("hueRotate"), d = oe("invert"), h = oe("gap"), p = oe("gradientColorStops"), m = oe("gradientColorStopPositions"), g = oe("inset"), y = oe("margin"), w = oe("opacity"), S = oe("padding"), b = oe("saturate"), A = oe("scale"), R = oe("sepia"), M = oe("skew"), E = oe("space"), O = oe("translate"), C = () => ["auto", "contain", "none"], k = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", H, t], N = () => [H, t], L = () => ["", He, tt], _ = () => ["auto", St, H], G = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], se = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], re = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], J = () => ["", "0", H], ge = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], fe = () => [St, H];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Et],
      spacing: [He, tt],
      blur: ["none", "", rt, H],
      brightness: fe(),
      borderColor: [e],
      borderRadius: ["none", "", "full", rt, H],
      borderSpacing: N(),
      borderWidth: L(),
      contrast: fe(),
      grayscale: J(),
      hueRotate: fe(),
      invert: J(),
      gap: N(),
      gradientColorStops: [e],
      gradientColorStopPositions: [wv, tt],
      inset: P(),
      margin: P(),
      opacity: fe(),
      padding: N(),
      saturate: fe(),
      scale: fe(),
      sepia: J(),
      skew: fe(),
      space: N(),
      translate: N()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", H]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [rt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ge()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ge()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...G(), H]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: C()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": C()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": C()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Mt, H]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", H]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: J()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: J()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Mt, H]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Et]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Mt, H]
        }, H]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": _()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": _()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Et]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Mt, H]
        }, H]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": _()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": _()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...re()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...re(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...re(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", H, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [H, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [H, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [rt]
        }, rt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [H, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [H, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", rt, tt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Zr]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Et]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", H]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", St, Zr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", He, H]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", H]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", H]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", He, tt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", He, H]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: N()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", H]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", H]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...G(), Cv]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Av]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Tv]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [He, H]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [He, tt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: L()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [He, tt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", rt, Ov]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Et]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...se(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": se()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", rt, H]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", H]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: fe()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", H]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: fe()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", H]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [A]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [A]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [A]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Mt, H]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", H]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", H]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": N()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": N()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": N()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": N()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": N()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": N()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": N()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": N()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": N()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": N()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": N()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": N()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": N()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": N()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": N()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": N()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": N()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": N()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", H]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [He, tt, Zr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Ev = /* @__PURE__ */ hv(Mv);
function X(...e) {
  return Ev(ao(e));
}
let Qr;
function en() {
  return Qr === void 0 && (Qr = navigator.platform.includes("Mac")), Qr;
}
function $v(e) {
  return `${e}`.toLowerCase() === "mod" ? en() ? "⌘" : "Ctrl" : `${e}`.toLowerCase() === "alt" ? en() ? "⌥" : "Alt" : `${e}`.toLowerCase() === "shift" ? en() ? "⇧" : "Shift" : e;
}
function kv(e) {
  return e.map($v).join(" ");
}
const q = ur.forwardRef(
  (e, t) => {
    const {
      icon: r = void 0,
      // title = undefined,
      tooltip: n = void 0,
      disabled: i = !1,
      customClass: o = "",
      // color = undefined,
      loading: a = void 0,
      shortcutKeys: c = void 0,
      tooltipOptions: l = {},
      action: u = void 0,
      isActive: f = void 0,
      children: d,
      asChild: h = !1,
      upload: p = !1,
      ...m
    } = e, g = bl[r];
    return /* @__PURE__ */ T(jl, { children: [
      /* @__PURE__ */ s(ql, { asChild: !0, children: /* @__PURE__ */ T(
        h ? Is : zl,
        {
          "data-state": f != null && f() ? "on" : "off",
          onClick: u,
          ref: t,
          size: "sm",
          className: X("richtext-w-[32px] richtext-h-[32px]", o),
          disabled: i,
          ...m,
          children: [
            g && /* @__PURE__ */ s(g, { className: "richtext-size-4" }),
            d
          ]
        }
      ) }),
      n && /* @__PURE__ */ s(Po, { ...l, children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-max-w-24 richtext-flex-col richtext-items-center richtext-text-center", children: [
        /* @__PURE__ */ s("div", { children: n }),
        !!(c != null && c.length) && /* @__PURE__ */ s("span", { children: kv(c) })
      ] }) })
    ] });
  }
);
function _v(e) {
  const t = ["size-small", "size-medium", "size-large"], r = [
    "SizeS",
    "SizeM",
    "SizeL"
  ];
  return t.map((n, i) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.${n.replace("-", ".")}.tooltip`),
      icon: r[i],
      action: () => e.commands.updateImage({ width: hr[n] }),
      isActive: () => e.isActive("image", { width: hr[n] })
    }
  }));
}
function Lv(e) {
  const t = ["size-small", "size-medium", "size-large"], r = [
    "SizeS",
    "SizeM",
    "SizeL"
  ];
  return t.map((n, i) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.${n.replace("-", ".")}.tooltip`),
      icon: r[i],
      action: () => e.commands.updateImageGif({ width: hr[n] }),
      isActive: () => e.isActive("image", { width: hr[n] })
    }
  }));
}
function Dv(e) {
  const t = ["left", "center", "right"], r = {
    left: "AlignLeft",
    center: "AlignCenter",
    right: "AlignRight"
  };
  return t.map((n) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.textalign.${n}.tooltip`),
      icon: r[n],
      action: () => {
        var i, o;
        return (o = (i = e.commands) == null ? void 0 : i.setAlignImage) == null ? void 0 : o.call(i, n);
      },
      isActive: () => e.isActive({ align: n }) || !1,
      disabled: !1
    }
  }));
}
function Bv(e) {
  const t = ["left", "center", "right"], r = {
    left: "AlignLeft",
    center: "AlignCenter",
    right: "AlignRight"
  };
  return t.map((n) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.textalign.${n}.tooltip`),
      icon: r[n],
      action: () => {
        var i, o;
        return (o = (i = e.commands) == null ? void 0 : i.setAlignImageGif) == null ? void 0 : o.call(i, n);
      },
      isActive: () => e.isActive({ align: n }) || !1,
      disabled: !1
    }
  }));
}
function zv(e) {
  const t = ["left", "center", "right"], r = {
    left: "AlignLeft",
    center: "AlignCenter",
    right: "AlignRight"
  };
  return t.map((n) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.textalign.${n}.tooltip`),
      icon: r[n],
      action: () => {
        var i, o;
        return (o = (i = e.commands) == null ? void 0 : i.setAlignImageMermaid) == null ? void 0 : o.call(i, n);
      },
      isActive: () => e.isActive({ align: n }) || !1,
      disabled: !1
    }
  }));
}
function jv(e) {
  const t = ["left", "center", "right"], r = {
    left: "AlignLeft",
    center: "AlignCenter",
    right: "AlignRight"
  };
  return t.map((n) => ({
    type: `image-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.textalign.${n}.tooltip`),
      icon: r[n],
      action: () => {
        var i, o;
        return (o = (i = e.commands) == null ? void 0 : i.setAlignImageDrawer) == null ? void 0 : o.call(i, n);
      },
      isActive: () => e.isActive({ align: n }) || !1,
      disabled: !1
    }
  }));
}
function qv(e) {
  const t = ["size-small", "size-medium", "size-large"], r = [
    "SizeS",
    "SizeM",
    "SizeL"
  ];
  return t.map((n, i) => ({
    type: `video-${n}`,
    component: q,
    componentProps: {
      tooltip: we.t(`editor.${n.replace("-", ".")}.tooltip`),
      icon: r[i],
      action: () => e.commands.updateVideo({ width: qi[n] }),
      isActive: () => e.isActive("video", { width: qi[n] })
    }
  }));
}
function Fv(e) {
  return [
    {
      type: "flipX",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.tooltip.flipX"),
        icon: "FlipX",
        action: () => {
          const t = e.getAttributes("image"), { flipX: r } = t;
          e.chain().focus(void 0, { scrollIntoView: !1 }).updateImage({
            flipX: !r
          }).run();
        }
      }
    },
    {
      type: "flipY",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.tooltip.flipY"),
        icon: "FlipY",
        action: () => {
          const t = e.getAttributes("image"), { flipY: r } = t;
          e.chain().focus(void 0, { scrollIntoView: !1 }).updateImage({
            flipY: !r
          }).run();
        }
      }
    },
    ..._v(e),
    ...Dv(e),
    {
      type: "remove",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.remove"),
        icon: "Trash2",
        action: () => {
          const { state: t, dispatch: r } = e.view;
          Wt(t, r);
        }
      }
    }
  ];
}
function Hv(e) {
  return [
    ...Lv(e),
    ...Bv(e),
    {
      type: "remove",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.remove"),
        icon: "Trash2",
        action: () => {
          const { state: t, dispatch: r } = e.view;
          Wt(t, r);
        }
      }
    }
  ];
}
function F0(e) {
  return [
    ...zv(e),
    {
      type: "edit",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.edit"),
        icon: "Pencil",
        action: () => !0
      }
    },
    {
      type: "remove",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.remove"),
        icon: "Trash2",
        action: () => {
          const { state: t, dispatch: r } = e.view;
          Wt(t, r);
        }
      }
    }
  ];
}
function H0(e) {
  return [
    ...jv(e),
    {
      type: "edit",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.edit"),
        icon: "Pencil",
        action: () => (console.log("AAA"), !0)
      }
    },
    {
      type: "remove",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.remove"),
        icon: "Trash2",
        action: () => {
          const { state: t, dispatch: r } = e.view;
          Wt(t, r);
        }
      }
    }
  ];
}
function Uv(e) {
  return [
    ...qv(e),
    {
      type: "remove",
      component: q,
      componentProps: {
        editor: e,
        tooltip: we.t("editor.remove"),
        icon: "Trash2",
        action: () => {
          const { state: t, dispatch: r } = e.view;
          Wt(t, r);
        }
      }
    }
  ];
}
function Wv(e, t) {
  return $u.reduce((r, n) => {
    if (n === "divider" && r.length > 0)
      return [...r, {
        type: "divider",
        component: void 0,
        componentProps: {}
      }];
    const i = e.extensionManager.extensions.find((o) => o.name === n);
    return i ? [...r, i.configure().options.button({ editor: e, t, extension: i })] : r;
  }, []);
}
function wo(e, t, r) {
  const n = [], i = e.node(0);
  r = typeof r == "number" && r >= 0 ? r : e.sameParent(t) ? Math.max(0, e.sharedDepth(t.pos) - 1) : e.sharedDepth(t.pos);
  const o = new of(e, t, r), a = o.depth === 0 ? 0 : i.resolve(o.start).posAtIndex(0);
  return o.parent.forEach((c, l) => {
    const u = a + l, f = u + c.nodeSize;
    if (u < o.start || u >= o.end) return;
    const d = new af(i.resolve(u), i.resolve(f));
    n.push(d);
  }), n;
}
class So {
  constructor(t, r) {
    rr(this, "anchor");
    rr(this, "head");
    this.anchor = t, this.head = r;
  }
  map(t) {
    return new So(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    const r = t.resolve(this.anchor), n = t.resolve(this.head);
    return new ke(r, n);
  }
}
class ke extends cf {
  constructor(r, n, i, o = 1) {
    const { doc: a } = r, c = r === n, l = r.pos === a.content.size && n.pos === a.content.size, u = c && !l ? a.resolve(n.pos + (o > 0 ? 1 : -1)) : n, f = c && l ? a.resolve(r.pos - (o > 0 ? 1 : -1)) : r, d = wo(f.min(u), f.max(u), i);
    super(
      u.pos >= r.pos ? d[0].$from : d[d.length - 1].$to,
      u.pos >= r.pos ? d[d.length - 1].$to : d[0].$from,
      d
    );
    rr(this, "depth");
    this.depth = i;
  }
  get $to() {
    return this.ranges[this.ranges.length - 1].$to;
  }
  eq(r) {
    return r instanceof ke && r.$from.pos === this.$from.pos && r.$to.pos === this.$to.pos;
  }
  map(r, n) {
    const i = r.resolve(n.map(this.anchor)), o = r.resolve(n.map(this.head));
    return new ke(i, o);
  }
  toJSON() {
    return { type: "nodeRange", anchor: this.anchor, head: this.head };
  }
  get isForwards() {
    return this.head >= this.anchor;
  }
  get isBackwards() {
    return !this.isForwards;
  }
  extendBackwards() {
    const { doc: r } = this.$from;
    if (this.isForwards && this.ranges.length > 1) {
      const o = this.ranges.slice(0, -1), a = o[0].$from, c = o[o.length - 1].$to;
      return new ke(a, c, this.depth);
    }
    const n = this.ranges[0], i = r.resolve(Math.max(0, n.$from.pos - 1));
    return new ke(this.$anchor, i, this.depth);
  }
  extendForwards() {
    const { doc: r } = this.$from;
    if (this.isBackwards && this.ranges.length > 1) {
      const o = this.ranges.slice(1), a = o[0].$from, c = o[o.length - 1].$to;
      return new ke(c, a, this.depth);
    }
    const n = this.ranges[this.ranges.length - 1], i = r.resolve(Math.min(r.content.size, n.$to.pos + 1));
    return new ke(this.$anchor, i, this.depth);
  }
  static fromJSON(r, n) {
    return new ke(r.resolve(n.anchor), r.resolve(n.head));
  }
  static create(r, n, i, o, a = 1) {
    return new this(r.resolve(n), r.resolve(i), o, a);
  }
  getBookmark() {
    return new So(this.anchor, this.head);
  }
}
function Gv(e) {
  const t = e.cloneNode(!0), r = [e, ...Array.from(e.getElementsByTagName("*"))], n = [t, ...Array.from(t.getElementsByTagName("*"))];
  return r.forEach((i, o) => {
    n[o].style.cssText = function(a) {
      let c = "";
      const l = getComputedStyle(a);
      for (let u = 0; u < l.length; u += 1)
        c += `${l[u]}:${l.getPropertyValue(l[u])};`;
      return c;
    }(i);
  }), t;
}
function ir(e, t) {
  return window.getComputedStyle(e)[t];
}
function Vv(e = 0, t = 0, r = 0) {
  return Math.min(Math.max(e, t), r);
}
function Ia(e) {
  e.parentNode !== null && e.parentNode !== void 0 && e.parentNode.removeChild(e);
}
function xl(e) {
  const { x: t, y: r, direction: n, editor: i } = e;
  let o = null, a = null, c = null, l = t;
  for (; a === null && l < window.innerWidth && l > 0; ) {
    const u = document.elementsFromPoint(l, r), f = u.findIndex((h) => h.classList.contains("ProseMirror")), d = u.slice(0, f);
    if (d.length > 0) {
      const h = d[0];
      if (o = h, c = i.view.posAtDOM(h, 0), c >= 0) {
        a = i.state.doc.nodeAt(Math.max(c - 1, 0)), (a === null || a.isText) && (a = i.state.doc.nodeAt(Math.max(c - 1, 0))), a || (a = i.state.doc.nodeAt(Math.max(c, 0)));
        break;
      }
    }
    n === "left" ? l -= 1 : l += 1;
  }
  return {
    resultElement: o,
    resultNode: a,
    pos: c !== null ? c : null
  };
}
function Xv(e, t) {
  const { doc: r } = t.view.state, n = xl({ editor: t, x: e.clientX, y: e.clientY, direction: "right" });
  if (!n.resultNode || n.pos === null) return [];
  const i = e.clientX, o = function(f, d, h) {
    const p = Number.parseInt(ir(f.dom, "paddingLeft"), 10), m = Number.parseInt(ir(f.dom, "paddingRight"), 10), g = Number.parseInt(ir(f.dom, "borderLeftWidth"), 10), y = Number.parseInt(ir(f.dom, "borderLeftWidth"), 10), w = f.dom.getBoundingClientRect();
    return {
      left: Vv(
        d,
        w.left + p + g,
        w.right - m - y
      ),
      top: h
    };
  }(t.view, i, e.clientY), a = t.view.posAtCoords(o);
  if (!a) return [];
  const { pos: c } = a;
  if (!r.resolve(c).parent) return [];
  const l = r.resolve(n.pos), u = r.resolve(n.pos + 1);
  return wo(l, u, 0);
}
function Ta(e, t) {
  const r = e.resolve(t), { depth: n } = r;
  return n === 0 ? t : r.pos - r.parentOffset - 1;
}
function Oa(e, t) {
  const r = e.nodeAt(t), n = e.resolve(t);
  let { depth: i } = n, o = r;
  for (; i > 0; ) {
    const a = n.node(i);
    i -= 1, i === 0 && (o = a);
  }
  return o;
}
function Pa(e, t) {
  let r = t;
  for (; r && r.parentNode && r.parentNode !== e.dom; ) r = r.parentNode;
  return r;
}
const yl = new lo("dragHandle");
function Yv({
  pluginKey: e = yl,
  element: t,
  editor: r,
  tippyOptions: n,
  onNodeChange: i
}) {
  const o = document.createElement("div");
  let a = null, c = !1, l = null, u = -1;
  return t.addEventListener("dragstart", (f) => {
    const { view: d } = r;
    if (!f.dataTransfer) return;
    const { empty: h, $from: p, $to: m } = d.state.selection, g = Xv(f, r), y = wo(p, m, 0), w = y.some((C) => g.find((k) => k.$from === C.$from && k.$to === C.$to)), S = h || !w ? g : y;
    if (S.length === 0) return;
    const { tr: b } = d.state, A = document.createElement("div"), R = S[0].$from.pos, M = S[S.length - 1].$to.pos, E = ke.create(d.state.doc, R, M), O = E.content();
    S.forEach((C) => {
      const k = Gv(d.nodeDOM(C.$from.pos));
      A.append(k);
    }), A.style.position = "absolute", A.style.top = "-10000px", document.body.append(A), f.dataTransfer.clearData(), f.dataTransfer.setDragImage(A, 0, 0), d.dragging = { slice: O, move: !0 }, b.setSelection(E), d.dispatch(b), document.addEventListener("drop", () => Ia(A), { once: !0 }), setTimeout(() => {
      t && (t.style.pointerEvents = "none");
    }, 0);
  }), t.addEventListener("dragend", () => {
    t && (t.style.pointerEvents = "auto");
  }), new uo({
    key: typeof e == "string" ? new lo(e) : e,
    state: {
      init: () => ({ locked: !1 }),
      apply(f, d) {
        const h = f.getMeta("lockDragHandle"), p = f.getMeta("hideDragHandle");
        if (h !== void 0 && (c = h), p && a)
          return a.hide(), c = !1, l = null, u = -1, i == null || i({ editor: r, node: null, pos: -1 }), d;
        if (f.docChanged && u !== -1 && t && a) {
          const m = f.mapping.map(u);
          m !== u && (u = m);
        }
        return d;
      }
    },
    view: (f) => {
      return d(), h(r.view.dom), a = vf(f.dom, {
        ...p(),
        ...n
      }), {
        update(A, R) {
          if (!m(t, a) || (t.draggable = !c, !g(A, R)))
            return;
          const M = y(A);
          M && w(A, M);
        },
        destroy() {
          b();
        }
      };
      function d() {
        t.draggable = !0, t.style.pointerEvents = "auto";
      }
      function h(A) {
        var R;
        (R = A.parentElement) == null || R.appendChild(o), o.appendChild(t), Object.assign(o.style, {
          pointerEvents: "none",
          position: "absolute",
          top: "0",
          left: "0"
        });
      }
      function p() {
        return {
          getReferenceClientRect: null,
          interactive: !0,
          trigger: "manual",
          placement: "left-start",
          hideOnClick: !1,
          duration: 100,
          zIndex: 10,
          appendTo: o,
          content: t,
          popperOptions: {
            modifiers: [
              { name: "flip", enabled: !1 },
              {
                name: "preventOverflow",
                options: {
                  rootBoundary: "document",
                  mainAxis: !1
                }
              }
            ]
          }
        };
      }
      function m(A, R) {
        return A && R;
      }
      function g(A, R) {
        return !A.state.doc.eq(R.doc) && u !== -1;
      }
      function y(A) {
        let R = A.nodeDOM(u);
        return R = Pa(A, R), R === A.dom || (R == null ? void 0 : R.nodeType) !== 1 ? null : R;
      }
      function w(A, R) {
        const M = A.posAtDOM(R, 0), E = Oa(r.state.doc, M);
        if (E === l)
          return;
        const O = Ta(r.state.doc, M);
        l = E, u = O, i == null || i({
          editor: r,
          node: l,
          pos: u
        }), S(R);
      }
      function S(A) {
        a.setProps({
          getReferenceClientRect: () => A.getBoundingClientRect()
        }), a.show();
      }
      function b() {
        a == null || a.destroy(), t && Ia(o);
      }
    },
    props: {
      handleDOMEvents: {
        mouseleave: (f, d) => {
          if (c || !h(d)) return !1;
          return p(), m(), !1;
          function h(g) {
            return g.target && !o.contains(g.relatedTarget);
          }
          function p() {
            a == null || a.hide();
          }
          function m() {
            l = null, u = -1, i == null || i({
              editor: r,
              node: null,
              pos: -1
            });
          }
        },
        mousemove: Or((f, d) => {
          if (!t || !a || c)
            return !1;
          const h = xl({
            x: d.clientX,
            y: d.clientY,
            direction: "right",
            editor: r
          });
          if (!h.resultElement || h.resultElement === f.dom)
            return !1;
          const p = Pa(f, h.resultElement);
          if (p === f.dom || (p == null ? void 0 : p.nodeType) !== 1)
            return !1;
          const m = f.posAtDOM(p, 0), g = Oa(r.state.doc, m);
          if (g === l)
            return !1;
          const y = Ta(r.state.doc, m);
          return l = g, u = y, i == null || i({
            editor: r,
            node: l,
            pos: u
          }), a.setProps({
            getReferenceClientRect: () => p.getBoundingClientRect()
          }), a.show(), !1;
        }, 100)
      }
    }
  });
}
var to = /* @__PURE__ */ ((e) => (e[e.max = 7] = "max", e[e.min = 0] = "min", e[e.more = 1] = "more", e[e.less = -1] = "less", e))(to || {});
function Kv(e, t, r) {
  return e < t ? t : e > r ? r : e;
}
function Jv(e, t, r, n) {
  const { doc: i, selection: o } = e;
  if (!i || !o || !(o instanceof Gt || o instanceof sf))
    return e;
  const { from: a, to: c } = o;
  return i.nodesBetween(a, c, (l, u) => {
    const f = l.type;
    return r.includes(f.name) ? (e = ro(e, u, t), !1) : !lf(l.type.name, n.extensionManager.extensions);
  }), e;
}
function ro(e, t, r) {
  if (!e.doc)
    return e;
  const n = e.doc.nodeAt(t);
  if (!n)
    return e;
  const a = Kv((n.attrs.indent || 0) + r, 0, 7);
  if (a === n.attrs.indent)
    return e;
  const c = {
    ...n.attrs,
    indent: a
  };
  return e.setNodeMarkup(t, n.type, c, n.marks);
}
function U0({ delta: e, types: t }) {
  return ({ state: r, dispatch: n, editor: i }) => {
    const { selection: o } = r;
    let { tr: a } = r;
    return a = a.setSelection(o), a = Jv(a, e, t, i), a.docChanged ? (n && n(a), !0) : !1;
  };
}
function Zv(e) {
  var O, C, k;
  const { pluginKey: t = yl } = e, { t: r } = me(), [n, i] = Y(null), [o, a] = Y(-1), c = We(null), l = We(null), [u, f] = Y(!1), d = e.editor.extensionManager.extensions.some((P) => P.name === "textAlign"), h = e.editor.extensionManager.extensions.some((P) => P.name === "indent"), p = e.editor.extensionManager.extensions.some((P) => P.name === "clear");
  le(() => {
    c.current && !e.editor.isDestroyed && (l.current = Yv({
      editor: e.editor,
      element: c.current,
      pluginKey: "ContentItemMenu",
      tippyOptions: {
        offset: [-2, 16],
        zIndex: 99,
        moveTransition: "transform 0.15s ease-out"
      },
      onNodeChange: R
    }), e.editor.registerPlugin(l.current));
  }, [e.editor, c]);
  function m() {
    const P = e.editor.chain();
    P.setNodeSelection(o).unsetAllMarks(), (n == null ? void 0 : n.type.name) !== "paragraph" && P.setParagraph(), P.run();
  }
  function g() {
    e.editor.chain().focus().setNodeSelection(o).run(), document.execCommand("copy");
  }
  function y() {
    e.editor.commands.setNodeSelection(o);
    const { $anchor: P } = e.editor.state.selection, N = P.node(1) || e.editor.state.selection.node;
    e.editor.chain().setMeta("hideDragHandle", !0).insertContentAt(o + ((n == null ? void 0 : n.nodeSize) || 0), N.toJSON()).run();
  }
  function w(P) {
    e.editor.commands.setTextAlign(P);
  }
  function S() {
    const P = ro(e.editor.state.tr, o, 1);
    P.setMeta("hideDragHandle", !0), e.editor.view.dispatch && e.editor.view.dispatch(P);
  }
  function b() {
    const P = ro(e.editor.state.tr, o, -1);
    e.editor.view.dispatch && e.editor.view.dispatch(P);
  }
  function A() {
    e.editor.chain().setMeta("hideDragHandle", !0).setNodeSelection(o).deleteSelection().run();
  }
  function R(P) {
    P.node && i(P.node), a(P.pos);
  }
  function M() {
    var P;
    if (o !== -1) {
      const N = (n == null ? void 0 : n.nodeSize) || 0, L = o + N, _ = (n == null ? void 0 : n.type.name) === "paragraph" && ((P = n == null ? void 0 : n.content) == null ? void 0 : P.size) === 0, G = _ ? o + 2 : L + 2;
      e.editor.chain().command(({ dispatch: ee, tr: se, state: re }) => ee ? (_ ? se.insertText("/", o, o + 1) : se.insert(
        L,
        re.schema.nodes.paragraph.create(null, [re.schema.text("/")])
      ), ee(se)) : !0).focus(G).run();
    }
  }
  le(() => (u ? e.editor.commands.setMeta("lockDragHandle", !0) : e.editor.commands.setMeta("lockDragHandle", !1), () => {
    e.editor.commands.setMeta("lockDragHandle", !1);
  }), [u]), le(() => () => {
    l.current && (e.editor.unregisterPlugin(t), l.current = null);
  }, []), le(() => {
    var P;
    (P = e.editor) != null && P.isDestroyed && l.current && (e.editor.unregisterPlugin(t), l.current = null);
  }, [(O = e.editor) == null ? void 0 : O.isDestroyed]);
  const E = (P) => {
    e != null && e.disabled || f(P);
  };
  return /* @__PURE__ */ s(
    "div",
    {
      ref: c,
      className: `drag-handle richtext-duration-200 richtext-ease-in-out [transition-property:top,_left] ${e == null ? void 0 : e.className}`,
      style: {
        opacity: e != null && e.disabled ? 0 : 1
      },
      children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-gap-0.5 richtext-duration-200 richtext-ease-in-out [transition-property:top,_left]", children: [
        /* @__PURE__ */ s(
          be,
          {
            className: "!richtext-size-7 richtext-cursor-grab",
            disabled: e == null ? void 0 : e.disabled,
            onClick: M,
            size: "icon",
            type: "button",
            variant: "ghost",
            children: /* @__PURE__ */ s(
              xe,
              {
                className: "richtext-text-lg richtext-text-neutral-600 dark:richtext-text-neutral-200",
                name: "Plus"
              }
            )
          }
        ),
        /* @__PURE__ */ T(
          vy,
          {
            onOpenChange: E,
            open: u,
            children: [
              /* @__PURE__ */ T("div", { className: "richtext-relative richtext-flex richtext-flex-col", children: [
                /* @__PURE__ */ T(jl, { children: [
                  /* @__PURE__ */ s(
                    ql,
                    {
                      asChild: !0,
                      disabled: e == null ? void 0 : e.disabled,
                      children: /* @__PURE__ */ s(
                        be,
                        {
                          className: "richtext-relative richtext-z-[1] !richtext-size-7 richtext-cursor-grab",
                          disabled: e == null ? void 0 : e.disabled,
                          size: "icon",
                          type: "button",
                          variant: "ghost",
                          onMouseUp: (P) => {
                            P.preventDefault(), !(e != null && e.disabled) && f(!0);
                          },
                          children: /* @__PURE__ */ s(
                            xe,
                            {
                              className: "richtext-text-sm richtext-text-neutral-600 dark:richtext-text-neutral-200",
                              name: "Grip"
                            }
                          )
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ s(Po, { children: r("editor.draghandle.tooltip") })
                ] }),
                /* @__PURE__ */ s(xy, { className: "richtext-absolute richtext-left-0 richtext-top-0 richtext-z-0 richtext-size-[28px]" })
              ] }),
              /* @__PURE__ */ T(
                Nl,
                {
                  align: "start",
                  className: "richtext-w-48",
                  side: "bottom",
                  sideOffset: 0,
                  children: [
                    /* @__PURE__ */ T(
                      $e,
                      {
                        className: "richtext-flex richtext-gap-3 richtext-bg-opacity-10 hover:richtext-bg-red-400 hover:richtext-bg-opacity-20 focus:richtext-bg-red-400 focus:richtext-bg-opacity-30 focus:richtext-text-red-500 dark:hover:richtext-bg-opacity-20 dark:hover:richtext-text-red-500",
                        onClick: A,
                        children: [
                          /* @__PURE__ */ s(xe, { name: "Trash2" }),
                          /* @__PURE__ */ s("span", { children: r("editor.remove") })
                        ]
                      }
                    ),
                    p ? /* @__PURE__ */ T(
                      $e,
                      {
                        className: "richtext-flex richtext-gap-3",
                        onClick: m,
                        children: [
                          /* @__PURE__ */ s(xe, { name: "PaintRoller" }),
                          /* @__PURE__ */ s("span", { children: r("editor.clear.tooltip") })
                        ]
                      }
                    ) : null,
                    /* @__PURE__ */ T(
                      $e,
                      {
                        className: "richtext-flex richtext-gap-3",
                        onClick: g,
                        children: [
                          /* @__PURE__ */ s(xe, { name: "Clipboard" }),
                          /* @__PURE__ */ s("span", { children: r("editor.copyToClipboard") })
                        ]
                      }
                    ),
                    /* @__PURE__ */ T(
                      $e,
                      {
                        className: "richtext-flex richtext-gap-3",
                        onClick: y,
                        children: [
                          /* @__PURE__ */ s(xe, { name: "Copy" }),
                          /* @__PURE__ */ s("span", { children: r("editor.copy") })
                        ]
                      }
                    ),
                    d || h ? /* @__PURE__ */ s(Ml, {}) : null,
                    d ? /* @__PURE__ */ T($a, { children: [
                      /* @__PURE__ */ T(no, { className: "richtext-flex richtext-gap-3", children: [
                        /* @__PURE__ */ s(xe, { name: "AlignCenter" }),
                        /* @__PURE__ */ s("span", { children: r("editor.textalign.tooltip") })
                      ] }),
                      /* @__PURE__ */ s(Ea, { children: /* @__PURE__ */ T(io, { children: [
                        /* @__PURE__ */ T(
                          $e,
                          {
                            className: "richtext-flex richtext-gap-3",
                            onClick: () => w("left"),
                            children: [
                              /* @__PURE__ */ s(xe, { name: "AlignLeft" }),
                              /* @__PURE__ */ s("span", { children: r("editor.textalign.left.tooltip") })
                            ]
                          }
                        ),
                        /* @__PURE__ */ T(
                          $e,
                          {
                            className: "richtext-flex richtext-gap-3",
                            onClick: () => w("center"),
                            children: [
                              /* @__PURE__ */ s(xe, { name: "AlignCenter" }),
                              /* @__PURE__ */ s("span", { children: r("editor.textalign.center.tooltip") })
                            ]
                          }
                        ),
                        /* @__PURE__ */ T(
                          $e,
                          {
                            className: "richtext-flex richtext-gap-3",
                            onClick: () => w("right"),
                            children: [
                              /* @__PURE__ */ s(xe, { name: "AlignRight" }),
                              /* @__PURE__ */ s("span", { children: r("editor.textalign.right.tooltip") })
                            ]
                          }
                        )
                      ] }) })
                    ] }) : null,
                    h ? /* @__PURE__ */ T($a, { children: [
                      /* @__PURE__ */ T(no, { className: "richtext-flex richtext-gap-3", children: [
                        /* @__PURE__ */ s(xe, { name: "IndentIncrease" }),
                        /* @__PURE__ */ s("span", { children: r("editor.indent") })
                      ] }),
                      /* @__PURE__ */ s(Ea, { children: /* @__PURE__ */ T(io, { children: [
                        /* @__PURE__ */ T(
                          $e,
                          {
                            className: "richtext-flex richtext-gap-3",
                            disabled: ((C = n == null ? void 0 : n.attrs) == null ? void 0 : C.indent) >= to.max,
                            onClick: S,
                            children: [
                              /* @__PURE__ */ s(xe, { name: "IndentIncrease" }),
                              /* @__PURE__ */ s("span", { children: r("editor.indent.tooltip") })
                            ]
                          }
                        ),
                        /* @__PURE__ */ T(
                          $e,
                          {
                            className: "richtext-flex richtext-gap-3",
                            disabled: ((k = n == null ? void 0 : n.attrs) == null ? void 0 : k.indent) <= to.min,
                            onClick: b,
                            children: [
                              /* @__PURE__ */ s(xe, { name: "IndentDecrease" }),
                              /* @__PURE__ */ s("span", { children: r("editor.outdent.tooltip") })
                            ]
                          }
                        )
                      ] }) })
                    ] }) : null
                  ]
                }
              )
            ]
          }
        )
      ] })
    }
  );
}
const Qv = {
  maxWidth: "auto",
  zIndex: 20,
  appendTo: "parent",
  moveTransition: "transform 0.1s ease-out"
};
function ex({ item: e, disabled: t, editor: r }) {
  var i;
  const n = e.component;
  return n ? /* @__PURE__ */ s(
    n,
    {
      ...e.componentProps,
      disabled: t || ((i = e == null ? void 0 : e.componentProps) == null ? void 0 : i.disabled),
      editor: r
    }
  ) : /* @__PURE__ */ s(de, {});
}
function tx(e) {
  const { t, lang: r } = me(), n = ({ editor: o }) => {
    const { selection: a } = o.view.state, { $from: c, to: l } = a;
    return c.pos === l ? !1 : a instanceof Gt;
  }, i = ye(() => e.disabled || !(e != null && e.editor) ? [] : Wv(e.editor, t), [e.disabled, e.editor, r, t]);
  return /* @__PURE__ */ s(
    at,
    {
      editor: e == null ? void 0 : e.editor,
      shouldShow: n,
      tippyOptions: Qv,
      children: i != null && i.length ? /* @__PURE__ */ s("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-flex richtext-h-[26px] richtext-flex-nowrap richtext-items-center richtext-justify-start richtext-gap-[4px] richtext-whitespace-nowrap", children: i == null ? void 0 : i.map((o, a) => (o == null ? void 0 : o.type) === "divider" ? /* @__PURE__ */ s(
        _e,
        {
          className: "!richtext-mx-1 !richtext-my-2 !richtext-h-[16px]",
          orientation: "vertical"
        },
        `bubbleMenu-divider-${a}`
      ) : /* @__PURE__ */ s(
        ex,
        {
          disabled: e.disabled,
          editor: e.editor,
          item: o
        },
        `bubbleMenu-text-${a}`
      )) }) }) : /* @__PURE__ */ s(de, {})
    }
  );
}
function rx(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "currentColor",
      d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2zm14-6H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H3V5h18z"
    }
  ) });
}
function nx(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M6 15h15m0 4H6m9-8h6m0-4h-6M9 9h1a1 1 0 1 1-1 1V7.5a2 2 0 0 1 2-2M3 9h1a1 1 0 1 1-1 1V7.5a2 2 0 0 1 2-2"
    }
  ) });
}
function ix() {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      className: "richtext-w-4 richtext-h-4",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M5.5 3c1.404 0 2.107 0 2.611.38c.219.164.406.375.552.62C9 4.568 9 5.358 9 6.938v10.125c0 1.58 0 2.37-.337 2.937a2.1 2.1 0 0 1-.552.621c-.504.38-1.207.38-2.611.38s-2.107 0-2.611-.38a2.1 2.1 0 0 1-.552-.62C2 19.432 2 18.642 2 17.062V6.938c0-1.58 0-2.37.337-2.938a2.1 2.1 0 0 1 .552-.62C3.393 3 4.096 3 5.5 3M20 11.938v5.124c0 1.58 0 2.37-.337 2.938a2.1 2.1 0 0 1-.552.62c-.504.38-1.207.38-2.611.38s-2.107 0-2.611-.38a2.1 2.1 0 0 1-.552-.62C13 19.433 13 18.642 13 17.063V6.938c0-1.58 0-2.37.337-2.938M22 9l-6-6m6 0l-6 6",
          color: "currentColor"
        }
      )
    }
  );
}
function ox() {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      className: "richtext-w-4 richtext-h-4",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M21 18.5c0 1.404 0 2.107-.38 2.611a2.1 2.1 0 0 1-.62.552c-.567.337-1.358.337-2.937.337H6.938c-1.58 0-2.37 0-2.938-.337a2.1 2.1 0 0 1-.62-.552C3 20.607 3 19.904 3 18.5s0-2.107.38-2.611c.163-.218.374-.406.62-.552C4.567 15 5.357 15 6.938 15h10.125c1.58 0 2.37 0 2.937.337c.246.146.457.334.62.552c.38.504.38 1.207.38 2.611M12.063 4H6.937C5.358 4 4.568 4 4 4.337a2.1 2.1 0 0 0-.62.552C3 5.393 3 6.096 3 7.5s0 2.107.38 2.611c.163.218.374.406.62.552C4.567 11 5.357 11 6.938 11h10.125c1.58 0 2.37 0 2.937-.337M21 8l-6-6m6 0l-6 6",
          color: "currentColor"
        }
      )
    }
  );
}
function ax(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "currentColor",
      d: "M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8zm4 18H6V4h7v5h5zm-.65-10l-2.1 9h-1.4l-1.8-6.79l-1.8 6.79h-1.4l-2.2-9h1.5l1.4 6.81l1.8-6.81h1.3l1.8 6.81l1.4-6.81z"
    }
  ) });
}
function xe(e) {
  const t = bl[e.name];
  return t ? /* @__PURE__ */ s(t, { onClick: e == null ? void 0 : e.onClick, className: `richtext-w-4 richtext-h-4 ${(e == null ? void 0 : e.className) || ""}` }) : null;
}
function cx(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "currentColor",
      d: "M21 22H3v-2h18zm0-18H3V2h18zm-11 9.7h4l-2-5.4zM11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2z"
    }
  ) });
}
function sx(e) {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      width: "1em",
      height: "1em",
      viewBox: "0 0 48 48",
      ...e,
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          stroke: "currentColor",
          strokeLinejoin: "round",
          strokeWidth: 4,
          d: "M36 19L24 31L12 19z"
        }
      )
    }
  );
}
function lx(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s("path", { fill: "currentColor", d: "M9 7v10h6v-2h-4V7z" }) });
}
function ux(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "currentColor",
      d: "M9 7c-1.1 0-2 .9-2 2v8h2V9h2v7h2V9h2v8h2V9a2 2 0 0 0-2-2z"
    }
  ) });
}
function dx(e) {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s(
    "path",
    {
      fill: "currentColor",
      d: "M11 7c-1.1 0-2 .9-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4c1.11 0 2-.89 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7z"
    }
  ) });
}
function fx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m-9 8h4m-2-2v4" }) });
}
function hx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m9 8h4m-2-2v4" }) });
}
function px() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 21v-4m0-4V9m0-4V3m-2 18h4M8 5v4h11l2-2l-2-2zm6 8v4H6l-2-2l2-2z" }) });
}
function mx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "currentColor", d: "M23.943 19.806a.2.2 0 0 0-.168-.034c-1.26-1.855-2.873-3.61-4.419-5.315l-.252-.284c-.001-.073-.067-.12-.134-.15l-.084-.084c-.05-.1-.169-.167-.286-.1c-.47.234-.907.585-1.327.919c-.554.434-1.109.87-1.63 1.354a5 5 0 0 0-.588.618c-.084.117-.017.217.084.267c-.37.368-.74.736-1.109 1.12a.2.2 0 0 0-.05.134c0 .05.033.1.067.117l.655.502v.016c.924.92 2.554 2.173 4.285 3.527c.251.201.52.402.773.602c.117.134.234.285.335.418c.05.066.169.084.236.033c.033.034.084.067.118.1a.24.24 0 0 0 .1.034a.15.15 0 0 0 .135-.066a.24.24 0 0 0 .033-.1c.017 0 .017.016.034.016a.2.2 0 0 0 .134-.05l3.058-3.327c.12-.116.014-.267 0-.267m-7.628-.134l-1.546-1.17l-.15-.1c-.035-.017-.068-.05-.102-.067l-.117-.1c.66-.66 1.33-1.308 2-1.956c-.488.484-1.463 1.906-1.261 2.373c.002 0 .018.042.067.084zm4.1 3.126l-1.277-.97a27 27 0 0 0-1.58-1.504c.69.518 1.277.97 1.361 1.053c.673.585.638.485 1.093.87l.554.4c-.074.103-.151.148-.151.151m.336.25l-.034-.016a1 1 0 0 0 .152-.117zM.588 3.476c.033.217.084.435.117.636c.201 1.103.403 2.106.772 2.858l.152.568c.05.217.134.485.219.552a67 67 0 0 0 3.578 2.942a.18.18 0 0 0 .219 0s0 .016.016.016a.15.15 0 0 0 .118.05a.2.2 0 0 0 .134-.05c1.798-1.989 3.142-3.627 4.1-4.998c.068-.066.084-.167.084-.25c.067-.067.118-.151.185-.201c.067-.067.067-.184 0-.235l-.017-.016c0-.033-.017-.084-.05-.1c-.42-.401-.722-.685-1.042-.986a94 94 0 0 1-2.352-2.273c-.017-.017-.034-.034-.067-.034c-.336-.117-1.025-.234-1.882-.385c-1.277-.216-3.008-.517-4.57-.986c0 0-.101 0-.118.017l-.05.05C.05.714.022.707 0 .718c.017.1.017.167.05.284c0 .033.068.301.068.334zm7.19 4.78l-.033.034a.036.036 0 0 1 .033-.034M6.553 2.238c.101.1.521.502.622.585c-.437-.2-1.529-.702-2.034-.869c.505.1 1.194.201 1.412.284M.79 1.403c.252.434.454 1.939.655 3.41c-.118-.469-.201-.936-.302-1.372C.992 2.673.84 1.988.638 1.386c.124 0 .152.021.152.017m-.286-.369c0-.016 0-.033-.017-.033c.085 0 .135.017.202.05c0 .006-.145-.017-.185-.017m23.17-.217c.017-.066-.336-.367-.219-.384c.253-.017.253-.401 0-.401c-.335.017-.688.1-1.008.15c-.587.117-1.192.234-1.78.367a80 80 0 0 0-3.949.937c-.403.117-.857.2-1.243.401c-.135.067-.118.2-.05.284c-.034.017-.051.017-.085.034c-.117.017-.218.034-.335.05c-.102.017-.152.1-.135.2c0 .017.017.05.017.067c-.706.936-1.496 1.923-2.353 2.976c-.84.969-1.73 1.989-2.62 3.042c-2.84 3.31-6.05 7.07-9.594 10.38a.16.16 0 0 0 0 .234c.016.016.033.033.05.033c-.05.05-.101.085-.152.134q-.05.05-.05.1a.4.4 0 0 0-.067.084c-.067.067-.067.184.017.234c.067.066.185.066.235-.017c.017-.017.017-.033.033-.033a.265.265 0 0 1 .37 0c.202.217.404.435.588.618l-.42-.35c-.067-.067-.184-.05-.234.016c-.068.066-.051.184.016.234l4.469 3.727c.034.034.067.034.118.034a.15.15 0 0 0 .117-.05l.101-.1c.017.016.05.016.067.016c.05 0 .084-.016.118-.05c6.049-6.05 10.922-10.614 16.5-14.693c.05-.033.067-.1.067-.15c.067 0 .118-.05.15-.117c1.026-3.125 1.228-5.9 1.295-7.27c0-.059.016-.038.016-.068c.017-.033.017-.05.017-.05a.98.98 0 0 0-.067-.619m-10.82 4.915c.268-.301.537-.619.806-.903c-1.73 2.273-4.603 5.767-8.67 9.929c2.773-3.059 5.562-6.218 7.864-9.026M5.14 23.466c-.016-.017-.016-.017 0-.017zm2.504-2.156c.135-.15.27-.284.42-.434c0 0 0 .016.017.016c-.224.198-.433.418-.437.418m.69-.668c.099-.1.14-.173.284-.318c.992-1.02 2.017-2.04 3.059-3.076l.016-.016c.252-.2.555-.418.824-.619a228 228 0 0 0-4.184 4.029M14.852 3.91c-.554.719-1.176 1.671-1.697 2.423c-1.646 2.374-6.94 8.174-7.057 8.274a1190 1190 0 0 1-4.839 4.597l-.1.1c-.085-.1-.085-.25.016-.334C8.652 11.966 13.19 6.133 15.021 3.576c-.05.116-.084.216-.168.334zm2.906 3.427c-.671-.386-.99-.987-.806-1.572l.05-.2a.8.8 0 0 1 .085-.167a1.9 1.9 0 0 1 .756-.703c.016 0 .033 0 .05-.016c-.017-.034-.017-.084-.017-.134c.017-.1.085-.167.202-.167c.202 0 .824.184 1.059.384c.067.05.134.117.202.184c.084.1.218.268.285.401c.034.017.067.184.118.268c.033.134.067.284.05.418c-.017.016 0 .116-.017.116a1.6 1.6 0 0 1-.218.619c-.03.03.006.012-.05.067a1.2 1.2 0 0 1-.32.334a1.49 1.49 0 0 1-1.26.234a2 2 0 0 0-.169-.066m4.37 1.403c0 .017-.017.05 0 .067c-.034 0-.05.017-.085.034a110 110 0 0 0-3.915 3.025c1.11-.986 2.218-1.989 3.378-2.975c.336-.301.571-.686.638-1.12l.168-1.003v-.033c.085-.201.404-.118.353.1c-.004-.001-.173.795-.537 1.905" }) });
}
function gx() {
  return /* @__PURE__ */ T("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", children: [
    /* @__PURE__ */ s("path", { fill: "currentColor", d: "M30 18v-2h-6v10h2v-4h3v-2h-3v-2zm-11 8h-4V16h4a3.003 3.003 0 0 1 3 3v4a3.003 3.003 0 0 1-3 3m-2-2h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2zm-6-8H6v10h2v-3h3a2.003 2.003 0 0 0 2-2v-3a2 2 0 0 0-2-2m-3 5v-3h3l.001 3z" }),
    /* @__PURE__ */ s("path", { fill: "currentColor", d: "M22 14v-4a.91.91 0 0 0-.3-.7l-7-7A.9.9 0 0 0 14 2H4a2.006 2.006 0 0 0-2 2v24a2 2 0 0 0 2 2h16v-2H4V4h8v6a2.006 2.006 0 0 0 2 2h6v2Zm-8-4V4.4l5.6 5.6Z" })
  ] });
}
function vx() {
  return /* @__PURE__ */ T(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      className: "icon",
      viewBox: "0 0 1024 1024",
      children: [
        /* @__PURE__ */ s(
          "path",
          {
            fill: "currentColor",
            d: "M679.253 402.364 618.77 561.015l-60.348-158.651a30.04 30.04 0 0 0-30.447-18.637 29.76 29.76 0 0 0-30.447 18.637l-60.416 158.651-60.416-158.651a30.515 30.515 0 0 0-38.843-17.272 28.945 28.945 0 0 0-17.954 37.547l88.815 233.267c4.369 11.469 15.7 19.115 28.398 19.115a30.31 30.31 0 0 0 28.468-19.115l62.395-163.908 62.396 163.84c4.437 11.605 15.701 19.183 28.4 19.183a30.31 30.31 0 0 0 28.466-19.115l88.747-233.267a28.945 28.945 0 0 0-17.886-37.547 30.447 30.447 0 0 0-38.912 17.272zm219.478 395.605-51.883-29.218c-28.672-16.18-52.224-3.072-52.224 29.082v.273H643.209a29.833 29.833 0 0 0-30.31 29.354c0 16.18 13.584 29.218 30.31 29.218h151.825c1.092 30.516 24.03 43.077 52.224 27.648l51.063-27.989c29.013-15.906 29.15-42.189.41-58.368"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "currentColor",
            d: "m810.667 913.135-.478.068H201.796c-19.865 0-36.727-11.673-36.727-25.6v-618.36h154.965c51.268 0 92.911-39.39 92.911-87.858v-87.86H810.19c19.797 0 36.522 11.742 36.522 25.669V739.26h61.987V119.262c0-46.421-44.169-84.241-98.51-84.241H328.364l-225.28 194.56v658.09c0 46.285 44.236 84.105 98.713 84.105H810.19c43.759 0 80.554-24.713 93.32-58.573h-92.842zM350.89 94.89v86.562c0 16.11-13.858 29.286-30.925 29.286H216.815L350.959 94.891z"
          }
        )
      ]
    }
  );
}
function xx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ T("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", color: "currentColor", children: [
    /* @__PURE__ */ s("path", { d: "M14.86 22h-4.312c-3.291 0-4.937 0-6.08-.798a4.2 4.2 0 0 1-.863-.805c-.855-1.066-.855-2.6-.855-5.67v-2.545c0-2.963 0-4.445.473-5.628c.761-1.903 2.37-3.403 4.41-4.113C8.9 2 10.49 2 13.667 2c1.816 0 2.723 0 3.448.252c1.166.406 2.085 1.263 2.52 2.35c.27.676.27 1.523.27 3.216V10" }),
    /* @__PURE__ */ s("path", { d: "M2.75 12c0-1.84 1.506-3.333 3.364-3.333c.672 0 1.464.116 2.117-.057a1.67 1.67 0 0 0 1.19-1.179c.174-.647.057-1.432.057-2.098C9.478 3.493 10.984 2 12.84 2m.002 16h2.523m-4.949-4.15c-.126-.8-.281-.801-1.61-.85h-1.01c-.557 0-1.009.448-1.009 1v3c0 .552.452 1 1.01 1h1.816c.39 0 .803-.313.803-.7v-1.1c0-.11-.113-.304-.224-.304H9.068M12.842 13h1.261m0 0h1.262m-1.262 0v4.875M21.251 13h-2.523c-.557 0-1.009.448-1.009 1v1.5m0 0V18m0-2.5h2.523" })
  ] }) });
}
function yx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", children: /* @__PURE__ */ s("path", { fill: "currentColor", d: "M6.5 3a.75.75 0 0 1 .697.471l3 7.5a.75.75 0 0 1-1.393.557L7.992 9.5H5.008l-.811 2.028a.75.75 0 0 1-1.393-.556l3-7.5A.75.75 0 0 1 6.5 3m0 2.77L5.608 8h1.784zm8.28-1.55a.75.75 0 1 0-1.06 1.06l.72.72h-3.69a.75.75 0 0 0 0 1.5h3.69l-.72.72a.75.75 0 0 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06zm0 7.5a.75.75 0 1 0-1.06 1.06l.72.72H3.75a.75.75 0 0 0 0 1.5h10.69l-.72.72a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06z" }) });
}
function bx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 48 48", children: /* @__PURE__ */ T("g", { fill: "none", stroke: "currentColor", strokeWidth: "4", children: [
    /* @__PURE__ */ s("circle", { cx: "10", cy: "24", r: "4" }),
    /* @__PURE__ */ s("circle", { cx: "38", cy: "10", r: "4" }),
    /* @__PURE__ */ s("circle", { cx: "38", cy: "24", r: "4" }),
    /* @__PURE__ */ s("circle", { cx: "38", cy: "38", r: "4" }),
    /* @__PURE__ */ s("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M34 38H22V10h12M14 24h20" })
  ] }) });
}
function wx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", children: /* @__PURE__ */ s("path", { fill: "currentColor", d: "M13.5 3a.75.75 0 0 0-.697.471l-3 7.5a.75.75 0 0 0 1.393.557l.812-2.028h2.984l.811 2.028a.75.75 0 0 0 1.393-.556l-3-7.5A.75.75 0 0 0 13.5 3m0 2.77L14.392 8h-1.784zM5.22 4.22a.75.75 0 0 1 1.06 1.06L5.56 6h3.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zm0 7.5a.75.75 0 0 1 1.06 1.06l-.72.72h10.69a.75.75 0 0 1 0 1.5H5.56l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06z" }) });
}
function Sx() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "m3 21l7.548-7.548M21 3l-7.548 7.548m0 0L8 3H3l7.548 10.452m2.904-2.904L21 21h-5l-5.452-7.548", color: "currentColor" }) });
}
function Ax() {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M14 2H6a2 2 0 0 0-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V8zm4 18H6V4h7v5h5zm-.65-10l-2.1 9h-1.4l-1.8-6.79l-1.8 6.79h-1.4l-2.2-9h1.5l1.4 6.81l1.8-6.81h1.3l1.8 6.81l1.4-6.81z"
        }
      )
    }
  );
}
const bl = {
  Bold: Jd,
  LoaderCircle: Kd,
  Italic: Yd,
  Underline: Xd,
  Quote: Vd,
  TextQuote: nx,
  Strikethrough: Gd,
  Minus: Wd,
  Eraser: Ud,
  PaintRoller: Hd,
  Redo2: Fd,
  Undo2: qd,
  AlignCenter: nf,
  AlignJustify: rf,
  AlignLeft: tf,
  AlignRight: ef,
  ChevronDown: jd,
  Subscript: zd,
  Superscript: Bd,
  Code: Dd,
  Code2: Ld,
  Type: _d,
  IndentIncrease: kd,
  IndentDecrease: $d,
  List: Ed,
  ListOrdered: Md,
  ListTodo: Nd,
  Link: Rd,
  ImageUp: Pd,
  Video: Od,
  Maximize: Td,
  Minimize: Id,
  Table: Cd,
  Sparkles: Ad,
  Pencil: Sd,
  Unlink: wd,
  BetweenHorizonalEnd: bd,
  BetweenHorizonalStart: yd,
  BetweenVerticalStart: xd,
  BetweenVerticalEnd: vd,
  TableCellsMerge: gd,
  TableCellsSplit: md,
  Trash2: pd,
  Trash: hd,
  Replace: Yo,
  ChevronsUpDown: fd,
  LineHeight: cx,
  Word: ax,
  Heading1: dd,
  Heading2: ud,
  Heading3: ld,
  Heading4: sd,
  Heading5: cd,
  Heading6: ad,
  Columns2: Ko,
  Columns3: od,
  Columns4: id,
  Plus: Ps,
  Grip: nd,
  Copy: rd,
  Clipboard: td,
  PanelLeft: ed,
  PanelRight: Qu,
  Columns: Ko,
  Iframe: Zu,
  MenuDown: sx,
  SizeS: dx,
  SizeM: ux,
  SizeL: lx,
  AspectRatio: rx,
  Emoji: Ju,
  DeleteColumn: ix,
  DeleteRow: ox,
  SearchAndReplace: Yo,
  EmojiIcon: Ku,
  KatexIcon: Yu,
  ExportPdf: gx,
  ExportWord: vx,
  ImportWord: Ax,
  ColumnAddLeft: fx,
  ColumnAddRight: hx,
  BookMarked: Xu,
  Excalidraw: mx,
  ZoomIn: Vu,
  ZoomOut: Gu,
  Settings: Wu,
  Eye: Uu,
  TextDirection: px,
  LeftToRight: yx,
  RightToLeft: wx,
  Attachment: Hu,
  GifIcon: xx,
  ChevronUp: Fu,
  Crop: qu,
  Mermaid: bx,
  Twitter: Sx,
  FlipX: ju,
  FlipY: zu,
  PencilRuler: Bu,
  WrapText: Du
};
function Cx({ fill: e }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "18px",
      height: "18px",
      viewBox: "0 0 256 256",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "icon/填充色", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ T("g", { id: "icon/背景颜色", children: [
        /* @__PURE__ */ s("g", { id: "编组", fill: "currentColor", children: /* @__PURE__ */ T(
          "g",
          {
            transform: "translate(119.502295, 137.878331) rotate(-135.000000) translate(-119.502295, -137.878331) translate(48.002295, 31.757731)",
            id: "矩形",
            children: [
              /* @__PURE__ */ s(
                "path",
                {
                  d: "M100.946943,60.8084699 L43.7469427,60.8084699 C37.2852111,60.8084699 32.0469427,66.0467383 32.0469427,72.5084699 L32.0469427,118.70847 C32.0469427,125.170201 37.2852111,130.40847 43.7469427,130.40847 L100.946943,130.40847 C107.408674,130.40847 112.646943,125.170201 112.646943,118.70847 L112.646943,72.5084699 C112.646943,66.0467383 107.408674,60.8084699 100.946943,60.8084699 Z M93.646,79.808 L93.646,111.408 L51.046,111.408 L51.046,79.808 L93.646,79.808 Z",
                  fillRule: "nonzero"
                }
              ),
              /* @__PURE__ */ s(
                "path",
                {
                  d: "M87.9366521,16.90916 L87.9194966,68.2000001 C87.9183543,69.4147389 86.9334998,70.399264 85.7187607,70.4 L56.9423078,70.4 C55.7272813,70.4 54.7423078,69.4150264 54.7423078,68.2 L54.7423078,39.4621057 C54.7423078,37.2523513 55.5736632,35.1234748 57.0711706,33.4985176 L76.4832996,12.4342613 C78.9534987,9.75382857 83.1289108,9.5834005 85.8093436,12.0535996 C87.1658473,13.303709 87.9372691,15.0644715 87.9366521,16.90916 Z",
                  fillRule: "evenodd"
                }
              ),
              /* @__PURE__ */ s(
                "path",
                {
                  d: "M131.3,111.241199 L11.7,111.241199 C5.23826843,111.241199 0,116.479467 0,122.941199 L0,200.541199 C0,207.002931 5.23826843,212.241199 11.7,212.241199 L131.3,212.241199 C137.761732,212.241199 143,207.002931 143,200.541199 L143,122.941199 C143,116.479467 137.761732,111.241199 131.3,111.241199 Z M124,130.241 L124,193.241 L19,193.241 L19,130.241 L124,130.241 Z",
                  fillRule: "nonzero"
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M51,218 L205,218 C211.075132,218 216,222.924868 216,229 C216,235.075132 211.075132,240 205,240 L51,240 C44.9248678,240 40,235.075132 40,229 C40,222.924868 44.9248678,218 51,218 Z",
            id: "矩形",
            fill: e || "#FBDE28"
          }
        )
      ] }) })
    }
  );
}
function Ix(e) {
  const [t, r] = Y(void 0);
  function n(a) {
    var c;
    (c = e.action) == null || c.call(e, a);
  }
  function i() {
    var a;
    (a = e.action) == null || a.call(e, t);
  }
  const o = te(
    Or((a) => {
      r(a);
    }, 350),
    []
  );
  return /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-h-[32px]", children: [
    /* @__PURE__ */ s(
      q,
      {
        tooltip: e == null ? void 0 : e.tooltip,
        disabled: e == null ? void 0 : e.disabled,
        action: i,
        tooltipOptions: e == null ? void 0 : e.tooltipOptions,
        shortcutKeys: e == null ? void 0 : e.shortcutKeys,
        children: /* @__PURE__ */ s("span", { className: "richtext-flex richtext-items-center richtext-justify-center richtext-text-sm", children: /* @__PURE__ */ s(Cx, { fill: t }) })
      }
    ),
    /* @__PURE__ */ s(
      h0,
      {
        selectedColor: t,
        setSelectedColor: o,
        onChange: n,
        highlight: !0,
        disabled: e == null ? void 0 : e.disabled,
        children: /* @__PURE__ */ s(be, { variant: "ghost", size: "icon", className: "!richtext-w-3 !richtext-h-[32px]", disabled: e == null ? void 0 : e.disabled, children: /* @__PURE__ */ s(xe, { className: "!richtext-w-3 !richtext-h-3 richtext-text-zinc-500", name: "MenuDown" }) })
      }
    )
  ] });
}
function Tx({ editor: e, disabled: t, actions: r }) {
  var y, w, S, b, A, R, M, E, O, C, k, P, N, L, _, G, ee, se;
  const n = ({ editor: re }) => uf(re.view.state, "table"), { t: i } = me();
  function o() {
    e.chain().focus().addColumnBefore().run();
  }
  function a() {
    e.chain().focus().addColumnAfter().run();
  }
  function c() {
    e.chain().focus().deleteColumn().run();
  }
  function l() {
    e.chain().focus().addRowBefore().run();
  }
  function u() {
    e.chain().focus().addRowAfter().run();
  }
  function f() {
    e.chain().focus().deleteRow().run();
  }
  function d() {
    e.chain().focus().mergeCells().run();
  }
  function h() {
    e == null || e.chain().focus().splitCell().run();
  }
  function p() {
    e.chain().focus().deleteTable().run();
  }
  function m(re) {
    e.chain().focus().setTableCellBackground(re).run();
  }
  return /* @__PURE__ */ s(
    at,
    {
      editor: e,
      pluginKey: "table",
      shouldShow: n,
      updateDelay: 0,
      tippyOptions: {
        offset: [0, 8],
        popperOptions: {
          modifiers: [{ name: "flip", enabled: !1 }]
        },
        maxWidth: "auto",
        getReferenceClientRect: () => {
          var Ne;
          const {
            view: re,
            state: {
              selection: { from: J }
            }
          } = e, ge = re.domAtPos(J).node;
          if (!ge)
            return new DOMRect(-1e3, -1e3, 0, 0);
          const fe = (Ne = ge == null ? void 0 : ge.closest) == null ? void 0 : Ne.call(ge, ".tableWrapper");
          return fe ? fe.getBoundingClientRect() : new DOMRect(-1e3, -1e3, 0, 0);
        },
        plugins: [xf],
        sticky: "popper"
      },
      children: t ? /* @__PURE__ */ s(de, {}) : /* @__PURE__ */ T("div", { className: "richtext-flex richtext-size-full richtext-min-w-32 richtext-flex-row richtext-items-center richtext-gap-0.5 richtext-rounded-lg !richtext-border richtext-border-border richtext-bg-background richtext-p-2 richtext-leading-none richtext-shadow-sm", children: [
        /* @__PURE__ */ s(
          q,
          {
            action: o,
            disabled: !((w = (y = e == null ? void 0 : e.can()) == null ? void 0 : y.addColumnBefore) != null && w.call(y)),
            icon: "BetweenHorizonalEnd",
            tooltip: i("editor.table.menu.insertColumnBefore"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: a,
            disabled: !((b = (S = e == null ? void 0 : e.can()) == null ? void 0 : S.addColumnAfter) != null && b.call(S)),
            icon: "BetweenHorizonalStart",
            tooltip: i("editor.table.menu.insertColumnAfter"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: c,
            disabled: !((R = e == null ? void 0 : (A = e.can()).deleteColumn) != null && R.call(A)),
            icon: "DeleteColumn",
            tooltip: i("editor.table.menu.deleteColumn"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          _e,
          {
            className: "!richtext-mx-1 !richtext-my-2 !richtext-h-[16px]",
            orientation: "vertical"
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: l,
            disabled: !((E = e == null ? void 0 : (M = e.can()).addRowBefore) != null && E.call(M)),
            icon: "BetweenVerticalEnd",
            tooltip: i("editor.table.menu.insertRowAbove"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: u,
            disabled: !((C = (O = e == null ? void 0 : e.can()) == null ? void 0 : O.addRowAfter) != null && C.call(O)),
            icon: "BetweenVerticalStart",
            tooltip: i("editor.table.menu.insertRowBelow"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: f,
            disabled: !((P = (k = e == null ? void 0 : e.can()) == null ? void 0 : k.deleteRow) != null && P.call(k)),
            icon: "DeleteRow",
            tooltip: i("editor.table.menu.deleteRow"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          _e,
          {
            className: "!richtext-mx-1 !richtext-my-2 !richtext-h-[16px]",
            orientation: "vertical"
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: d,
            disabled: !((L = (N = e == null ? void 0 : e.can()) == null ? void 0 : N.mergeCells) != null && L.call(N)),
            icon: "TableCellsMerge",
            tooltip: i("editor.table.menu.mergeCells"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: h,
            disabled: !((G = (_ = e == null ? void 0 : e.can()) == null ? void 0 : _.splitCell) != null && G.call(_)),
            icon: "TableCellsSplit",
            tooltip: i("editor.table.menu.splitCells"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          _e,
          {
            className: "!richtext-mx-1 !richtext-my-2 !richtext-h-[16px]",
            orientation: "vertical"
          }
        ),
        /* @__PURE__ */ s(
          Ix,
          {
            action: m,
            editor: e,
            tooltip: i("editor.table.menu.setCellsBgColor"),
            tooltipOptions: {
              sideOffset: 15
            }
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: p,
            disabled: !((se = (ee = e == null ? void 0 : e.can()) == null ? void 0 : ee.deleteTable) != null && se.call(ee)),
            icon: "Trash2",
            tooltip: i("editor.table.menu.deleteTable"),
            "tooltip-options": {
              sideOffset: 15
            }
          }
        ),
        r && r.map((re, J) => /* @__PURE__ */ s(
          q,
          {
            ...re
          },
          J
        ))
      ] })
    }
  );
}
function Ox(e) {
  const { t } = me(), [r, n] = Y({
    text: "",
    link: ""
  }), [i, o] = Y(!1);
  le(() => {
    var c;
    if (e != null && e.editor) {
      const { href: l, target: u } = (c = e.editor) == null ? void 0 : c.getAttributes("link"), { from: f, to: d } = e.editor.state.selection, h = e.editor.state.doc.textBetween(f, d, " ");
      n({
        link: l,
        text: h
      }), o(u === "_blank");
    }
  }, [e == null ? void 0 : e.editor]);
  function a(c) {
    c.preventDefault(), c.stopPropagation(), e == null || e.onSetLink(r.link, r.text, i);
  }
  return /* @__PURE__ */ s("div", { className: "border-neutral-200 richtext-rounded-lg !richtext-border richtext-bg-white richtext-p-2 richtext-shadow-sm dark:richtext-border-neutral-800 dark:richtext-bg-black", children: /* @__PURE__ */ T(
    "form",
    {
      className: "richtext-flex richtext-flex-col richtext-gap-2",
      onSubmit: a,
      children: [
        /* @__PURE__ */ s(it, { className: "mb-[6px]", children: t("editor.link.dialog.text") }),
        /* @__PURE__ */ s("div", { className: "richtext-mb-[10px] richtext-flex richtext-w-full richtext-max-w-sm richtext-items-center richtext-gap-1.5", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-w-full richtext-max-w-sm richtext-items-center", children: /* @__PURE__ */ s(
          Oe,
          {
            className: "richtext-w-80",
            onChange: (c) => n({ ...r, text: c.target.value }),
            placeholder: "Text",
            required: !0,
            type: "text",
            value: r.text
          }
        ) }) }),
        /* @__PURE__ */ s(it, { className: "mb-[6px]", children: t("editor.link.dialog.link") }),
        /* @__PURE__ */ s("div", { className: "richtext-flex richtext-w-full richtext-max-w-sm richtext-items-center richtext-gap-1.5", children: /* @__PURE__ */ T("div", { className: "richtext-relative richtext-w-full richtext-max-w-sm richtext-items-center", children: [
          /* @__PURE__ */ s(
            Oe,
            {
              className: "richtext-pl-10",
              onChange: (c) => n({ ...r, link: c.target.value }),
              required: !0,
              type: "url",
              value: r.link
            }
          ),
          /* @__PURE__ */ s("span", { className: "richtext-absolute richtext-inset-y-0 richtext-start-0 richtext-flex richtext-items-center richtext-justify-center richtext-px-2", children: /* @__PURE__ */ s(
            xe,
            {
              className: "richtext-size-5 richtext-text-muted-foreground",
              name: "Link"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-space-x-2", children: [
          /* @__PURE__ */ s(it, { children: t("editor.link.dialog.openInNewTab") }),
          /* @__PURE__ */ s(
            El,
            {
              checked: i,
              onCheckedChange: (c) => {
                o(c);
              }
            }
          )
        ] }),
        /* @__PURE__ */ s(
          be,
          {
            className: "richtext-mt-2 richtext-self-end",
            type: "submit",
            children: t("editor.link.dialog.button.apply")
          }
        )
      ]
    }
  ) });
}
function Px(e) {
  const { t } = me();
  return /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-gap-2 richtext-p-2 richtext-bg-white !richtext-border richtext-rounded-lg richtext-shadow-sm dark:richtext-bg-black richtext-border-neutral-200 dark:richtext-border-neutral-800", children: [
    /* @__PURE__ */ s(
      "a",
      {
        href: e == null ? void 0 : e.link,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "richtext-text-sm richtext-underline richtext-break-all",
        children: ev(e == null ? void 0 : e.link, {
          length: 50,
          omission: "…"
        })
      }
    ),
    (e == null ? void 0 : e.link) && /* @__PURE__ */ s(_e, { orientation: "vertical", className: "!richtext-h-4" }),
    /* @__PURE__ */ T("div", { className: "richtext-flex richtext-flex-nowrap", children: [
      /* @__PURE__ */ s(
        q,
        {
          icon: "Pencil",
          tooltip: t("editor.link.edit.tooltip"),
          action: () => {
            e == null || e.onEdit();
          },
          tooltipOptions: { sideOffset: 15 }
        }
      ),
      /* @__PURE__ */ s(
        q,
        {
          icon: "Unlink",
          tooltip: t("editor.link.unlink.tooltip"),
          action: () => {
            e == null || e.onClear();
          },
          tooltipOptions: { sideOffset: 15 }
        }
      )
    ] })
  ] });
}
function Rx({ editor: e, disabled: t }) {
  const [r, n] = Y(!1), i = ye(() => {
    const { href: l } = e.getAttributes("link");
    return l;
  }, [e]), o = te(({ editor: l }) => l.isActive("link"), []), a = (l, u, f) => {
    e.chain().extendMarkRange("link").insertContent({
      type: "text",
      text: u,
      marks: [
        {
          type: "link",
          attrs: {
            href: l,
            target: f ? "_blank" : ""
          }
        }
      ]
    }).setLink({ href: l }).focus().run(), n(!1);
  }, c = te(() => {
    e.chain().extendMarkRange("link").unsetLink().focus().run(), n(!1);
  }, [e]);
  return /* @__PURE__ */ s(de, { children: /* @__PURE__ */ s(
    at,
    {
      editor: e,
      shouldShow: o,
      tippyOptions: {
        popperOptions: {
          modifiers: [{ name: "flip", enabled: !1 }]
        },
        placement: "bottom-start",
        offset: [-2, 16],
        zIndex: 9999,
        onHidden: () => {
          n(!1);
        }
      },
      children: t ? /* @__PURE__ */ s(de, {}) : /* @__PURE__ */ s(de, { children: r ? /* @__PURE__ */ s(Ox, { onSetLink: a, editor: e }) : /* @__PURE__ */ s(
        Px,
        {
          editor: e,
          onClear: c,
          onEdit: () => {
            n(!0);
          },
          link: i
        }
      ) })
    }
  ) });
}
const Nx = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, wl = Vt.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", Ct(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      $s({
        find: Nx,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, r, n] = e;
          return { src: r, alt: t, title: n };
        }
      })
    ];
  }
}), Pr = Pe.Root, Rr = Pe.Trigger, Mx = Pe.Portal, Sl = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Pe.Overlay,
  {
    ref: r,
    className: X(
      "richtext-fixed richtext-inset-0 richtext-z-50 richtext-bg-black/80 richtext- data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[state=closed]:richtext-fade-out-0 data-[state=open]:richtext-fade-in-0",
      e
    ),
    ...t
  }
));
Sl.displayName = Pe.Overlay.displayName;
const Xt = Z.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ T(Mx, { children: [
  /* @__PURE__ */ s(Sl, {}),
  /* @__PURE__ */ T(
    Pe.Content,
    {
      ref: n,
      className: X(
        "richtext-dialog-content richtext-fixed richtext-left-[50%] richtext-top-[50%] richtext-z-50 richtext-grid richtext-w-full richtext-max-w-lg richtext-translate-x-[-50%] richtext-translate-y-[-50%] richtext-gap-4 richtext-border richtext-bg-background richtext-p-6 richtext-shadow-lg richtext-duration-200 data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[state=closed]:richtext-fade-out-0 data-[state=open]:richtext-fade-in-0 data-[state=closed]:richtext-zoom-out-95 data-[state=open]:richtext-zoom-in-95 data-[state=closed]:richtext-slide-out-to-left-1/2 data-[state=closed]:richtext-slide-out-to-top-[48%] data-[state=open]:richtext-slide-in-from-left-1/2 data-[state=open]:richtext-slide-in-from-top-[48%] sm:richtext-rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ T(Pe.Close, { className: "richtext-absolute richtext-right-4 richtext-top-4 richtext-rounded-sm richtext-opacity-70 richtext-ring-offset-background richtext-transition-opacity hover:richtext-opacity-100 focus:richtext-outline-none focus:richtext-ring-2 focus:richtext-ring-ring focus:richtext-ring-offset-2 disabled:richtext-pointer-events-none data-[state=open]:richtext-bg-accent data-[state=open]:richtext-text-muted-foreground", children: [
          /* @__PURE__ */ s(Rs, { className: "richtext-h-4 richtext-w-4" }),
          /* @__PURE__ */ s("span", { className: "richtext-sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Xt.displayName = Pe.Content.displayName;
function Al({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: X(
        "richtext-flex richtext-flex-col richtext-space-y-1.5 richtext-text-center sm:richtext-text-left",
        e
      ),
      ...t
    }
  );
}
Al.displayName = "DialogHeader";
function Ao({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: X(
        "richtext-flex richtext-flex-col-reverse sm:richtext-flex-row sm:richtext-justify-end sm:richtext-space-x-2",
        e
      ),
      ...t
    }
  );
}
Ao.displayName = "DialogFooter";
const Yt = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Pe.Title,
  {
    ref: r,
    className: X(
      "richtext-text-lg richtext-font-semibold richtext-leading-none richtext-tracking-tight",
      e
    ),
    ...t
  }
));
Yt.displayName = Pe.Title.displayName;
const Ex = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Pe.Description,
  {
    ref: r,
    className: X("richtext-text-sm richtext-text-muted-foreground", e),
    ...t
  }
));
Ex.displayName = Pe.Description.displayName;
const Ra = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Na = ao, Nr = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return Na(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const f = r == null ? void 0 : r[u], d = o == null ? void 0 : o[u];
    if (f === null) return null;
    const h = Ra(f) || Ra(d);
    return i[u][h];
  }), c = r && Object.entries(r).reduce((u, f) => {
    let [d, h] = f;
    return h === void 0 || (u[d] = h), u;
  }, {}), l = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, f) => {
    let { class: d, className: h, ...p } = f;
    return Object.entries(p).every((m) => {
      let [g, y] = m;
      return Array.isArray(y) ? y.includes({
        ...o,
        ...c
      }[g]) : {
        ...o,
        ...c
      }[g] === y;
    }) ? [
      ...u,
      d,
      h
    ] : u;
  }, []);
  return Na(e, a, l, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, $x = Nr(
  "richtext-inline-flex richtext-items-center richtext-justify-center richtext-whitespace-nowrap richtext-rounded-md richtext-text-sm richtext-font-medium richtext-ring-offset-background richtext-transition-colors focus-visible:richtext-outline-none focus-visible:richtext-ring-2 focus-visible:richtext-ring-ring focus-visible:richtext-ring-offset-2 disabled:richtext-pointer-events-none disabled:richtext-opacity-50",
  {
    variants: {
      variant: {
        default: "!richtext-bg-primary !richtext-text-primary-foreground hover:!richtext-bg-primary/90",
        destructive: "richtext-bg-destructive richtext-text-destructive-foreground hover:richtext-bg-destructive/90",
        outline: "richtext-border richtext-border-input richtext-bg-background hover:richtext-bg-accent hover:richtext-text-accent-foreground",
        secondary: "richtext-bg-secondary richtext-text-secondary-foreground hover:richtext-bg-secondary/80",
        ghost: "hover:richtext-bg-accent hover:richtext-text-accent-foreground",
        link: "richtext-text-primary richtext-underline-offset-4 hover:richtext-underline"
      },
      size: {
        default: "richtext-h-10 richtext-px-4 richtext-py-2",
        sm: "richtext-h-9 richtext-rounded-md richtext-px-3",
        lg: "richtext-h-11 richtext-rounded-md richtext-px-8",
        icon: "richtext-h-10 richtext-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), be = Z.forwardRef(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...i }, o) => /* @__PURE__ */ s(
    n ? Is : "button",
    {
      className: X($x({ variant: t, size: r, className: e })),
      ref: o,
      ...i
    }
  )
);
be.displayName = "Button";
function W0(e) {
  return e.replace(/^.*\/|\..+$/g, "");
}
function G0(e) {
  return e.split(".").pop();
}
function V0(e) {
  return e < 1024 ? `${e} Byte` : e < 1024 * 1024 ? `${(e / 1024).toFixed(2)} KB` : `${(e / 1024 / 1024).toFixed(2)} MB`;
}
function X0(e) {
  return e ? e === "application/pdf" ? "pdf" : e.startsWith("application/") && [".document", "word"].some((t) => e.includes(t)) ? "word" : e.startsWith("application/") && ["presentation"].some((t) => e.includes(t)) ? "excel" : e.startsWith("application/") && ["sheet"].some((t) => e.includes(t)) ? "ppt" : e.startsWith("image") ? "image" : e.startsWith("audio") ? "audio" : e.startsWith("video") ? "video" : "file" : "file";
}
function kx(e) {
  return new Promise((t) => {
    const r = new FileReader();
    r.addEventListener(
      "load",
      () => {
        t({
          alt: e.name,
          src: r.result
        });
      },
      !1
    ), r.readAsDataURL(e);
  });
}
function _x(e, t) {
  const r = e.split(","), n = r[0].match(/:(.*?);/)[1], i = atob(r[r.length - 1]);
  let o = i.length;
  const a = new Uint8Array(o);
  for (; o--; )
    a[o] = i.charCodeAt(o);
  return new File([a], t, { type: n });
}
function Lx({ editor: e, imageInline: t, onClose: r }) {
  const { t: n } = me(), [i, o] = Y(!1), a = ur.useRef(null), [c, l] = ur.useState(), [u, f] = ur.useState(""), d = We(null), [h, p] = Y({
    src: "",
    file: null
  });
  function m(b) {
    if (a.current && b.width && b.height) {
      const A = g(a.current, b);
      f(A);
    }
  }
  function g(b, A) {
    const R = document.createElement("canvas"), M = b.naturalWidth / b.width, E = b.naturalHeight / b.height;
    R.width = A.width * M, R.height = A.height * E;
    const O = R.getContext("2d");
    return O && (O.imageSmoothingEnabled = !1, O.drawImage(
      b,
      A.x * M,
      A.y * E,
      A.width * M,
      A.height * E,
      0,
      0,
      A.width * M,
      A.height * E
    )), R.toDataURL("image/png", 1);
  }
  async function y() {
    var b, A;
    try {
      const R = _x(u, ((b = h == null ? void 0 : h.file) == null ? void 0 : b.name) || "image.png"), M = (A = e.extensionManager.extensions.find(
        (O) => O.name === qt.name
      )) == null ? void 0 : A.options;
      let E = "";
      M.upload ? E = await M.upload(R) : E = URL.createObjectURL(R), e.chain().focus().setImageInline({ src: E, inline: t }).run(), o(!1), p({
        src: "",
        file: null
      }), r();
    } catch (R) {
      console.log("Error cropping image", R);
    }
  }
  function w(b) {
    var A;
    b.preventDefault(), (A = d.current) == null || A.click();
  }
  const S = async (b) => {
    var E;
    const A = (E = b == null ? void 0 : b.target) == null ? void 0 : E.files;
    if (!e || e.isDestroyed || A.length === 0)
      return;
    const R = A[0], M = await kx(R);
    o(!0), p({
      src: M.src,
      file: R
    });
  };
  return /* @__PURE__ */ T(de, { children: [
    /* @__PURE__ */ s(
      be,
      {
        className: "richtext-mt-1 richtext-w-full",
        onClick: w,
        size: "sm",
        children: n("editor.image.dialog.tab.uploadCrop")
      }
    ),
    /* @__PURE__ */ T(Pr, { open: i, children: [
      /* @__PURE__ */ s(Rr, {}),
      /* @__PURE__ */ T(Xt, { children: [
        /* @__PURE__ */ s(Yt, { children: n("editor.image.dialog.tab.uploadCrop") }),
        /* @__PURE__ */ s("div", { children: h.src && /* @__PURE__ */ s(
          gf,
          {
            className: "richtext-w-full",
            crop: c,
            onChange: (b) => l(b),
            onComplete: (b) => m(b),
            children: /* @__PURE__ */ s(
              "img",
              {
                alt: "Crop me",
                ref: a,
                src: h.src
              }
            )
          }
        ) }),
        /* @__PURE__ */ T(Ao, { children: [
          /* @__PURE__ */ T(
            be,
            {
              onClick: () => {
                o(!1), p({
                  src: "",
                  file: null
                });
              },
              children: [
                n("editor.imageUpload.cancel"),
                /* @__PURE__ */ s(
                  xe,
                  {
                    className: "richtext-ml-[4px]",
                    name: "Trash2"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ T(
            be,
            {
              className: "richtext-w-fit",
              onClick: y,
              children: [
                n("editor.imageUpload.crop"),
                /* @__PURE__ */ s(
                  xe,
                  {
                    className: "richtext-ml-[4px]",
                    name: "Crop"
                  }
                )
              ]
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s(
      "input",
      {
        accept: "image/*",
        multiple: !0,
        onChange: S,
        ref: d,
        type: "file",
        style: {
          display: "none"
        }
      }
    )
  ] });
}
function Mr(e) {
  function t() {
    const o = We(e), a = te(() => o.current, []), c = We(/* @__PURE__ */ new Set()), l = te((f) => {
      o.current = { ...o.current, ...f }, c.current.forEach((d) => d());
    }, []), u = te((f) => (c.current.add(f), () => c.current.delete(f)), []);
    return {
      get: a,
      set: l,
      subscribe: u
    };
  }
  const r = Su(null);
  function n({ children: o }) {
    return /* @__PURE__ */ s(r.Provider, { value: t(), children: o });
  }
  function i(o) {
    const a = Au(r);
    if (!a)
      throw new Error("Store not found");
    return [Cu(
      a.subscribe,
      () => o(a.get()),
      () => o(e)
    ), a.set];
  }
  return {
    Provider: n,
    useStore: i
  };
}
Mr({
  value: !1
});
Mr({
  value: !1
});
const { Provider: Dx, useStore: Cl } = Mr({
  value: !1
}), { Provider: Bx, useStore: Il } = Mr({
  value: "light"
});
ku("0");
function br(e, t) {
  return window.addEventListener(e, t), () => {
    window.removeEventListener(e, t);
  };
}
function Co(e, t) {
  window.dispatchEvent(
    new CustomEvent(e, {
      detail: t
    })
  );
}
const ut = {
  UPLOAD_IMAGE: (e) => `UPLOAD_IMAGE-${e}`,
  UPLOAD_VIDEO: (e) => `UPLOAD_VIDEO-${e}`,
  EDIT: (e) => `EDIT-${e}`,
  UPDATE_THEME: (e) => `UPDATE_THEME-${e}`,
  SEARCH_REPLCE: "SEARCH_REPLACE"
}, zx = {
  setOpen: (e, t) => {
    Co(ut.UPLOAD_IMAGE(e), t);
  }
};
function jx(e) {
  var m;
  const { t } = me(), [r, n] = Y(!1), i = (g) => {
    n(g.detail);
  }, [o, a] = Y(""), c = We(null), [l, u] = Y(((m = e.editor.extensionManager.extensions.find(
    (g) => g.name === qt.name
  )) == null ? void 0 : m.options.defaultInline) || !1), f = ye(() => {
    var y;
    return (y = e.editor.extensionManager.extensions.find(
      (w) => w.name === qt.name
    )) == null ? void 0 : y.options;
  }, [e.editor]);
  le(() => {
    const g = br(ut.UPLOAD_IMAGE(e.editor.id), i);
    return () => {
      g();
    };
  }, []);
  async function d(g) {
    var b;
    const y = (b = g == null ? void 0 : g.target) == null ? void 0 : b.files;
    if (!e.editor || e.editor.isDestroyed || y.length === 0)
      return;
    const w = y[0];
    let S = "";
    f.upload ? S = await f.upload(w) : S = URL.createObjectURL(w), e.editor.chain().focus().setImageInline({ src: S, inline: l }).run(), n(!1), u(!1);
  }
  function h(g) {
    g.preventDefault(), g.stopPropagation(), e.editor.chain().focus().setImageInline({ src: o, inline: l }).run(), n(!1), u(!1), a("");
  }
  function p(g) {
    var y;
    g.preventDefault(), (y = c.current) == null || y.click();
  }
  return /* @__PURE__ */ T(
    Pr,
    {
      onOpenChange: n,
      open: r,
      children: [
        /* @__PURE__ */ s(Rr, { asChild: !0, children: /* @__PURE__ */ s(
          q,
          {
            action: () => n(!0),
            icon: e.icon,
            tooltip: e.tooltip
          }
        ) }),
        /* @__PURE__ */ T(Xt, { children: [
          /* @__PURE__ */ s(Yt, { children: t("editor.image.dialog.title") }),
          /* @__PURE__ */ T(
            $l,
            {
              activationMode: "manual",
              defaultValue: f.resourceImage === "both" || f.resourceImage === "upload" ? "upload" : "link",
              children: [
                /* @__PURE__ */ T(Oo, { className: "richtext-grid richtext-w-full richtext-grid-cols-2", children: [
                  f.resourceImage === "both" || f.resourceImage === "upload" ? /* @__PURE__ */ s(Ft, { value: "upload", children: t("editor.image.dialog.tab.upload") }) : /* @__PURE__ */ s(de, {}),
                  f.resourceImage === "both" || f.resourceImage === "link" ? /* @__PURE__ */ s(Ft, { value: "link", children: t("editor.image.dialog.tab.url") }) : /* @__PURE__ */ s(de, {})
                ] }),
                /* @__PURE__ */ T("div", { className: "richtext-my-[10px] richtext-flex richtext-items-center richtext-gap-[4px]", children: [
                  /* @__PURE__ */ s(
                    Fl,
                    {
                      checked: l,
                      onCheckedChange: (g) => {
                        u(g);
                      }
                    }
                  ),
                  /* @__PURE__ */ s(it, { children: t("editor.link.dialog.inline") })
                ] }),
                /* @__PURE__ */ T(Ht, { value: "upload", children: [
                  /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-gap-[10px]", children: [
                    /* @__PURE__ */ s(
                      be,
                      {
                        className: "richtext-mt-1 richtext-w-full",
                        onClick: p,
                        size: "sm",
                        children: t("editor.image.dialog.tab.upload")
                      }
                    ),
                    /* @__PURE__ */ s(
                      Lx,
                      {
                        editor: e.editor,
                        imageInline: l,
                        onClose: () => zx.setOpen(e.editor.id, !1)
                      }
                    )
                  ] }),
                  /* @__PURE__ */ s(
                    "input",
                    {
                      accept: "image/*",
                      multiple: !0,
                      onChange: d,
                      ref: c,
                      type: "file",
                      style: {
                        display: "none"
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ s(Ht, { value: "link", children: /* @__PURE__ */ s("form", { onSubmit: h, children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-gap-2", children: [
                  /* @__PURE__ */ s(
                    Oe,
                    {
                      autoFocus: !0,
                      onChange: (g) => a(g.target.value),
                      placeholder: t("editor.image.dialog.placeholder"),
                      required: !0,
                      type: "url",
                      value: o
                    }
                  ),
                  /* @__PURE__ */ s(be, { type: "submit", children: t("editor.image.dialog.button.apply") })
                ] }) }) })
              ]
            }
          )
        ] })
      ]
    }
  );
}
const or = {
  TOP_LEFT: "tl",
  TOP_RIGHT: "tr",
  BOTTOM_LEFT: "bl",
  BOTTOM_RIGHT: "br"
};
function qx(e) {
  var E, O;
  const [t, r] = Y({
    width: pr,
    height: pr
  }), [n, i] = Y({
    width: 0,
    height: 0
  }), [o] = Y([
    or.TOP_LEFT,
    or.TOP_RIGHT,
    or.BOTTOM_LEFT,
    or.BOTTOM_RIGHT
  ]), [a, c] = Y(!1), [l, u] = Y({
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    dir: ""
  }), { align: f, inline: d } = (E = e == null ? void 0 : e.node) == null ? void 0 : E.attrs, h = ye(() => {
    var J;
    const { src: C, alt: k, width: P, height: N, flipX: L, flipY: _ } = (J = e == null ? void 0 : e.node) == null ? void 0 : J.attrs, G = yr(P) ? `${P}px` : P, ee = yr(N) ? `${N}px` : N, se = [];
    L && se.push("rotateX(180deg)"), _ && se.push("rotateY(180deg)");
    const re = se.join(" ");
    return {
      src: C || void 0,
      alt: k || void 0,
      style: {
        width: G || void 0,
        height: ee || void 0,
        transform: re || "none"
      }
    };
  }, [(O = e == null ? void 0 : e.node) == null ? void 0 : O.attrs]), p = ye(() => {
    const {
      style: { width: C }
    } = h;
    return { width: C === "100%" ? C : void 0 };
  }, [h]);
  function m(C) {
    i({
      width: C.target.width,
      height: C.target.height
    });
  }
  function g() {
    const { editor: C, getPos: k } = e;
    C.commands.setNodeSelection(k());
  }
  const y = te(
    jt(() => {
      const { editor: C } = e, { width: k } = getComputedStyle(C.view.dom);
      r((P) => ({
        ...P,
        width: Number.parseInt(k, 10)
      }));
    }, mr),
    [e == null ? void 0 : e.editor]
  );
  function w(C, k) {
    C.preventDefault(), C.stopPropagation();
    const P = n.width, N = n.height, L = P / N;
    let _ = Number(e.node.attrs.width), G = Number(e.node.attrs.height);
    const ee = t.width;
    _ && !G ? (_ = _ > ee ? ee : _, G = Math.round(_ / L)) : G && !_ ? (_ = Math.round(G * L), _ = _ > ee ? ee : _) : !_ && !G ? (_ = P > ee ? ee : P, G = Math.round(_ / L)) : _ = _ > ee ? ee : _, c(!0), u({
      x: C.clientX,
      y: C.clientY,
      w: _,
      h: G,
      dir: k
    });
  }
  const S = te(
    jt((C) => {
      if (C.preventDefault(), C.stopPropagation(), !a)
        return;
      const { x: k, w: P, dir: N } = l, L = (C.clientX - k) * (/l/.test(N) ? -1 : 1), _ = tl(P + L, Ts, t.width);
      e.updateAttributes({
        width: _,
        height: null
      });
    }, mr),
    [a, l, t, e.updateAttributes]
  ), b = te(
    (C) => {
      C.preventDefault(), C.stopPropagation(), a && (u({
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        dir: ""
      }), c(!1), g());
    },
    [a, g]
  ), A = te(() => {
    document == null || document.addEventListener("mousemove", S, !0), document == null || document.addEventListener("mouseup", b, !0);
  }, [S, b]), R = te(() => {
    document == null || document.removeEventListener("mousemove", S, !0), document == null || document.removeEventListener("mouseup", b, !0);
  }, [S, b]);
  le(() => (a ? A() : R(), () => {
    R();
  }), [a, A, R]);
  const M = ye(() => new ResizeObserver(() => y()), [y]);
  return le(() => (M.observe(e.editor.view.dom), () => {
    M.disconnect();
  }), [e.editor.view.dom, M]), /* @__PURE__ */ s(
    co,
    {
      as: d ? "span" : "div",
      className: "image-view",
      style: { ...p, textAlign: f, display: d ? "inline" : "block" },
      children: /* @__PURE__ */ T(
        "div",
        {
          "data-drag-handle": !0,
          draggable: "true",
          style: p,
          className: `image-view__body ${e != null && e.selected ? "image-view__body--focused" : ""} ${a ? "image-view__body--resizing" : ""}`,
          children: [
            /* @__PURE__ */ s(
              "img",
              {
                alt: h.alt,
                className: "image-view__body__image block",
                height: "auto",
                onClick: g,
                onLoad: m,
                src: h.src,
                style: h.style
              }
            ),
            (e == null ? void 0 : e.editor.view.editable) && ((e == null ? void 0 : e.selected) || a) && /* @__PURE__ */ s("div", { className: "image-resizer", children: o == null ? void 0 : o.map((C) => /* @__PURE__ */ s(
              "span",
              {
                className: `image-resizer__handler image-resizer__handler--${C}`,
                onMouseDown: (k) => w(k, C)
              },
              `image-dir-${C}`
            )) })
          ]
        }
      )
    }
  );
}
const At = new lo("upload-image");
function Fx() {
  return new uo({
    key: At,
    state: {
      init() {
        return ff.empty;
      },
      apply(e, t) {
        t = t.map(e.mapping, e.doc);
        const r = e.getMeta(At);
        if (r != null && r.add)
          for (const { id: n, pos: i, src: o } of r.add) {
            const a = Hx(o), c = df.widget(i, a, { id: n });
            t = t.add(e.doc, [c]);
          }
        else if (r != null && r.remove)
          for (const n of r.remove)
            t = t.remove(t.find(void 0, void 0, (i) => i.id === n));
        return t;
      }
    },
    props: {
      decorations(e) {
        return this.getState(e);
      }
    }
  });
}
function Hx(e) {
  const t = document.createElement("div"), r = document.createElement("img");
  return r.setAttribute("class", "opacity-50"), r.src = e, r.addEventListener("load", () => {
    t.setAttribute("class", "img-placeholder");
  }), t.append(r), t;
}
function Ux(e, t) {
  var i;
  const n = At.getState(e).find(void 0, void 0, (o) => o.id === t);
  return n.length > 0 ? (i = n[0]) == null ? void 0 : i.from : null;
}
function Wx({ validateFn: e, onUpload: t, postUpload: r, defaultInline: n = !1 }) {
  return (i, o, a) => {
    for (const c of i) {
      if (e && !e(c))
        continue;
      const l = Date.now().toString(), u = o.state.tr;
      u.selection.empty || u.deleteSelection();
      const f = URL.createObjectURL(c);
      u.setMeta(At, {
        add: [{ id: l, pos: a, src: f }]
      }), o.dispatch(u), t(c).then(
        async (d) => {
          var S;
          r && typeof d == "string" && (d = await r(d));
          const { schema: h } = o.state;
          let p = Ux(o.state, l);
          if (p === null)
            return;
          const m = typeof d == "object" ? f : d, g = (S = h.nodes.image) == null ? void 0 : S.create({
            src: m,
            inline: n
          });
          if (!g)
            return;
          const { doc: y } = o.state;
          p > y.content.size && (p = y.content.size - 1);
          const w = o.state.tr.replaceWith(p, p, g).setMeta(At, { remove: [l] });
          o.dispatch(w);
        },
        () => {
          const d = o.state.tr.delete(a, a).setMeta(At, { remove: [l] });
          o.dispatch(d);
        }
      );
    }
  };
}
function Gx(e, t, r) {
  var i;
  const n = [...((i = t.clipboardData) == null ? void 0 : i.files) || []];
  if (n.length > 0) {
    t.preventDefault();
    const o = e.state.selection.from;
    return r(n, e, o + 1), !0;
  }
  return !1;
}
function Vx(e, t, r, n) {
  var o;
  const i = [...((o = t.dataTransfer) == null ? void 0 : o.files) || []];
  if (!r && i.length > 0) {
    t.preventDefault();
    const a = e.posAtCoords({
      left: t.clientX,
      top: t.clientY
    });
    if (a)
      return n(i, e, a.pos + 1), !0;
  }
  return !1;
}
const Xx = {
  acceptMimes: ["image/jpeg", "image/gif", "image/png", "image/jpg"],
  maxSize: 1024 * 1024 * 5,
  // 5MB
  resourceImage: "both",
  defaultInline: !1
}, qt = /* @__PURE__ */ wl.extend({
  group: "inline",
  inline: !0,
  defining: !0,
  draggable: !0,
  selectable: !0,
  addOptions() {
    var e;
    return {
      ...Xx,
      ...(e = this.parent) == null ? void 0 : e.call(this),
      upload: () => Promise.reject("Image Upload Function"),
      button: ({
        editor: t,
        extension: r,
        t: n
      }) => {
        var i, o;
        return {
          component: jx,
          componentProps: {
            action: () => !0,
            upload: r.options.upload,
            /* If setImage is not available(when Image Component is not imported), the button is disabled */
            disabled: !((o = (i = t.can()).setImage) != null && o.call(i, {})),
            icon: "ImageUp",
            tooltip: n("editor.image.tooltip"),
            editor: t
          }
        };
      }
    };
  },
  addAttributes() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      flipX: {
        default: !1
      },
      flipY: {
        default: !1
      },
      width: {
        default: null,
        parseHTML: (t) => {
          const r = t.style.width || t.getAttribute("width") || null;
          return r ? Number.parseInt(r, 10) : null;
        },
        renderHTML: (t) => ({
          width: t.width
        })
      },
      align: {
        default: "center",
        parseHTML: (t) => t.getAttribute("align"),
        renderHTML: (t) => ({
          align: t.align
        })
      },
      inline: {
        default: !1,
        parseHTML: (t) => !!t.getAttribute("inline"),
        renderHTML: (t) => ({
          inline: t.inline
        })
      }
    };
  },
  addNodeView() {
    return so(qx);
  },
  addCommands() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      setImageInline: (t) => ({ commands: r }) => r.insertContent({
        type: this.name,
        attrs: {
          ...t,
          inline: t.inline ?? this.options.defaultInline
        }
      }),
      updateImage: (t) => ({ commands: r }) => r.updateAttributes(this.name, t),
      setAlignImage: (t) => ({ commands: r }) => r.updateAttributes(this.name, { align: t })
    };
  },
  renderHTML({ HTMLAttributes: e }) {
    const { flipX: t, flipY: r, align: n, inline: i } = e, o = t || r ? `transform: rotateX(${t ? "180" : "0"}deg) rotateY(${r ? "180" : "0"}deg);` : "", a = n ? `text-align: ${n};` : "";
    return [
      i ? "span" : "div",
      {
        style: a,
        class: "image"
      },
      [
        "img",
        Ct(
          {
            height: "auto",
            style: o
          },
          this.options.HTMLAttributes,
          e
        )
      ]
    ];
  },
  parseHTML() {
    return [
      {
        tag: "span.image img",
        getAttrs: (e) => {
          var o;
          const t = e == null ? void 0 : e.parentElement, r = e == null ? void 0 : e.getAttribute("width"), n = (e == null ? void 0 : e.getAttribute("flipx")) || !1, i = (e == null ? void 0 : e.getAttribute("flipy")) || !1;
          return {
            src: e == null ? void 0 : e.getAttribute("src"),
            alt: e == null ? void 0 : e.getAttribute("alt"),
            caption: e == null ? void 0 : e.getAttribute("caption"),
            width: r ? Number.parseInt(r, 10) : null,
            align: (e == null ? void 0 : e.getAttribute("align")) || ((o = t == null ? void 0 : t.style) == null ? void 0 : o.textAlign) || null,
            inline: (e == null ? void 0 : e.getAttribute("inline")) || !1,
            flipX: n === "true",
            flipY: i === "true"
          };
        }
      },
      {
        tag: "div[class=image]",
        getAttrs: (e) => {
          const t = e.querySelector("img"), r = t == null ? void 0 : t.getAttribute("width"), n = (t == null ? void 0 : t.getAttribute("flipx")) || !1, i = (t == null ? void 0 : t.getAttribute("flipy")) || !1;
          return {
            src: t == null ? void 0 : t.getAttribute("src"),
            alt: t == null ? void 0 : t.getAttribute("alt"),
            caption: t == null ? void 0 : t.getAttribute("caption"),
            width: r ? Number.parseInt(r, 10) : null,
            align: (t == null ? void 0 : t.getAttribute("align")) || e.style.textAlign || null,
            inline: (t == null ? void 0 : t.getAttribute("inline")) || !1,
            flipX: n === "true",
            flipY: i === "true"
          };
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    const t = Wx({
      validateFn: (r) => !(!this.options.acceptMimes.includes(r.type) || r.size > this.options.maxSize),
      onUpload: this.options.upload,
      // postUpload: this.options.postUpload,
      defaultInline: this.options.defaultInline
    });
    return [
      new uo({
        props: {
          handlePaste: (r, n) => !n.clipboardData || [...n.clipboardData.files || []].some((o) => o.type === "text/html") ? !1 : Gx(r, n, t),
          handleDrop: (r, n, i, o) => (!(n instanceof DragEvent) || !n.dataTransfer || Vx(r, n, o, t), !1)
        }
      }),
      Fx()
    ];
  }
});
function Yx({ selectImage: e, giphyApiKey: t, children: r }) {
  const [n, i] = Y([]), [o] = Y(15), a = We(null), c = (u, f = "search") => {
    if (!t)
      return;
    const h = `${f === "search" ? `https://api.giphy.com/v1/gifs/search?q=${u}` : `https://api.giphy.com/v1/gifs/trending?q=${u}`}&limit=${o}&api_key=${t}`;
    fetch(h).then((p) => p.json()).then((p) => {
      i(p.data);
    }).catch((p) => {
      console.log(p);
    });
  };
  le(() => {
    c("", "trend");
  }, []);
  const l = te(
    Or((u) => {
      if (!u.target.value) {
        c("", "trend");
        return;
      }
      c(u.target.value);
    }, 350),
    // Adjust the debounce delay as needed
    []
  );
  return /* @__PURE__ */ T(Er, { modal: !0, children: [
    /* @__PURE__ */ s($r, { asChild: !0, children: r }),
    /* @__PURE__ */ s(
      Kt,
      {
        align: "start",
        className: "richtext-size-full richtext-p-2",
        hideWhenDetached: !0,
        side: "bottom",
        children: t ? /* @__PURE__ */ T(de, { children: [
          /* @__PURE__ */ s("div", { className: "richtext-mb-[10px] richtext-w-full", children: /* @__PURE__ */ s(
            Oe,
            {
              onChange: l,
              placeholder: "Search GIF",
              ref: a,
              type: "text"
            }
          ) }),
          /* @__PURE__ */ s("div", { className: "richtext-max-h-[280px] richtext-overflow-y-auto", children: /* @__PURE__ */ s("div", { className: "richtext-grid richtext-grid-cols-2 richtext-gap-1 ", children: n != null && n.length ? n == null ? void 0 : n.map((u) => /* @__PURE__ */ s(
            "img",
            {
              alt: "giphy",
              className: "richtext-cursor-pointer richtext-text-center",
              height: u.images.fixed_width_downsampled.height,
              onClick: () => e(u),
              src: u.images.fixed_width_downsampled.url,
              width: u.images.fixed_width_downsampled.width
            },
            `giphy-${u.id}`
          )) : /* @__PURE__ */ s("p", { children: "No GIFs found" }) }) })
        ] }) : /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s("p", { children: "Missing Giphy API Key" }) })
      }
    )
  ] });
}
function Kx({ editor: e, icon: t, giphyApiKey: r, ...n }) {
  return /* @__PURE__ */ s(
    Yx,
    {
      giphyApiKey: r,
      selectImage: (o) => {
        const { url: a } = o.images.original;
        e.chain().focus().setImageGif({ src: a }).run();
      },
      children: /* @__PURE__ */ s(
        q,
        {
          icon: t,
          tooltip: n == null ? void 0 : n.tooltip
        }
      )
    }
  );
}
const ar = {
  TOP_LEFT: "tl",
  TOP_RIGHT: "tr",
  BOTTOM_LEFT: "bl",
  BOTTOM_RIGHT: "br"
};
function Jx(e) {
  var M, E;
  const [t, r] = Y({
    width: pr,
    height: pr
  }), [n, i] = Y({
    width: 0,
    height: 0
  }), [o] = Y([
    ar.TOP_LEFT,
    ar.TOP_RIGHT,
    ar.BOTTOM_LEFT,
    ar.BOTTOM_RIGHT
  ]), [a, c] = Y(!1), [l, u] = Y({
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    dir: ""
  }), { align: f } = (M = e == null ? void 0 : e.node) == null ? void 0 : M.attrs, d = ye(() => {
    var _;
    const { src: O, alt: C, width: k, height: P } = (_ = e == null ? void 0 : e.node) == null ? void 0 : _.attrs, N = yr(k) ? `${k}px` : k, L = yr(P) ? `${P}px` : P;
    return {
      src: O || void 0,
      alt: C || void 0,
      style: {
        width: N || void 0,
        height: L || void 0
      }
    };
  }, [(E = e == null ? void 0 : e.node) == null ? void 0 : E.attrs]), h = ye(() => {
    const {
      style: { width: O }
    } = d;
    return { width: O === "100%" ? O : void 0 };
  }, [d]);
  function p(O) {
    i({
      width: O.target.width,
      height: O.target.height
    });
  }
  function m() {
    const { editor: O, getPos: C } = e;
    O.commands.setNodeSelection(C());
  }
  const g = te(
    jt(() => {
      const { editor: O } = e, { width: C } = getComputedStyle(O.view.dom);
      r((k) => ({
        ...k,
        width: Number.parseInt(C, 10)
      }));
    }, mr),
    [e == null ? void 0 : e.editor]
  );
  function y(O, C) {
    O.preventDefault(), O.stopPropagation();
    const k = n.width, P = n.height, N = k / P;
    let L = Number(e.node.attrs.width), _ = Number(e.node.attrs.height);
    const G = t.width;
    L && !_ ? (L = L > G ? G : L, _ = Math.round(L / N)) : _ && !L ? (L = Math.round(_ * N), L = L > G ? G : L) : !L && !_ ? (L = k > G ? G : k, _ = Math.round(L / N)) : L = L > G ? G : L, c(!0), u({
      x: O.clientX,
      y: O.clientY,
      w: L,
      h: _,
      dir: C
    });
  }
  const w = te(
    jt((O) => {
      if (O.preventDefault(), O.stopPropagation(), !a)
        return;
      const { x: C, w: k, dir: P } = l, N = (O.clientX - C) * (/l/.test(P) ? -1 : 1), L = tl(k + N, Ts, t.width);
      e.updateAttributes({
        width: L,
        height: null
      });
    }, mr),
    [a, l, t, e.updateAttributes]
  ), S = te(
    (O) => {
      O.preventDefault(), O.stopPropagation(), a && (u({
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        dir: ""
      }), c(!1), m());
    },
    [a, m]
  ), b = te(() => {
    document == null || document.addEventListener("mousemove", w, !0), document == null || document.addEventListener("mouseup", S, !0);
  }, [w, S]), A = te(() => {
    document == null || document.removeEventListener("mousemove", w, !0), document == null || document.removeEventListener("mouseup", S, !0);
  }, [w, S]);
  le(() => (a ? b() : A(), () => {
    A();
  }), [a, b, A]);
  const R = ye(() => new ResizeObserver(() => g()), [g]);
  return le(() => (R.observe(e.editor.view.dom), () => {
    R.disconnect();
  }), [e.editor.view.dom, R]), /* @__PURE__ */ s(
    co,
    {
      className: "image-view",
      style: { ...h, width: "100%", textAlign: f },
      children: /* @__PURE__ */ T(
        "div",
        {
          "data-drag-handle": !0,
          draggable: "true",
          style: h,
          className: `image-view__body ${e != null && e.selected ? "image-view__body--focused" : ""} ${a ? "image-view__body--resizing" : ""}`,
          children: [
            /* @__PURE__ */ s(
              "img",
              {
                alt: d.alt,
                className: "image-view__body__image block",
                height: "auto",
                onClick: m,
                onLoad: p,
                src: d.src,
                style: d.style
              }
            ),
            (e == null ? void 0 : e.editor.view.editable) && ((e == null ? void 0 : e.selected) || a) && /* @__PURE__ */ s("div", { className: "image-resizer", children: o == null ? void 0 : o.map((O) => /* @__PURE__ */ s(
              "span",
              {
                className: `image-resizer__handler image-resizer__handler--${O}`,
                onMouseDown: (C) => y(C, O)
              },
              `image-dir-${O}`
            )) })
          ]
        }
      )
    }
  );
}
const Tl = /* @__PURE__ */ wl.extend({
  name: "imageGif",
  addOptions() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      inline: !1,
      content: "",
      marks: "",
      group: "block",
      GIPHY_API_KEY: "",
      draggable: !1,
      selectable: !0,
      atom: !0,
      button: ({ editor: t, extension: r, t: n }) => {
        var o;
        const i = ((o = r == null ? void 0 : r.options) == null ? void 0 : o.GIPHY_API_KEY) || "";
        return {
          component: Kx,
          componentProps: {
            editor: t,
            action: () => {
            },
            isActive: () => !1,
            disabled: !1,
            icon: "GifIcon",
            tooltip: n("editor.imageGif.tooltip"),
            giphyApiKey: i
          }
        };
      }
    };
  },
  addAttributes() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      width: {
        default: null,
        parseHTML: (t) => {
          const r = t.style.width || t.getAttribute("width") || "10";
          return r === void 0 ? null : Number.parseInt(`${r}`, 10);
        },
        renderHTML: (t) => ({
          width: t.width
        })
      },
      align: {
        default: "center",
        parseHTML: (t) => t.getAttribute("align"),
        renderHTML: (t) => ({
          align: t.align
        })
      }
    };
  },
  addNodeView() {
    return so(Jx);
  },
  addCommands() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      setImageGif: (t) => ({ commands: r }) => r.insertContent({
        type: this.name,
        attrs: t
      }),
      updateImageGif: (t) => ({ commands: r }) => r.updateAttributes(this.name, t),
      setAlignImageGif: (t) => ({ commands: r }) => r.updateAttributes(this.name, { align: t })
    };
  },
  renderHTML({ HTMLAttributes: e }) {
    const { align: t } = e;
    return [
      "div",
      // Parent element
      {
        style: t ? `text-align: ${t};` : "",
        class: "imageGIf"
      },
      [
        "img",
        Ct(
          // Always render the `height="auto"`
          {
            height: "auto"
          },
          this.options.HTMLAttributes,
          e
        )
      ]
    ];
  },
  parseHTML() {
    return [
      {
        tag: "div[class=imageGIf]",
        getAttrs: (e) => {
          const t = e.querySelector("img"), r = t == null ? void 0 : t.getAttribute("width");
          return {
            src: t == null ? void 0 : t.getAttribute("src"),
            alt: t == null ? void 0 : t.getAttribute("alt"),
            title: t == null ? void 0 : t.getAttribute("title"),
            width: r ? Number.parseInt(r, 10) : null,
            align: (t == null ? void 0 : t.getAttribute("align")) || e.style.textAlign || null
          };
        }
      }
    ];
  }
});
function Zx(e) {
  return /\.(?:mp4|webm|ogg|mov)$/i.test(e);
}
function Qx(e) {
  const { t } = me(), [r, n] = Y(""), i = We(null), [o, a] = Y(""), [c, l] = Y(!1), u = (m) => {
    l(m.detail);
  };
  le(() => {
    const m = br(ut.UPLOAD_VIDEO(e.editor.id), u);
    return () => {
      m();
    };
  }, []);
  const f = ye(() => {
    var g;
    return (g = e.editor.extensionManager.extensions.find(
      (y) => y.name === Ol.name
    )) == null ? void 0 : g.options;
  }, [e.editor]);
  async function d(m) {
    var S;
    const g = (S = m == null ? void 0 : m.target) == null ? void 0 : S.files;
    if (!e.editor || e.editor.isDestroyed || g.length === 0)
      return;
    const y = g[0];
    let w = "";
    f.upload ? w = await f.upload(y) : w = URL.createObjectURL(y), e.editor.chain().focus().setVideo({
      src: w,
      width: "100%"
    }).run(), l(!1);
  }
  function h(m) {
    m.preventDefault(), m.stopPropagation(), r && (e.editor.chain().focus().setVideo({
      src: r,
      width: "100%"
    }).run(), l(!1));
  }
  function p(m) {
    var g;
    m.preventDefault(), (g = i.current) == null || g.click();
  }
  return /* @__PURE__ */ T(
    Pr,
    {
      onOpenChange: l,
      open: c,
      children: [
        /* @__PURE__ */ s(Rr, { asChild: !0, children: /* @__PURE__ */ s(
          q,
          {
            action: () => l(!0),
            icon: e.icon,
            tooltip: e.tooltip
          }
        ) }),
        /* @__PURE__ */ T(Xt, { children: [
          /* @__PURE__ */ s(Yt, { children: t("editor.video.dialog.title") }),
          /* @__PURE__ */ T(
            $l,
            {
              activationMode: "manual",
              defaultValue: (f == null ? void 0 : f.resourceVideo) === "both" || (f == null ? void 0 : f.resourceVideo) === "upload" ? "upload" : "link",
              children: [
                /* @__PURE__ */ T(Oo, { className: "richtext-grid richtext-w-full richtext-grid-cols-2", children: [
                  ((f == null ? void 0 : f.resourceVideo) === "both" || (f == null ? void 0 : f.resourceVideo) === "upload") && /* @__PURE__ */ s(Ft, { value: "upload", children: t("editor.video.dialog.tab.upload") }),
                  ((f == null ? void 0 : f.resourceVideo) === "both" || (f == null ? void 0 : f.resourceVideo) === "link") && /* @__PURE__ */ s(Ft, { value: "link", children: t("editor.video.dialog.link") })
                ] }),
                /* @__PURE__ */ T(Ht, { value: "upload", children: [
                  /* @__PURE__ */ s("div", { className: "richtext-flex richtext-items-center richtext-gap-[10px]", children: /* @__PURE__ */ s(
                    be,
                    {
                      className: "richtext-mt-1 richtext-w-full",
                      onClick: p,
                      size: "sm",
                      children: t("editor.video.dialog.tab.upload")
                    }
                  ) }),
                  /* @__PURE__ */ s(
                    "input",
                    {
                      accept: "video/*",
                      multiple: !0,
                      onChange: d,
                      ref: i,
                      type: "file",
                      style: {
                        display: "none"
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ T(Ht, { value: "link", children: [
                  /* @__PURE__ */ s("form", { onSubmit: h, children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center richtext-gap-2", children: [
                    /* @__PURE__ */ s(
                      Oe,
                      {
                        autoFocus: !0,
                        placeholder: t("editor.video.dialog.placeholder"),
                        required: !0,
                        type: "url",
                        value: r,
                        onChange: (m) => {
                          const g = m.target.value;
                          if (!Zx(g)) {
                            a("Invalid video URL"), n("");
                            return;
                          }
                          a(""), n(g);
                        }
                      }
                    ),
                    /* @__PURE__ */ s(be, { type: "submit", children: t("editor.video.dialog.button.apply") })
                  ] }) }),
                  o && /* @__PURE__ */ s("div", { className: "richtext-my-[5px] richtext-text-red-500", children: o })
                ] })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Y0(e, t, r) {
  return e < t ? t : e > r ? r : e;
}
const ey = (e) => typeof e == "number", ty = (e) => typeof e == "string", ry = (e) => typeof e == "function";
function ny(e, t = "px") {
  if (!e)
    return e;
  const r = ey(e) ? String(e) : e, n = Number.parseFloat(r), i = r.match(/[%a-z]+$/i), o = i ? i[0] : t;
  return Number.isNaN(n) ? e : n + o;
}
function iy(e, t) {
  if (!e)
    return !1;
  const { extensions: r = [] } = (e == null ? void 0 : e.extensionManager) ?? {};
  return !!r.find((i) => i.name === t);
}
function K0(e) {
  return e.map((t) => ty(t) ? { value: t, name: t } : t);
}
function oy(e) {
  return e = e.replace("https://youtu.be/", "https://www.youtube.com/watch?v=").replace("watch?v=", "embed/"), e = e.replace("https://vimeo.com/", "https://player.vimeo.com/video/"), /^https?:\/\/www.bilibili.com\/video\/.*/i.test(e) && (e = e.replace(/\?.*$/, "").replace("https://www.bilibili.com/video/", "https://player.bilibili.com/player.html?bvid=")), e.includes("drive.google.com") && (e = e.replace("/view", "/preview")), e;
}
const Ol = /* @__PURE__ */ Vt.create({
  name: "video",
  group: "block",
  atom: !0,
  draggable: !0,
  addOptions() {
    return {
      divider: !1,
      spacer: !1,
      allowFullscreen: !0,
      upload: void 0,
      frameborder: !1,
      resourceVideo: "both",
      width: qi["size-medium"],
      HTMLAttributes: {
        class: "iframe-wrapper",
        style: "display: flex;justify-content: center;"
      },
      button: ({ editor: e, t }) => {
        var r, n;
        return {
          component: Qx,
          componentProps: {
            action: () => {
            },
            isActive: () => e.isActive("video") || !1,
            /* If setVideo is not available(when Video Component is not imported), the button is disabled */
            disabled: !((n = (r = e.can()).setVideo) != null && n.call(r, {})),
            icon: "Video",
            tooltip: t("editor.video.tooltip"),
            editor: e
          }
        };
      }
    };
  },
  addAttributes() {
    return {
      src: {
        default: null,
        renderHTML: ({ src: e }) => ({
          src: e ? oy(e) : null
        })
      },
      width: {
        default: this.options.width,
        renderHTML: ({ width: e }) => ({
          width: ny(e)
        })
      },
      frameborder: {
        default: this.options.frameborder ? 1 : 0,
        parseHTML: () => this.options.frameborder ? 1 : 0
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-video] iframe"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { width: t = "100%" } = e ?? {}, r = {
      ...e,
      width: "100%",
      height: "100%"
    }, n = `position: relative;overflow: hidden;display: flex;flex: 1;max-width: ${t};`, i = `flex: 1;padding-bottom: ${9 / 16 * 100}%;`, c = ["div", { style: n }, ["div", { style: i }], ["iframe", r]];
    return ["div", {
      ...this.options.HTMLAttributes,
      "data-video": ""
    }, c];
  },
  addCommands() {
    return {
      setVideo: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      }),
      updateVideo: (e) => ({ commands: t }) => t.updateAttributes(this.name, e)
    };
  }
}), Io = {
  maxWidth: "auto",
  zIndex: 20,
  appendTo: "parent",
  moveTransition: "transform 0.1s ease-out"
};
function To({ item: e, disabled: t, editor: r }) {
  var i;
  const n = e.component;
  return n ? /* @__PURE__ */ s(Iu, { children: e.type === "divider" ? /* @__PURE__ */ s(
    _e,
    {
      className: "!richtext-mx-1 !richtext-my-2 !richtext-h-[16px]",
      orientation: "vertical"
    }
  ) : /* @__PURE__ */ s(
    n,
    {
      ...e.componentProps,
      disabled: t || ((i = e == null ? void 0 : e.componentProps) == null ? void 0 : i.disabled),
      editor: r
    }
  ) }) : /* @__PURE__ */ s(de, {});
}
function ay(e) {
  return e.type.name === qt.name;
}
function cy(e) {
  return e.type.name === Tl.name;
}
function sy(e) {
  return e.type.name === Ol.name;
}
function ly(e) {
  const { lang: t } = me(), r = ({ editor: i }) => {
    const { selection: o } = i.view.state, { $from: a, to: c } = o;
    let l = !1;
    return i.view.state.doc.nodesBetween(a.pos, c, (u) => {
      if (ay(u))
        return l = !0, !1;
    }), l;
  }, n = ye(() => e.disabled ? [] : Fv(e.editor), [e.disabled, e.editor, t]);
  return /* @__PURE__ */ s(de, { children: /* @__PURE__ */ s(
    at,
    {
      editor: e == null ? void 0 : e.editor,
      shouldShow: r,
      tippyOptions: Io,
      children: n != null && n.length ? /* @__PURE__ */ s("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-flex richtext-h-[26px] richtext-flex-nowrap richtext-items-center richtext-justify-start richtext-whitespace-nowrap", children: n == null ? void 0 : n.map((i, o) => /* @__PURE__ */ s(
        To,
        {
          disabled: e.disabled,
          editor: e.editor,
          item: i
        },
        `bubbleMenu-image-${o}`
      )) }) }) : /* @__PURE__ */ s(de, {})
    }
  ) });
}
function uy(e) {
  const { lang: t } = me(), r = ({ editor: i }) => {
    const { selection: o } = i.view.state, { $from: a, to: c } = o;
    let l = !1;
    return i.view.state.doc.nodesBetween(a.pos, c, (u) => {
      if (cy(u))
        return l = !0, !1;
    }), l;
  }, n = ye(() => e.disabled ? [] : Hv(e.editor), [e.disabled, e.editor, t]);
  return /* @__PURE__ */ s(de, { children: /* @__PURE__ */ s(
    at,
    {
      editor: e == null ? void 0 : e.editor,
      shouldShow: r,
      tippyOptions: Io,
      children: n != null && n.length ? /* @__PURE__ */ s("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-flex richtext-h-[26px] richtext-flex-nowrap richtext-items-center richtext-justify-start richtext-whitespace-nowrap", children: n == null ? void 0 : n.map((i, o) => /* @__PURE__ */ s(
        To,
        {
          disabled: e.disabled,
          editor: e.editor,
          item: i
        },
        `bubbleMenu-image-gif-${o}`
      )) }) }) : /* @__PURE__ */ s(de, {})
    }
  ) });
}
function dy(e) {
  const { lang: t } = me(), r = ({ editor: i }) => {
    const { selection: o } = i.view.state, { $from: a, to: c } = o;
    let l = !1;
    return i.view.state.doc.nodesBetween(a.pos, c, (u) => {
      if (sy(u))
        return l = !0, !1;
    }), l;
  }, n = ye(() => e.disabled ? [] : Uv(e.editor), [e.editor, e.disabled, t]);
  return /* @__PURE__ */ s(de, { children: /* @__PURE__ */ s(
    at,
    {
      editor: e == null ? void 0 : e.editor,
      shouldShow: r,
      tippyOptions: Io,
      children: n != null && n.length ? /* @__PURE__ */ s("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-flex richtext-h-[26px] richtext-flex-nowrap richtext-items-center richtext-justify-start richtext-whitespace-nowrap", children: n == null ? void 0 : n.map((i, o) => /* @__PURE__ */ s(
        To,
        {
          disabled: e.disabled,
          editor: e.editor,
          item: i
        },
        `bubbleMenu-video-${o}`
      )) }) }) : /* @__PURE__ */ s(de, {})
    }
  ) });
}
function fy(e, t, r = null) {
  return r ? e.createChecked({ index: t }, r) : e.createAndFill({ index: t });
}
function hy(e) {
  if (e.cached.columnsNodeTypes)
    return e.cached.columnsNodeTypes;
  const t = {
    columns: e.nodes.columns,
    column: e.nodes.column
  };
  return e.cached.columnsNodeTypes = t, t;
}
function py(e, t, r = null) {
  const n = hy(e), i = [];
  for (let o = 0; o < t; o += 1) {
    const a = fy(n.column, o, r);
    a && i.push(a);
  }
  return n.columns.createChecked({ cols: t }, i);
}
function tn({
  state: e,
  dispatch: t,
  type: r
}) {
  const n = gr((o) => o.type.name === wr.name)(e.selection), i = gr((o) => o.type.name === Pl.name)(e.selection);
  if (t && n && i) {
    const o = n.node, a = i.node.attrs.index, c = o.toJSON();
    let l = a;
    r === "delete" ? (l = a - 1, c.content.splice(a, 1)) : (l = r === "addBefore" ? a : a + 1, c.content.splice(l, 0, {
      type: "column",
      attrs: {
        index: a
      },
      content: [
        {
          type: "paragraph"
        }
      ]
    })), c.attrs.cols = c.content.length, c.content.forEach((h, p) => {
      h.attrs.index = p;
    });
    const u = hf.fromJSON(e.schema, c);
    let f = n.pos;
    u.content.forEach((h, p, m) => {
      m < l && (f += h.nodeSize);
    });
    const d = e.tr.setTime(Date.now());
    d.replaceWith(n.pos, n.pos + n.node.nodeSize, u).setSelection(
      Gt.near(d.doc.resolve(f))
    ), t(d);
  }
  return !0;
}
function Ma({ state: e, dispatch: t, type: r }) {
  const n = gr((o) => o.type.name === wr.name)(e.selection), i = gr((o) => o.type.name === Pl.name)(e.selection);
  if (t && n && i) {
    const o = n.node, a = i.node.attrs.index;
    let c = 0;
    r === "before" ? c = (a - 1 + o.attrs.cols) % o.attrs.cols : c = (a + 1) % o.attrs.cols;
    let l = n.pos;
    o.content.forEach((f, d, h) => {
      h < c && (l += f.nodeSize);
    });
    const u = e.tr.setTime(Date.now());
    return u.setSelection(Gt.near(u.doc.resolve(l))), t(u), !0;
  }
  return !1;
}
const Pl = /* @__PURE__ */ Vt.create({
  name: "column",
  content: "block+",
  isolating: !0,
  addOptions() {
    return {
      HTMLAttributes: {
        class: "column"
      }
    };
  },
  addAttributes() {
    return {
      index: {
        default: 0,
        parseHTML: (e) => e.getAttribute("index")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[class=column]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["div", Ct(this.options.HTMLAttributes, e), 0];
  }
}), J0 = pf.create({
  name: "columnActionButton",
  addOptions() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      button: ({ editor: t, t: r }) => ({
        component: q,
        componentProps: {
          action: () => {
            t.chain().focus().insertColumns({ cols: 2 }).run();
          },
          icon: "Columns",
          tooltip: r("editor.columns.tooltip")
        }
      })
    };
  }
}), my = 200, wr = /* @__PURE__ */ Vt.create({
  name: "columns",
  group: "block",
  defining: !0,
  isolating: !0,
  allowGapCursor: !1,
  content: "column{1,}",
  priority: my,
  addOptions() {
    return {
      HTMLAttributes: {
        class: "columns"
      }
    };
  },
  addAttributes() {
    return {
      cols: {
        default: 2,
        parseHTML: (e) => e.getAttribute("cols")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[class=grid]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["div", Ct(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      insertColumns: (e) => ({ tr: t, dispatch: r, editor: n }) => {
        const i = py(n.schema, e && e.cols || 3);
        if (r) {
          const o = t.selection.anchor + 1;
          t.replaceSelectionWith(i).scrollIntoView().setSelection(Gt.near(t.doc.resolve(o)));
        }
        return !0;
      },
      addColBefore: () => ({ dispatch: e, state: t }) => tn({ dispatch: e, state: t, type: "addBefore" }),
      addColAfter: () => ({ dispatch: e, state: t }) => tn({ dispatch: e, state: t, type: "addAfter" }),
      deleteCol: () => ({ dispatch: e, state: t }) => tn({ dispatch: e, state: t, type: "delete" })
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-G": () => this.editor.commands.insertColumns(),
      Tab: () => Ma({
        state: this.editor.state,
        dispatch: this.editor.view.dispatch,
        type: "after"
      }),
      "Shift-Tab": () => Ma({
        state: this.editor.state,
        dispatch: this.editor.view.dispatch,
        type: "before"
      })
    };
  }
});
function Rl(e, t) {
  const { state: r } = t, n = r.selection.$anchor;
  let i = !1;
  if (n.depth)
    for (let o = n.depth; o > 0; o--)
      n.node(o).type.name === e && (t.dispatchTransaction && t.dispatchTransaction(r.tr.delete(n.before(o), n.after(o)).scrollIntoView()), i = !0);
  else {
    const o = r.selection.node;
    o && o.type.name === e && (t.chain().deleteSelection().run(), i = !0);
  }
  if (!i) {
    const o = n.pos;
    if (o) {
      const a = r.tr.doc.nodeAt(o);
      a && a.type.name === e && (t.dispatchTransaction && t.dispatchTransaction(r.tr.delete(o, o + a.nodeSize)), i = !0);
    }
  }
  return i;
}
function gy({ editor: e }) {
  const { t } = me(), r = te(() => e.isActive(wr.name), [e]), n = te(() => Rl(wr.name, e), [e]), i = te(() => e.chain().focus().addColBefore().run(), [e]), o = te(() => e.chain().focus().addColAfter().run(), [e]), a = te(() => e.chain().focus().deleteCol().run(), [e]);
  return /* @__PURE__ */ s(
    at,
    {
      editor: e,
      pluginKey: "columns-bubble-menu",
      shouldShow: r,
      tippyOptions: {
        popperOptions: {
          modifiers: [{ name: "flip", enabled: !1 }]
        },
        placement: "bottom-start",
        offset: [-2, 16],
        zIndex: 9999
        // onHidden: () => {
        //   toggleVisible(false)
        // },
      },
      children: /* @__PURE__ */ T("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: [
        /* @__PURE__ */ s(
          q,
          {
            action: i,
            icon: "ColumnAddLeft",
            tooltip: t("editor.table.menu.insertColumnBefore")
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: o,
            icon: "ColumnAddRight",
            tooltip: t("editor.table.menu.insertColumnAfter")
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: a,
            icon: "DeleteColumn",
            tooltip: t("editor.table.menu.deleteColumn")
          }
        ),
        /* @__PURE__ */ s(
          q,
          {
            action: n,
            icon: "Trash2",
            tooltip: t("editor.table.menu.delete_column")
          }
        )
      ] })
    }
  );
}
const vy = ce.Root, xy = ce.Trigger, Ea = ce.Portal, $a = ce.Sub, no = Z.forwardRef(({ className: e, inset: t, children: r, ...n }, i) => /* @__PURE__ */ T(
  ce.SubTrigger,
  {
    ref: i,
    className: X(
      "richtext-flex richtext-cursor-default richtext-select-none richtext-items-center richtext-rounded-sm richtext-px-2 richtext-py-1.5 richtext-text-sm richtext-outline-none focus:richtext-bg-accent data-[state=open]:richtext-bg-accent",
      t && "richtext-pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ s(Zd, { className: "richtext-ml-auto richtext-h-4 richtext-w-4" })
    ]
  }
));
no.displayName = ce.SubTrigger.displayName;
const io = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  ce.SubContent,
  {
    ref: r,
    className: X(
      "richtext-z-50 richtext-min-w-[8rem] richtext-overflow-hidden richtext-rounded-md !richtext-border richtext-bg-popover richtext-p-1 richtext-text-popover-foreground richtext-shadow-lg data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[state=closed]:richtext-fade-out-0 data-[state=open]:richtext-fade-in-0 data-[state=closed]:richtext-zoom-out-95 data-[state=open]:richtext-zoom-in-95 data-[side=bottom]:richtext-slide-in-from-top-2 data-[side=left]:richtext-slide-in-from-right-2 data-[side=right]:richtext-slide-in-from-left-2 data-[side=top]:richtext-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
io.displayName = ce.SubContent.displayName;
const Nl = Z.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ s(ce.Portal, { children: /* @__PURE__ */ s(
  ce.Content,
  {
    ref: n,
    sideOffset: t,
    className: X(
      "richtext-z-50 richtext-min-w-[8rem] richtext-overflow-hidden richtext-rounded-md !richtext-border richtext-bg-popover richtext-p-1 richtext-text-popover-foreground richtext-shadow-md data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[state=closed]:richtext-fade-out-0 data-[state=open]:richtext-fade-in-0 data-[state=closed]:richtext-zoom-out-95 data-[state=open]:richtext-zoom-in-95 data-[side=bottom]:richtext-slide-in-from-top-2 data-[side=left]:richtext-slide-in-from-right-2 data-[side=right]:richtext-slide-in-from-left-2 data-[side=top]:richtext-slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
Nl.displayName = ce.Content.displayName;
const $e = Z.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ s(
  ce.Item,
  {
    ref: n,
    className: X(
      "richtext-relative richtext-flex richtext-cursor-default richtext-select-none richtext-items-center richtext-rounded-sm richtext-px-2 richtext-py-1.5 richtext-text-sm richtext-outline-none richtext-transition-colors focus:richtext-bg-accent focus:richtext-text-accent-foreground data-[disabled]:richtext-pointer-events-none data-[disabled]:richtext-opacity-50",
      t && "richtext-pl-8",
      e
    ),
    ...r
  }
));
$e.displayName = ce.Item.displayName;
const yy = Z.forwardRef(({ className: e, children: t, checked: r, ...n }, i) => /* @__PURE__ */ T(
  ce.CheckboxItem,
  {
    ref: i,
    className: X(
      "richtext-relative richtext-flex richtext-cursor-default richtext-select-none richtext-items-center richtext-rounded-sm richtext-py-1.5 richtext-pl-8 richtext-pr-2 richtext-text-sm richtext-outline-none richtext-transition-colors focus:richtext-bg-accent focus:richtext-text-accent-foreground data-[disabled]:richtext-pointer-events-none data-[disabled]:richtext-opacity-50",
      e
    ),
    checked: r,
    ...n,
    children: [
      /* @__PURE__ */ s("span", { className: "richtext-absolute richtext-left-2 richtext-flex richtext-h-3.5 richtext-w-3.5 richtext-items-center richtext-justify-center", children: /* @__PURE__ */ s(ce.ItemIndicator, { children: /* @__PURE__ */ s(Ns, { className: "richtext-h-4 richtext-w-4" }) }) }),
      t
    ]
  }
));
yy.displayName = ce.CheckboxItem.displayName;
const by = Z.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ T(
  ce.RadioItem,
  {
    ref: n,
    className: X(
      "richtext-relative richtext-flex richtext-cursor-default richtext-select-none richtext-items-center richtext-rounded-sm richtext-py-1.5 richtext-pl-8 richtext-pr-2 richtext-text-sm richtext-outline-none richtext-transition-colors focus:richtext-bg-accent focus:richtext-text-accent-foreground data-[disabled]:richtext-pointer-events-none data-[disabled]:richtext-opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ s("span", { className: "richtext-absolute richtext-left-2 richtext-flex richtext-h-3.5 richtext-w-3.5 richtext-items-center richtext-justify-center", children: /* @__PURE__ */ s(ce.ItemIndicator, { children: /* @__PURE__ */ s(Qd, { className: "richtext-h-2 richtext-w-2 richtext-fill-current" }) }) }),
      t
    ]
  }
));
by.displayName = ce.RadioItem.displayName;
const wy = Z.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ s(
  ce.Label,
  {
    ref: n,
    className: X(
      "richtext-px-2 richtext-py-1.5 richtext-text-sm richtext-font-semibold",
      t && "richtext-pl-8",
      e
    ),
    ...r
  }
));
wy.displayName = ce.Label.displayName;
const Ml = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  ce.Separator,
  {
    ref: r,
    className: X("richtext--mx-1 richtext-my-1 richtext-h-px richtext-bg-muted", e),
    ...t
  }
));
Ml.displayName = ce.Separator.displayName;
function Sy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s(
    "span",
    {
      className: X("richtext-ml-auto richtext-text-xs richtext-tracking-widest richtext-opacity-60", e),
      ...t
    }
  );
}
Sy.displayName = "DropdownMenuShortcut";
const Oe = Z.forwardRef(
  ({ className: e, type: t, ...r }, n) => /* @__PURE__ */ s(
    "input",
    {
      type: t,
      className: X(
        "richtext-flex richtext-h-10 richtext-w-full richtext-rounded-md !richtext-border richtext-border-input richtext-bg-background richtext-px-3 richtext-py-2 richtext-text-sm richtext-ring-offset-background file:richtext-border-0 file:richtext-bg-transparent file:richtext-text-sm file:richtext-font-medium placeholder:richtext-text-muted-foreground focus-visible:richtext-outline-none  disabled:richtext-cursor-not-allowed disabled:richtext-opacity-50",
        e
      ),
      ref: n,
      ...r
    }
  )
);
Oe.displayName = "Input";
const Ay = Nr(
  "richtext-text-sm richtext-font-medium richtext-leading-none peer-disabled:richtext-cursor-not-allowed peer-disabled:richtext-opacity-70"
), it = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Es.Root,
  {
    ref: r,
    className: X(Ay(), e),
    ...t
  }
));
it.displayName = Es.Root.displayName;
const Er = Lt.Root, $r = Lt.Trigger, Kt = Z.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, i) => /* @__PURE__ */ s(Lt.Portal, { children: /* @__PURE__ */ s(
  Lt.Content,
  {
    ref: i,
    align: t,
    sideOffset: r,
    className: X(
      "richtext-z-50 richtext-w-72 richtext-rounded-md !richtext-border richtext-bg-popover richtext-p-4 richtext-text-popover-foreground richtext-shadow-md richtext-outline-none data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[state=closed]:richtext-fade-out-0 data-[state=open]:richtext-fade-in-0 data-[state=closed]:richtext-zoom-out-95 data-[state=open]:richtext-zoom-in-95 data-[side=bottom]:richtext-slide-in-from-top-2 data-[side=left]:richtext-slide-in-from-right-2 data-[side=right]:richtext-slide-in-from-left-2 data-[side=top]:richtext-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
Kt.displayName = Lt.Content.displayName;
const _e = Z.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, i) => /* @__PURE__ */ s(
    Os.Root,
    {
      ref: i,
      decorative: r,
      orientation: t,
      className: X(
        "richtext-shrink-0 richtext-bg-border",
        t === "horizontal" ? "richtext-h-[1px] richtext-w-full" : "richtext-h-full richtext-w-[1px]",
        e
      ),
      ...n
    }
  )
);
_e.displayName = Os.Root.displayName;
const El = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Hi.Root,
  {
    className: X(
      "richtext-peer richtext-inline-flex richtext-h-6 richtext-w-11 richtext-shrink-0 richtext-cursor-pointer richtext-items-center richtext-rounded-full richtext-border-2 richtext-border-transparent richtext-transition-colors focus-visible:richtext-outline-none focus-visible:richtext-ring-2 focus-visible:richtext-ring-ring focus-visible:richtext-ring-offset-2 focus-visible:richtext-ring-offset-background disabled:richtext-cursor-not-allowed disabled:richtext-opacity-50 data-[state=checked]:richtext-bg-primary data-[state=unchecked]:richtext-bg-input",
      e
    ),
    ...t,
    ref: r,
    children: /* @__PURE__ */ s(
      Hi.Thumb,
      {
        className: X(
          "richtext-pointer-events-none richtext-block richtext-h-5 richtext-w-5 richtext-rounded-full richtext-bg-background richtext-shadow-lg richtext-ring-0 richtext-transition-transform data-[state=checked]:richtext-translate-x-5 data-[state=unchecked]:richtext-translate-x-0"
        )
      }
    )
  }
));
El.displayName = Hi.Root.displayName;
const $l = dt.Root, Oo = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  dt.List,
  {
    ref: r,
    className: X(
      "richtext-inline-flex richtext-h-10 richtext-items-center richtext-justify-center richtext-rounded-md richtext-bg-muted richtext-p-1 richtext-text-muted-foreground",
      e
    ),
    ...t
  }
));
Oo.displayName = dt.List.displayName;
const Ft = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  dt.Trigger,
  {
    ref: r,
    className: X(
      "richtext-inline-flex richtext-items-center richtext-justify-center richtext-whitespace-nowrap richtext-rounded-sm richtext-px-3 richtext-py-1.5 richtext-text-sm richtext-font-medium richtext-ring-offset-background richtext-transition-all focus-visible:richtext-outline-none focus-visible:richtext-ring-2 focus-visible:richtext-ring-ring focus-visible:richtext-ring-offset-2 disabled:richtext-pointer-events-none disabled:richtext-opacity-50 data-[state=active]:richtext-bg-background data-[state=active]:richtext-text-foreground data-[state=active]:richtext-shadow-sm",
      e
    ),
    ...t
  }
));
Ft.displayName = dt.Trigger.displayName;
const Ht = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  dt.Content,
  {
    ref: r,
    className: X(
      "richtext-mt-2 richtext-ring-offset-background focus-visible:richtext-outline-none focus-visible:richtext-ring-2 focus-visible:richtext-ring-ring focus-visible:richtext-ring-offset-2",
      e
    ),
    ...t
  }
));
Ht.displayName = dt.Content.displayName;
const Cy = Te.Provider, kl = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Te.Viewport,
  {
    ref: r,
    className: X(
      "richtext-fixed richtext-top-0 richtext-z-[100] richtext-flex richtext-max-h-screen richtext-w-full richtext-flex-col-reverse richtext-p-4 sm:richtext-bottom-0 sm:richtext-right-0 sm:richtext-top-auto sm:richtext-flex-col md:richtext-max-w-[420px]",
      e
    ),
    ...t
  }
));
kl.displayName = Te.Viewport.displayName;
const Iy = Nr(
  "richtext-group richtext-pointer-events-auto richtext-relative richtext-flex richtext-w-full richtext-items-center richtext-justify-between richtext-space-x-4 richtext-overflow-hidden richtext-rounded-md !richtext-border richtext-p-6 richtext-pr-8 richtext-shadow-lg richtext-transition-all data-[swipe=cancel]:richtext-translate-x-0 data-[swipe=end]:richtext-translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:richtext-translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:richtext-transition-none data-[state=open]:richtext-animate-in data-[state=closed]:richtext-animate-out data-[swipe=end]:richtext-animate-out data-[state=closed]:richtext-fade-out-80 data-[state=closed]:richtext-slide-out-to-right-full data-[state=open]:richtext-slide-in-from-top-full data-[state=open]:sm:richtext-slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "richtext-border richtext-bg-background richtext-text-foreground",
        destructive: "richtext-destructive richtext-group richtext-border-destructive richtext-bg-destructive richtext-text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), _l = Z.forwardRef(({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ s(
  Te.Root,
  {
    ref: n,
    className: X(Iy({ variant: t }), e),
    ...r
  }
));
_l.displayName = Te.Root.displayName;
const Ty = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Te.Action,
  {
    ref: r,
    className: X(
      "richtext-inline-flex richtext-h-8 richtext-shrink-0 richtext-items-center richtext-justify-center richtext-rounded-md !richtext-border richtext-bg-transparent richtext-px-3 richtext-text-sm richtext-font-medium richtext-ring-offset-background richtext-transition-colors hover:richtext-bg-secondary focus:richtext-outline-none focus:richtext-ring-2 focus:richtext-ring-ring focus:richtext-ring-offset-2 disabled:richtext-pointer-events-none disabled:richtext-opacity-50 group-[.destructive]:richtext-border-muted/40 group-[.destructive]:hover:richtext-border-destructive/30 group-[.destructive]:hover:richtext-bg-destructive group-[.destructive]:hover:richtext-text-destructive-foreground group-[.destructive]:focus:richtext-ring-destructive",
      e
    ),
    ...t
  }
));
Ty.displayName = Te.Action.displayName;
const Ll = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Te.Close,
  {
    ref: r,
    className: X(
      "richtext-absolute richtext-right-2 richtext-top-2 richtext-rounded-md richtext-p-1 richtext-text-foreground/50 richtext-opacity-0 richtext-transition-opacity hover:richtext-text-foreground focus:richtext-opacity-100 focus:richtext-outline-none focus:richtext-ring-2 group-hover:richtext-opacity-100 group-[.destructive]:richtext-text-red-300 group-[.destructive]:hover:richtext-text-red-50 group-[.destructive]:focus:richtext-ring-red-400 group-[.destructive]:focus:richtext-ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ s(Rs, { className: "richtext-h-4 richtext-w-4" })
  }
));
Ll.displayName = Te.Close.displayName;
const Dl = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Te.Title,
  {
    ref: r,
    className: X("richtext-text-sm richtext-font-semibold", e),
    ...t
  }
));
Dl.displayName = Te.Title.displayName;
const Bl = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Te.Description,
  {
    ref: r,
    className: X("richtext-text-sm richtext-opacity-90", e),
    ...t
  }
));
Bl.displayName = Te.Description.displayName;
const Oy = Nr(
  "richtext-inline-flex richtext-items-center richtext-justify-center richtext-rounded-md richtext-text-sm richtext-font-medium richtext-ring-offset-background richtext-transition-colors hover:richtext-bg-muted hover:richtext-text-muted-foreground focus-visible:richtext-outline-none focus-visible:richtext-ring-2 focus-visible:richtext-ring-ring focus-visible:richtext-ring-offset-2 disabled:richtext-pointer-events-none disabled:richtext-opacity-50 data-[state=on]:richtext-bg-accent data-[state=on]:richtext-text-accent-foreground",
  {
    variants: {
      variant: {
        default: "richtext-bg-transparent",
        outline: "richtext-border richtext-border-input richtext-bg-transparent hover:richtext-bg-accent hover:richtext-text-accent-foreground"
      },
      size: {
        default: "richtext-h-10 richtext-px-3",
        sm: "richtext-h-9 richtext-px-2",
        lg: "richtext-h-11 richtext-px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), zl = Z.forwardRef(({ className: e, variant: t, size: r, ...n }, i) => /* @__PURE__ */ s(
  Ms.Root,
  {
    ref: i,
    className: X(Oy({ variant: t, size: r, className: e })),
    ...n
  }
));
zl.displayName = Ms.Root.displayName;
const Py = Ut.Provider, jl = Ut.Root, ql = Ut.Trigger, Po = Z.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ s(
  Ut.Content,
  {
    ref: n,
    sideOffset: t,
    className: X(
      "richtext-z-50 richtext-overflow-hidden richtext-rounded-md !richtext-border richtext-bg-popover richtext-px-3 richtext-py-1.5 richtext-text-sm richtext-text-popover-foreground richtext-shadow-md richtext-animate-in richtext-fade-in-0 richtext-zoom-in-95 data-[side=bottom]:richtext-slide-in-from-top-2 data-[side=left]:richtext-slide-in-from-right-2 data-[side=right]:richtext-slide-in-from-left-2 data-[side=top]:richtext-slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
Po.displayName = Ut.Content.displayName;
const Ry = 1, Ny = 1e6;
let rn = 0;
function My() {
  return rn = (rn + 1) % Number.MAX_SAFE_INTEGER, rn.toString();
}
const nn = /* @__PURE__ */ new Map();
function ka(e) {
  if (nn.has(e))
    return;
  const t = setTimeout(() => {
    nn.delete(e), _t({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Ny);
  nn.set(e, t);
}
function Ey(e, t) {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Ry)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === t.toast.id ? { ...r, ...t.toast } : r
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: r } = t;
      return r ? ka(r) : e.toasts.forEach((n) => {
        ka(n.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === r || r === void 0 ? {
            ...n,
            open: !1
          } : n
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((r) => r.id !== t.toastId)
      };
  }
}
const dr = [];
let fr = { toasts: [] };
function _t(e) {
  fr = Ey(fr, e), dr.forEach((t) => {
    t(fr);
  });
}
function $y({ ...e }) {
  const t = My(), r = (i) => _t({
    type: "UPDATE_TOAST",
    toast: { ...i, id: t }
  }), n = () => _t({ type: "DISMISS_TOAST", toastId: t });
  return _t({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (i) => {
        i || n();
      }
    }
  }), {
    id: t,
    dismiss: n,
    update: r
  };
}
function ky() {
  const [e, t] = Z.useState(fr);
  return Z.useEffect(() => (dr.push(t), () => {
    const r = dr.indexOf(t);
    r > -1 && dr.splice(r, 1);
  }), [e]), {
    ...e,
    toast: $y,
    dismiss: (r) => _t({ type: "DISMISS_TOAST", toastId: r })
  };
}
const Fl = Z.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s(
  Fi.Root,
  {
    ref: r,
    className: X(
      "!richtext-peer !richtext-h-4 !richtext-w-4 !richtext-p-0 !richtext-shrink-0 !richtext-rounded-sm !richtext-border !richtext-border-primary !richtext-ring-offset-background focus-visible:!richtext-outline-none focus-visible:!richtext-ring-2 focus-visible:!richtext-ring-ring focus-visible:!richtext-ring-offset-2 disabled:!richtext-cursor-not-allowed disabled:!richtext-opacity-50 data-[state=checked]:!richtext-bg-primary data-[state=checked]:!richtext-text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ s(
      Fi.Indicator,
      {
        className: X("!richtext-flex !richtext-p-0 !richtext-items-center !richtext-justify-center !richtext-text-current"),
        children: /* @__PURE__ */ s(Ns, { className: "!richtext-h-4 !richtext-w-4" })
      }
    )
  }
));
Fl.displayName = Fi.Root.displayName;
const _y = { padding: "0 12px 12px" }, Ly = ({ width: e, maxWidth: t, height: r, onOk: n, children: i }) => {
  const { t: o } = me(), [a, c] = Y({
    width: "",
    height: "",
    maxWidth: ""
  });
  le(() => {
    c({
      width: e,
      height: r,
      maxWidth: t
    });
  }, [r, t, e]);
  function l(u) {
    u.preventDefault(), u.stopPropagation(), n(a);
  }
  return /* @__PURE__ */ T(Er, { modal: !0, children: [
    /* @__PURE__ */ s($r, { asChild: !0, children: i }),
    /* @__PURE__ */ s(Kt, { children: /* @__PURE__ */ s("div", { style: _y, children: /* @__PURE__ */ T("form", { className: "richtext-flex richtext-flex-col richtext-gap-2", onSubmit: l, children: [
      /* @__PURE__ */ s(it, { className: "mb-[6px]", children: "Width" }),
      /* @__PURE__ */ s("div", { className: "richtext-flex richtext-w-full richtext-max-w-sm richtext-items-center richtext-gap-1.5", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-items-center richtext-w-full richtext-max-w-sm", children: /* @__PURE__ */ s(
        Oe,
        {
          type: "number",
          value: a.width,
          required: !0,
          onChange: (u) => c({ ...a, width: u.target.value })
        }
      ) }) }),
      /* @__PURE__ */ s(it, { className: "mb-[6px]", children: "Max Width" }),
      /* @__PURE__ */ s("div", { className: "richtext-flex richtext-w-full richtext-max-w-sm richtext-items-center richtext-gap-1.5", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-items-center richtext-w-full richtext-max-w-sm", children: /* @__PURE__ */ s(
        Oe,
        {
          type: "number",
          value: a.maxWidth,
          required: !0,
          onChange: (u) => c({ ...a, maxWidth: u.target.value })
        }
      ) }) }),
      /* @__PURE__ */ s(it, { className: "mb-[6px]", children: "Height" }),
      /* @__PURE__ */ s("div", { className: "richtext-flex richtext-w-full richtext-max-w-sm richtext-items-center richtext-gap-1.5", children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-items-center richtext-w-full richtext-max-w-sm", children: /* @__PURE__ */ s(
        Oe,
        {
          type: "number",
          value: a.height,
          required: !0,
          onChange: (u) => c({ ...a, height: u.target.value })
        }
      ) }) }),
      /* @__PURE__ */ s(be, { type: "submit", className: "richtext-self-end richtext-mt-2", children: o("editor.link.dialog.button.apply") })
    ] }) }) })
  ] });
}, Tt = {
  youtube: {
    example: "https://www.youtube.com/watch?v=I4sMhHbHYXM",
    src: "https://www.youtube.com/embed/I4sMhHbHYXM",
    srcPrefix: "https://www.youtube.com/embed",
    linkRule: [
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\s/]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[&?]v=)|youtu\.be\/)([\w-]{11})/
    ]
  },
  youku: {
    example: "https://v.youku.com/v_show/id_XNDM0NDM4MTcy.html?spm=a2h0c.8166622.PhoneSokuUgc_4.dtitle",
    src: "https://player.youku.com/embed/XNDM0NDM4MTcy",
    srcPrefix: "https://player.youku.com/embed",
    linkRule: [String.raw`v.youku.com\/v_show\/id_\w+\=*`],
    idRule: String.raw`id_\w+\=*`
  },
  bilibili: {
    example: "https://www.bilibili.com/video/BV1EJ411u7DN",
    src: "https://player.bilibili.com/player.html?bvid=BV1EJ411u7DN",
    srcPrefix: "https://player.bilibili.com/player.html?bvid",
    linkRule: [String.raw`www.bilibili.com\/video\/\w+`]
  },
  qqvideo: {
    example: "https://v.qq.com/x/cover/mzc0020006aw1mn/u0033nvzb5v.html",
    src: "https://v.qq.com/txp/iframe/player.html?vid=u0033nvzb5v",
    srcPrefix: "https://v.qq.com/txp/iframe/player.html?vid",
    linkRule: [String.raw`v.qq.com\/x\/cover\/\w+\/\w+`]
  },
  amap: {
    example: "https://ditu.amap.com/",
    src: "https://www.amap.com/place/B000A45467",
    srcPrefix: "",
    linkRule: [String.raw`\.amap\.com`]
  },
  baidu_map: {
    example: "https://j.map.baidu.com/15/fo",
    src: "https://j.map.baidu.com/15/fo",
    srcPrefix: "",
    linkRule: [String.raw`map\.baidu\.com`]
  },
  modao: {
    example: "https://free.modao.cc/app/2cd26580a6717a147454df7470e7ec464093cba3/embed/v2#screen=sk71k6d1dfxulzx",
    src: "https://free.modao.cc/app/6UkpAxcGE3nPz52GLqhnOZgC7MATBSy/embed/v2",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/\w+.modao.cc\/app\/\w+\/embed\/v2`],
    tips: "Modao > More > Share > Embed > COPY"
  },
  lanhu: {
    example: "https://lanhuapp.com/link/#/invite?sid=evP7L",
    src: "https://lanhuapp.com/url/evP7L",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/lanhuapp.com\/url\/\w+`],
    tips: "Lanhu > Project > Share > Copy Link"
  },
  figma: {
    example: "https://www.figma.com/file/aS9uSgPXoNpaPkzbjNcK8v/Demo?node-id=0%3A1",
    src: "https://www.figma.com/file/aS9uSgPXoNpaPkzbjNcK8v/Demo?node-id=0%3A1",
    srcPrefix: "https://www.figma.com/embed?embed_host=share&url",
    linkRule: [String.raw`https:\/\/www.figma.com\/file\/\w+`]
  },
  canva: {
    example: "https://www.canva.cn/design/DAD61-t29UI/view",
    src: "https://www.canva.cn/design/DAD61-t29UI/view",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/www.canva.cn\/design\/.+\/view`]
  },
  processon: {
    example: "https://www.processon.com/embed/5ea99d8607912948b0e6fe78",
    src: "https://www.processon.com/embed/5ea99d8607912948b0e6fe78",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/www.processon.com\/embed\/\w+`]
  },
  codepen: {
    example: "https://codepen.io/mekery/embed/YzyrKOJ",
    src: "https://codepen.io/mekery/embed/YzyrKOJ",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/codepen.io\/.+\/embed\/\w+`]
  },
  jinshuju: {
    example: "https://jinshuju.net/f/q9YvVf",
    src: "https://jinshuju.net/f/q9YvVf",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/jinshuju.net\/f\/\w+`]
  },
  iframe: {
    example: "https://v.youku.com/v_show/id_XNDM0NDM4MTcy.html",
    src: "https://player.youku.com/embed/XNDM0NDM4MTcy",
    srcPrefix: "",
    linkRule: [".+"]
  },
  googlemaps: {
    example: "https://goo.gl/maps/8Ys8b4K1ZJY2",
    src: "https://www.google.com/maps/embed?pb=https://goo.gl/maps/8Ys8b4K1ZJY2",
    srcPrefix: "",
    linkRule: [String.raw`https:\/\/goo.gl\/maps\/\w+`]
  }
};
function Dy(e) {
  const t = Tt.youtube, r = e.matchedUrl;
  e.validLink = !0;
  const n = r.split("="), i = n.length;
  if (i > 0) {
    const o = n[i - 1];
    e.src = `${t.srcPrefix}/${o}`, e.validId = !0;
  }
  return e;
}
function By(e) {
  const t = Tt.youku, r = e.matchedUrl, n = t.idRule, i = new RegExp(n), o = r.match(i);
  if (o && o.length > 0) {
    const a = o[0].slice(3);
    e.validId = !0, e.src = `${t.srcPrefix}/${a}`;
  } else
    e.validId = !1;
  return e;
}
function zy(e) {
  const t = Tt.bilibili, n = e.matchedUrl.split("/"), i = n.length;
  if (i > 0) {
    const o = n[i - 1];
    e.src = `${t.srcPrefix}=${o}`, e.validId = !0;
  }
  return e;
}
function jy(e) {
  const t = Tt.qqvideo, n = e.matchedUrl.split("/"), i = n.length;
  if (i > 0) {
    const o = n[i - 1];
    e.src = `${t.srcPrefix}=${o}`, e.validId = !0;
  }
  return e;
}
function qy(e, t) {
  return t.src = e, t.validId = !0, t;
}
function Fy(e, t) {
  return t.src = e, t.validId = !0, t;
}
function Hy(e, t) {
  return t.src = e, t.validId = !0, t.originalLink = e, t;
}
function Uy(e) {
  return e.src = e.matchedUrl, e.validId = !0, e.originalLink = e.src, e;
}
function Wy(e) {
  return e.src = e.matchedUrl, e.validId = !0, e.originalLink = e.src, e;
}
function Gy(e) {
  const t = Tt.figma;
  return e.src = `${t.srcPrefix}=${encodeURIComponent(e.matchedUrl)}`, e.validId = !0, e.originalLink = e.matchedUrl, e;
}
function Vy(e, t) {
  return t.src = `${t.matchedUrl}?embed`, t.validId = !0, t.originalLink = e, t;
}
function Xy(e, t) {
  return t.src = `${t.matchedUrl}`, t.validId = !0, t.originalLink = e, t;
}
function Yy(e) {
  return e.src = `${e.matchedUrl}`, e.validId = !0, e.originalLink = e.src, e;
}
function Ky(e, t) {
  return t.src = `${t.matchedUrl}?background=white&banner=show&embedded=true`, t.validId = !0, t.originalLink = e, t;
}
function Jy(e, t) {
  return t.src = `${t.matchedUrl}`, t.validId = !0, t.originalLink = e, t;
}
function Zy(e, t, r) {
  if (e === "googlemaps")
    return r.validLink = !0, r.matchedUrl = t, r;
  const i = Tt[e].linkRule;
  for (const o of i) {
    const a = new RegExp(o), c = t.match(a);
    if (c && c.length > 0)
      return r.validLink = !0, r.matchedUrl = e === "youtube" ? c[1] : c[0], r;
  }
  return r;
}
function Qy(e) {
  var r, n;
  let t = "iframe";
  return ((r = e.includes) != null && r.call(e, "youtube") || (n = e.includes) != null && n.call(e, "youtu.be")) && (t = "youtube"), e.includes("youku") && (t = "youku"), e.includes("bilibili") && (t = "bilibili"), e.includes("qq") && (t = "qqvideo"), e.includes("amap") && (t = "amap"), e.includes("map.baidu") && (t = "baidu_map"), (e.includes("google.com/maps") || e.includes("maps.app.goo.gl")) && (t = "googlemaps"), e.includes("modao") && (t = "modao"), e.includes("lanhuapp") && (t = "lanhu"), e.includes("figma") && (t = "figma"), e.includes("canva") && (t = "canva"), e.includes("processon") && (t = "processon"), e.includes("codepen") && (t = "codepen"), e.includes("jinshuju") && (t = "jinshuju"), e.includes("iframe") && (t = "iframe"), t;
}
function Hl(e) {
  let t = {
    validLink: !1,
    validId: !1,
    matchedUrl: "",
    originalLink: e,
    src: ""
  };
  const r = Qy(e);
  if (t = Zy(r, e, t), !t.validLink)
    return t;
  switch (r) {
    case "youtube":
      return Dy(t);
    case "youku":
      return By(t);
    case "bilibili":
      return zy(t);
    case "qqvideo":
      return jy(t);
    case "amap":
      return qy(e, t);
    case "baidu_map":
      return Fy(e, t);
    case "googlemaps":
      return Hy(e, t);
    case "modao":
      return Uy(t);
    case "lanhu":
      return Wy(t);
    case "figma":
      return Gy(t);
    case "canva":
      return Vy(e, t);
    case "processon":
      return Xy(e, t);
    case "codepen":
      return Yy(t);
    case "jinshuju":
      return Ky(e, t);
    case "iframe":
      return Jy(e, t);
    default:
      return e;
  }
}
function e1() {
  const [e] = Cl((t) => t.value);
  return e;
}
const t1 = {
  setDisable: (e, t) => {
    Co(ut.EDIT(e), t);
  }
}, r1 = "_wrap_5y04w_1", n1 = "_innerWrap_5y04w_15", _a = {
  wrap: r1,
  innerWrap: n1
};
function i1({ editor: e, node: t, updateAttributes: r }) {
  const n = e1(), { src: i, width: o, height: a } = t.attrs, [c, l] = Y("");
  function u() {
    if (!c)
      return;
    const d = Hl(c);
    e.chain().updateAttributes(bt.name, {
      src: (d == null ? void 0 : d.src) || c
    }).setNodeSelection(e.state.selection.from).focus().run();
  }
  const f = te(
    (d) => {
      r({ width: d.width, height: d.height });
    },
    [r]
  );
  return /* @__PURE__ */ T(co, { children: [
    !i && /* @__PURE__ */ T("div", { className: "richtext-mx-auto richtext-my-[12px] richtext-flex richtext-max-w-[600px] richtext-items-center richtext-justify-center richtext-gap-[10px] richtext-rounded-[12px] richtext-border richtext-border-solid richtext-border-[#ccc] richtext-p-[10px]", children: [
      /* @__PURE__ */ s(
        Oe,
        {
          autoFocus: !0,
          className: "richtext-flex-1",
          onInput: (d) => l(d.target.value),
          placeholder: "Enter link",
          type: "url",
          value: c
        }
      ),
      /* @__PURE__ */ s(
        be,
        {
          className: "richtext-w-[60px]",
          onClick: u,
          children: "OK"
        }
      )
    ] }),
    i && /* @__PURE__ */ s(
      mf,
      {
        size: { width: Number.parseInt(o), height: Number.parseInt(a) },
        onResizeStop: (d, h, p, m) => {
          f({
            width: Number.parseInt(o) + m.width,
            height: Number.parseInt(a) + m.height
          });
        },
        children: /* @__PURE__ */ s("div", { className: ao(_a.wrap, "render-wrapper"), children: /* @__PURE__ */ s(
          "div",
          {
            className: _a.innerWrap,
            style: { pointerEvents: n ? "none" : "auto" },
            children: /* @__PURE__ */ s(
              "iframe",
              {
                className: "richtext-my-[12px] ",
                src: i
              }
            )
          }
        ) })
      }
    )
  ] });
}
const bt = /* @__PURE__ */ Vt.create({
  name: "iframe",
  content: "",
  marks: "",
  group: "block",
  selectable: !0,
  atom: !0,
  draggable: !0,
  addOptions() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      HTMLAttributes: {
        class: "iframe"
      },
      button: ({
        editor: t,
        extension: r,
        t: n
      }) => ({
        component: q,
        componentProps: {
          action: (i) => t.commands.setIframe(i),
          upload: r.options.upload,
          disabled: !t.can().setIframe({}),
          icon: "Iframe",
          tooltip: n("editor.iframe.tooltip")
        }
      })
    };
  },
  addAttributes() {
    return {
      width: {
        default: 600,
        parseHTML: Gr("width")
      },
      height: {
        default: 300,
        parseHTML: Gr("height")
      },
      src: {
        default: null,
        parseHTML: Gr("src")
      },
      defaultShowPicker: {
        default: !1
      },
      frameborder: {
        default: 0
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "iframe"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["iframe", Ct(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setIframe: (e) => ({ tr: t, commands: r, chain: n }) => {
        var o, a, c;
        if (((c = (a = (o = t.selection) == null ? void 0 : o.node) == null ? void 0 : a.type) == null ? void 0 : c.name) == this.name)
          return r.updateAttributes(this.name, e);
        const i = e || { url: "" };
        return n().insertContent({
          type: this.name,
          attrs: i
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      $s({
        find: /^\$iframe\$$/,
        type: this.type,
        getAttributes: () => ({ width: "100%" })
      })
    ];
  },
  addNodeView() {
    return so(i1);
  }
});
var Sr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function o1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function a1(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var on, La;
function Ul() {
  if (La) return on;
  La = 1;
  var e = Object.prototype.toString;
  return on = function(r) {
    var n = e.call(r), i = n === "[object Arguments]";
    return i || (i = n !== "[object Array]" && r !== null && typeof r == "object" && typeof r.length == "number" && r.length >= 0 && e.call(r.callee) === "[object Function]"), i;
  }, on;
}
var an, Da;
function c1() {
  if (Da) return an;
  Da = 1;
  var e;
  if (!Object.keys) {
    var t = Object.prototype.hasOwnProperty, r = Object.prototype.toString, n = Ul(), i = Object.prototype.propertyIsEnumerable, o = !i.call({ toString: null }, "toString"), a = i.call(function() {
    }, "prototype"), c = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], l = function(h) {
      var p = h.constructor;
      return p && p.prototype === h;
    }, u = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, f = function() {
      if (typeof window > "u")
        return !1;
      for (var h in window)
        try {
          if (!u["$" + h] && t.call(window, h) && window[h] !== null && typeof window[h] == "object")
            try {
              l(window[h]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), d = function(h) {
      if (typeof window > "u" || !f)
        return l(h);
      try {
        return l(h);
      } catch {
        return !1;
      }
    };
    e = function(p) {
      var m = p !== null && typeof p == "object", g = r.call(p) === "[object Function]", y = n(p), w = m && r.call(p) === "[object String]", S = [];
      if (!m && !g && !y)
        throw new TypeError("Object.keys called on a non-object");
      var b = a && g;
      if (w && p.length > 0 && !t.call(p, 0))
        for (var A = 0; A < p.length; ++A)
          S.push(String(A));
      if (y && p.length > 0)
        for (var R = 0; R < p.length; ++R)
          S.push(String(R));
      else
        for (var M in p)
          !(b && M === "prototype") && t.call(p, M) && S.push(String(M));
      if (o)
        for (var E = d(p), O = 0; O < c.length; ++O)
          !(E && c[O] === "constructor") && t.call(p, c[O]) && S.push(c[O]);
      return S;
    };
  }
  return an = e, an;
}
var cn, Ba;
function Ro() {
  if (Ba) return cn;
  Ba = 1;
  var e = Array.prototype.slice, t = Ul(), r = Object.keys, n = r ? function(a) {
    return r(a);
  } : c1(), i = Object.keys;
  return n.shim = function() {
    if (Object.keys) {
      var a = function() {
        var c = Object.keys(arguments);
        return c && c.length === arguments.length;
      }(1, 2);
      a || (Object.keys = function(l) {
        return t(l) ? i(e.call(l)) : i(l);
      });
    } else
      Object.keys = n;
    return Object.keys || n;
  }, cn = n, cn;
}
var sn, za;
function kr() {
  if (za) return sn;
  za = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return sn = e, sn;
}
var ln, ja;
function No() {
  return ja || (ja = 1, ln = SyntaxError), ln;
}
var un, qa;
function Re() {
  return qa || (qa = 1, un = TypeError), un;
}
var dn, Fa;
function s1() {
  return Fa || (Fa = 1, dn = Object.getOwnPropertyDescriptor), dn;
}
var fn, Ha;
function pt() {
  if (Ha) return fn;
  Ha = 1;
  var e = /* @__PURE__ */ s1();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return fn = e, fn;
}
var hn, Ua;
function Mo() {
  if (Ua) return hn;
  Ua = 1;
  var e = /* @__PURE__ */ kr(), t = /* @__PURE__ */ No(), r = /* @__PURE__ */ Re(), n = /* @__PURE__ */ pt();
  return hn = function(o, a, c) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new r("`obj` must be an object or a function`");
    if (typeof a != "string" && typeof a != "symbol")
      throw new r("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new r("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new r("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new r("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new r("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, f = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, h = !!n && n(o, a);
    if (e)
      e(o, a, {
        configurable: f === null && h ? h.configurable : !f,
        enumerable: l === null && h ? h.enumerable : !l,
        value: c,
        writable: u === null && h ? h.writable : !u
      });
    else if (d || !l && !u && !f)
      o[a] = c;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, hn;
}
var pn, Wa;
function Eo() {
  if (Wa) return pn;
  Wa = 1;
  var e = /* @__PURE__ */ kr(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, pn = t, pn;
}
var mn, Ga;
function mt() {
  if (Ga) return mn;
  Ga = 1;
  var e = Ro(), t = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", r = Object.prototype.toString, n = Array.prototype.concat, i = /* @__PURE__ */ Mo(), o = function(u) {
    return typeof u == "function" && r.call(u) === "[object Function]";
  }, a = /* @__PURE__ */ Eo()(), c = function(u, f, d, h) {
    if (f in u) {
      if (h === !0) {
        if (u[f] === d)
          return;
      } else if (!o(h) || !h())
        return;
    }
    a ? i(u, f, d, !0) : i(u, f, d);
  }, l = function(u, f) {
    var d = arguments.length > 2 ? arguments[2] : {}, h = e(f);
    t && (h = n.call(h, Object.getOwnPropertySymbols(f)));
    for (var p = 0; p < h.length; p += 1)
      c(u, h[p], f[h[p]], d[h[p]]);
  };
  return l.supportsDescriptors = !!a, mn = l, mn;
}
var gn = { exports: {} }, vn, Va;
function $o() {
  return Va || (Va = 1, vn = Object), vn;
}
var xn, Xa;
function Wl() {
  return Xa || (Xa = 1, xn = Error), xn;
}
var yn, Ya;
function l1() {
  return Ya || (Ya = 1, yn = EvalError), yn;
}
var bn, Ka;
function u1() {
  return Ka || (Ka = 1, bn = RangeError), bn;
}
var wn, Ja;
function d1() {
  return Ja || (Ja = 1, wn = ReferenceError), wn;
}
var Sn, Za;
function f1() {
  return Za || (Za = 1, Sn = URIError), Sn;
}
var An, Qa;
function h1() {
  return Qa || (Qa = 1, An = Math.abs), An;
}
var Cn, ec;
function p1() {
  return ec || (ec = 1, Cn = Math.floor), Cn;
}
var In, tc;
function m1() {
  return tc || (tc = 1, In = Math.max), In;
}
var Tn, rc;
function g1() {
  return rc || (rc = 1, Tn = Math.min), Tn;
}
var On, nc;
function v1() {
  return nc || (nc = 1, On = Math.pow), On;
}
var Pn, ic;
function x1() {
  return ic || (ic = 1, Pn = Math.round), Pn;
}
var Rn, oc;
function y1() {
  return oc || (oc = 1, Rn = Number.isNaN || function(t) {
    return t !== t;
  }), Rn;
}
var Nn, ac;
function b1() {
  if (ac) return Nn;
  ac = 1;
  var e = /* @__PURE__ */ y1();
  return Nn = function(r) {
    return e(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, Nn;
}
var Mn, cc;
function _r() {
  return cc || (cc = 1, Mn = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[r] = i;
    for (var o in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(t);
    if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var c = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (c.value !== i || c.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Mn;
}
var En, sc;
function ko() {
  if (sc) return En;
  sc = 1;
  var e = typeof Symbol < "u" && Symbol, t = _r();
  return En = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, En;
}
var $n, lc;
function Gl() {
  return lc || (lc = 1, $n = typeof Reflect < "u" && Reflect.getPrototypeOf || null), $n;
}
var kn, uc;
function Vl() {
  if (uc) return kn;
  uc = 1;
  var e = /* @__PURE__ */ $o();
  return kn = e.getPrototypeOf || null, kn;
}
var _n, dc;
function w1() {
  if (dc) return _n;
  dc = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", i = function(l, u) {
    for (var f = [], d = 0; d < l.length; d += 1)
      f[d] = l[d];
    for (var h = 0; h < u.length; h += 1)
      f[h + l.length] = u[h];
    return f;
  }, o = function(l, u) {
    for (var f = [], d = u, h = 0; d < l.length; d += 1, h += 1)
      f[h] = l[d];
    return f;
  }, a = function(c, l) {
    for (var u = "", f = 0; f < c.length; f += 1)
      u += c[f], f + 1 < c.length && (u += l);
    return u;
  };
  return _n = function(l) {
    var u = this;
    if (typeof u != "function" || t.apply(u) !== n)
      throw new TypeError(e + u);
    for (var f = o(arguments, 1), d, h = function() {
      if (this instanceof d) {
        var w = u.apply(
          this,
          i(f, arguments)
        );
        return Object(w) === w ? w : this;
      }
      return u.apply(
        l,
        i(f, arguments)
      );
    }, p = r(0, u.length - f.length), m = [], g = 0; g < p; g++)
      m[g] = "$" + g;
    if (d = Function("binder", "return function (" + a(m, ",") + "){ return binder.apply(this,arguments); }")(h), u.prototype) {
      var y = function() {
      };
      y.prototype = u.prototype, d.prototype = new y(), y.prototype = null;
    }
    return d;
  }, _n;
}
var Ln, fc;
function Jt() {
  if (fc) return Ln;
  fc = 1;
  var e = w1();
  return Ln = Function.prototype.bind || e, Ln;
}
var Dn, hc;
function _o() {
  return hc || (hc = 1, Dn = Function.prototype.call), Dn;
}
var Bn, pc;
function Lo() {
  return pc || (pc = 1, Bn = Function.prototype.apply), Bn;
}
var zn, mc;
function S1() {
  return mc || (mc = 1, zn = typeof Reflect < "u" && Reflect && Reflect.apply), zn;
}
var jn, gc;
function Xl() {
  if (gc) return jn;
  gc = 1;
  var e = Jt(), t = Lo(), r = _o(), n = S1();
  return jn = n || e.call(r, t), jn;
}
var qn, vc;
function Do() {
  if (vc) return qn;
  vc = 1;
  var e = Jt(), t = /* @__PURE__ */ Re(), r = _o(), n = Xl();
  return qn = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new t("a function is required");
    return n(e, r, o);
  }, qn;
}
var Fn, xc;
function A1() {
  if (xc) return Fn;
  xc = 1;
  var e = Do(), t = /* @__PURE__ */ pt(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (a) {
    if (!a || typeof a != "object" || !("code" in a) || a.code !== "ERR_PROTO_ACCESS")
      throw a;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, o = i.getPrototypeOf;
  return Fn = n && typeof n.get == "function" ? e([n.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(c) {
      return o(c == null ? c : i(c));
    }
  ) : !1, Fn;
}
var Hn, yc;
function Yl() {
  if (yc) return Hn;
  yc = 1;
  var e = Gl(), t = Vl(), r = /* @__PURE__ */ A1();
  return Hn = e ? function(i) {
    return e(i);
  } : t ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return t(i);
  } : r ? function(i) {
    return r(i);
  } : null, Hn;
}
var Un, bc;
function Bo() {
  if (bc) return Un;
  bc = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Jt();
  return Un = r.call(e, t), Un;
}
var Wn, wc;
function Ye() {
  if (wc) return Wn;
  wc = 1;
  var e, t = /* @__PURE__ */ $o(), r = /* @__PURE__ */ Wl(), n = /* @__PURE__ */ l1(), i = /* @__PURE__ */ u1(), o = /* @__PURE__ */ d1(), a = /* @__PURE__ */ No(), c = /* @__PURE__ */ Re(), l = /* @__PURE__ */ f1(), u = /* @__PURE__ */ h1(), f = /* @__PURE__ */ p1(), d = /* @__PURE__ */ m1(), h = /* @__PURE__ */ g1(), p = /* @__PURE__ */ v1(), m = /* @__PURE__ */ x1(), g = /* @__PURE__ */ b1(), y = Function, w = function(K) {
    try {
      return y('"use strict"; return (' + K + ").constructor;")();
    } catch {
    }
  }, S = /* @__PURE__ */ pt(), b = /* @__PURE__ */ kr(), A = function() {
    throw new c();
  }, R = S ? function() {
    try {
      return arguments.callee, A;
    } catch {
      try {
        return S(arguments, "callee").get;
      } catch {
        return A;
      }
    }
  }() : A, M = ko()(), E = Yl(), O = Vl(), C = Gl(), k = Lo(), P = _o(), N = {}, L = typeof Uint8Array > "u" || !E ? e : E(Uint8Array), _ = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": M && E ? E([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": N,
    "%AsyncGenerator%": N,
    "%AsyncGeneratorFunction%": N,
    "%AsyncIteratorPrototype%": N,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": y,
    "%GeneratorFunction%": N,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": M && E ? E(E([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !M || !E ? e : E((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": S,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !M || !E ? e : E((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": M && E ? E(""[Symbol.iterator]()) : e,
    "%Symbol%": M ? Symbol : e,
    "%SyntaxError%": a,
    "%ThrowTypeError%": R,
    "%TypedArray%": L,
    "%TypeError%": c,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": P,
    "%Function.prototype.apply%": k,
    "%Object.defineProperty%": b,
    "%Object.getPrototypeOf%": O,
    "%Math.abs%": u,
    "%Math.floor%": f,
    "%Math.max%": d,
    "%Math.min%": h,
    "%Math.pow%": p,
    "%Math.round%": m,
    "%Math.sign%": g,
    "%Reflect.getPrototypeOf%": C
  };
  if (E)
    try {
      null.error;
    } catch (K) {
      var G = E(E(K));
      _["%Error.prototype%"] = G;
    }
  var ee = function K(B) {
    var z;
    if (B === "%AsyncFunction%")
      z = w("async function () {}");
    else if (B === "%GeneratorFunction%")
      z = w("function* () {}");
    else if (B === "%AsyncGeneratorFunction%")
      z = w("async function* () {}");
    else if (B === "%AsyncGenerator%") {
      var D = K("%AsyncGeneratorFunction%");
      D && (z = D.prototype);
    } else if (B === "%AsyncIteratorPrototype%") {
      var U = K("%AsyncGenerator%");
      U && E && (z = E(U.prototype));
    }
    return _[B] = z, z;
  }, se = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, re = Jt(), J = /* @__PURE__ */ Bo(), ge = re.call(P, Array.prototype.concat), fe = re.call(k, Array.prototype.splice), Ke = re.call(P, String.prototype.replace), Ne = re.call(P, String.prototype.slice), I = re.call(P, RegExp.prototype.exec), $ = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, F = /\\(\\)?/g, j = function(B) {
    var z = Ne(B, 0, 1), D = Ne(B, -1);
    if (z === "%" && D !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (D === "%" && z !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var U = [];
    return Ke(B, $, function(ue, he, pe, ve) {
      U[U.length] = pe ? Ke(ve, F, "$1") : he || ue;
    }), U;
  }, V = function(B, z) {
    var D = B, U;
    if (J(se, D) && (U = se[D], D = "%" + U[0] + "%"), J(_, D)) {
      var ue = _[D];
      if (ue === N && (ue = ee(D)), typeof ue > "u" && !z)
        throw new c("intrinsic " + B + " exists, but is not available. Please file an issue!");
      return {
        alias: U,
        name: D,
        value: ue
      };
    }
    throw new a("intrinsic " + B + " does not exist!");
  };
  return Wn = function(B, z) {
    if (typeof B != "string" || B.length === 0)
      throw new c("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof z != "boolean")
      throw new c('"allowMissing" argument must be a boolean');
    if (I(/^%?[^%]*%?$/, B) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var D = j(B), U = D.length > 0 ? D[0] : "", ue = V("%" + U + "%", z), he = ue.name, pe = ue.value, ve = !1, Ae = ue.alias;
    Ae && (U = Ae[0], fe(D, ge([0, 1], Ae)));
    for (var ze = 1, Me = !0; ze < D.length; ze += 1) {
      var Ce = D[ze], je = Ne(Ce, 0, 1), qe = Ne(Ce, -1);
      if ((je === '"' || je === "'" || je === "`" || qe === '"' || qe === "'" || qe === "`") && je !== qe)
        throw new a("property names with quotes must have matching quotes");
      if ((Ce === "constructor" || !Me) && (ve = !0), U += "." + Ce, he = "%" + U + "%", J(_, he))
        pe = _[he];
      else if (pe != null) {
        if (!(Ce in pe)) {
          if (!z)
            throw new c("base intrinsic for " + B + " exists, but the property is not available.");
          return;
        }
        if (S && ze + 1 >= D.length) {
          var Fe = S(pe, Ce);
          Me = !!Fe, Me && "get" in Fe && !("originalValue" in Fe.get) ? pe = Fe.get : pe = pe[Ce];
        } else
          Me = J(pe, Ce), pe = pe[Ce];
        Me && !ve && (_[he] = pe);
      }
    }
    return pe;
  }, Wn;
}
var Gn, Sc;
function C1() {
  if (Sc) return Gn;
  Sc = 1;
  var e = /* @__PURE__ */ Ye(), t = /* @__PURE__ */ Mo(), r = /* @__PURE__ */ Eo()(), n = /* @__PURE__ */ pt(), i = /* @__PURE__ */ Re(), o = e("%Math.floor%");
  return Gn = function(c, l) {
    if (typeof c != "function")
      throw new i("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || o(l) !== l)
      throw new i("`length` must be a positive 32-bit integer");
    var u = arguments.length > 2 && !!arguments[2], f = !0, d = !0;
    if ("length" in c && n) {
      var h = n(c, "length");
      h && !h.configurable && (f = !1), h && !h.writable && (d = !1);
    }
    return (f || d || !u) && (r ? t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      l,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      l
    )), c;
  }, Gn;
}
var Vn, Ac;
function I1() {
  if (Ac) return Vn;
  Ac = 1;
  var e = Jt(), t = Lo(), r = Xl();
  return Vn = function() {
    return r(e, t, arguments);
  }, Vn;
}
var Cc;
function Ot() {
  return Cc || (Cc = 1, function(e) {
    var t = /* @__PURE__ */ C1(), r = /* @__PURE__ */ kr(), n = Do(), i = I1();
    e.exports = function(a) {
      var c = n(arguments), l = a.length - (arguments.length - 1);
      return t(
        c,
        1 + (l > 0 ? l : 0),
        !0
      );
    }, r ? r(e.exports, "apply", { value: i }) : e.exports.apply = i;
  }(gn)), gn.exports;
}
var Xn, Ic;
function Se() {
  if (Ic) return Xn;
  Ic = 1;
  var e = /* @__PURE__ */ Ye(), t = Do(), r = t([e("%String.prototype.indexOf%")]);
  return Xn = function(i, o) {
    var a = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      e(i, !!o)
    );
    return typeof a == "function" && r(i, ".prototype.") > -1 ? t([a]) : a;
  }, Xn;
}
var Yn, Tc;
function Kl() {
  if (Tc) return Yn;
  Tc = 1;
  var e = Ro(), t = _r()(), r = /* @__PURE__ */ Se(), n = /* @__PURE__ */ $o(), i = r("Array.prototype.push"), o = r("Object.prototype.propertyIsEnumerable"), a = t ? n.getOwnPropertySymbols : null;
  return Yn = function(l, u) {
    if (l == null)
      throw new TypeError("target must be an object");
    var f = n(l);
    if (arguments.length === 1)
      return f;
    for (var d = 1; d < arguments.length; ++d) {
      var h = n(arguments[d]), p = e(h), m = t && (n.getOwnPropertySymbols || a);
      if (m)
        for (var g = m(h), y = 0; y < g.length; ++y) {
          var w = g[y];
          o(h, w) && i(p, w);
        }
      for (var S = 0; S < p.length; ++S) {
        var b = p[S];
        if (o(h, b)) {
          var A = h[b];
          f[b] = A;
        }
      }
    }
    return f;
  }, Yn;
}
var Kn, Oc;
function Jl() {
  if (Oc) return Kn;
  Oc = 1;
  var e = Kl(), t = function() {
    if (!Object.assign)
      return !1;
    for (var n = "abcdefghijklmnopqrst", i = n.split(""), o = {}, a = 0; a < i.length; ++a)
      o[i[a]] = i[a];
    var c = Object.assign({}, o), l = "";
    for (var u in c)
      l += u;
    return n !== l;
  }, r = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var n = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(n, "xy");
    } catch {
      return n[1] === "y";
    }
    return !1;
  };
  return Kn = function() {
    return !Object.assign || t() || r() ? e : Object.assign;
  }, Kn;
}
var Jn, Pc;
function T1() {
  if (Pc) return Jn;
  Pc = 1;
  var e = mt(), t = Jl();
  return Jn = function() {
    var n = t();
    return e(
      Object,
      { assign: n },
      { assign: function() {
        return Object.assign !== n;
      } }
    ), n;
  }, Jn;
}
var Zn, Rc;
function O1() {
  if (Rc) return Zn;
  Rc = 1;
  var e = mt(), t = Ot(), r = Kl(), n = Jl(), i = T1(), o = t.apply(n()), a = function(l, u) {
    return o(Object, arguments);
  };
  return e(a, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), Zn = a, Zn;
}
var Qn, Nc;
function Zl() {
  if (Nc) return Qn;
  Nc = 1;
  var e = /* @__PURE__ */ Ye(), t = Ot(), r = t(e("String.prototype.indexOf"));
  return Qn = function(i, o) {
    var a = e(i, !!o);
    return typeof a == "function" && r(i, ".prototype.") > -1 ? t(a) : a;
  }, Qn;
}
var ei, Mc;
function P1() {
  if (Mc) return ei;
  Mc = 1;
  var e = function() {
    return typeof (function() {
    }).name == "string";
  }, t = Object.getOwnPropertyDescriptor;
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  e.functionsHaveConfigurableNames = function() {
    if (!e() || !t)
      return !1;
    var i = t(function() {
    }, "name");
    return !!i && !!i.configurable;
  };
  var r = Function.prototype.bind;
  return e.boundFunctionsHaveNames = function() {
    return e() && typeof r == "function" && (function() {
    }).bind().name !== "";
  }, ei = e, ei;
}
var ti, Ec;
function R1() {
  if (Ec) return ti;
  Ec = 1;
  var e = /* @__PURE__ */ Mo(), t = /* @__PURE__ */ Eo()(), r = P1().functionsHaveConfigurableNames(), n = /* @__PURE__ */ Re();
  return ti = function(o, a) {
    if (typeof o != "function")
      throw new n("`fn` is not a function");
    var c = arguments.length > 2 && !!arguments[2];
    return (!c || r) && (t ? e(
      /** @type {Parameters<define>[0]} */
      o,
      "name",
      a,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      o,
      "name",
      a
    )), o;
  }, ti;
}
var ri, $c;
function Ql() {
  if ($c) return ri;
  $c = 1;
  var e = R1(), t = /* @__PURE__ */ Re(), r = Object;
  return ri = e(function() {
    if (this == null || this !== r(this))
      throw new t("RegExp.prototype.flags getter called on non-object");
    var i = "";
    return this.hasIndices && (i += "d"), this.global && (i += "g"), this.ignoreCase && (i += "i"), this.multiline && (i += "m"), this.dotAll && (i += "s"), this.unicode && (i += "u"), this.unicodeSets && (i += "v"), this.sticky && (i += "y"), i;
  }, "get flags", !0), ri;
}
var ni, kc;
function eu() {
  if (kc) return ni;
  kc = 1;
  var e = Ql(), t = mt().supportsDescriptors, r = Object.getOwnPropertyDescriptor;
  return ni = function() {
    if (t && /a/mig.flags === "gim") {
      var i = r(RegExp.prototype, "flags");
      if (i && typeof i.get == "function" && "dotAll" in RegExp.prototype && "hasIndices" in RegExp.prototype) {
        var o = "", a = {};
        if (Object.defineProperty(a, "hasIndices", {
          get: function() {
            o += "d";
          }
        }), Object.defineProperty(a, "sticky", {
          get: function() {
            o += "y";
          }
        }), i.get.call(a), o === "dy")
          return i.get;
      }
    }
    return e;
  }, ni;
}
var ii, _c;
function N1() {
  if (_c) return ii;
  _c = 1;
  var e = mt().supportsDescriptors, t = eu(), r = /* @__PURE__ */ pt(), n = Object.defineProperty, i = /* @__PURE__ */ Wl(), o = Yl(), a = /a/;
  return ii = function() {
    if (!e || !o)
      throw new i("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var l = t(), u = o(a), f = r(u, "flags");
    return (!f || f.get !== l) && n(u, "flags", {
      configurable: !0,
      enumerable: !1,
      get: l
    }), l;
  }, ii;
}
var oi, Lc;
function M1() {
  if (Lc) return oi;
  Lc = 1;
  var e = mt(), t = Ot(), r = Ql(), n = eu(), i = N1(), o = t(n());
  return e(o, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), oi = o, oi;
}
var $t = { exports: {} }, ai, Dc;
function gt() {
  if (Dc) return ai;
  Dc = 1;
  var e = _r();
  return ai = function() {
    return e() && !!Symbol.toStringTag;
  }, ai;
}
var ci, Bc;
function tu() {
  if (Bc) return ci;
  Bc = 1;
  var e = gt()(), t = /* @__PURE__ */ Se(), r = t("Object.prototype.toString"), n = function(c) {
    return e && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : r(c) === "[object Arguments]";
  }, i = function(c) {
    return n(c) ? !0 : c !== null && typeof c == "object" && "length" in c && typeof c.length == "number" && c.length >= 0 && r(c) !== "[object Array]" && "callee" in c && r(c.callee) === "[object Function]";
  }, o = function() {
    return n(arguments);
  }();
  return n.isLegacyArguments = i, ci = o ? n : i, ci;
}
const E1 = {}, $1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E1
}, Symbol.toStringTag, { value: "Module" })), k1 = /* @__PURE__ */ a1($1);
var si, zc;
function Lr() {
  if (zc) return si;
  zc = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, o = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, a = i && o && typeof o.get == "function" ? o.get : null, c = i && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, u = l ? WeakMap.prototype.has : null, f = typeof WeakSet == "function" && WeakSet.prototype, d = f ? WeakSet.prototype.has : null, h = typeof WeakRef == "function" && WeakRef.prototype, p = h ? WeakRef.prototype.deref : null, m = Boolean.prototype.valueOf, g = Object.prototype.toString, y = Function.prototype.toString, w = String.prototype.match, S = String.prototype.slice, b = String.prototype.replace, A = String.prototype.toUpperCase, R = String.prototype.toLowerCase, M = RegExp.prototype.test, E = Array.prototype.concat, O = Array.prototype.join, C = Array.prototype.slice, k = Math.floor, P = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, _ = typeof Symbol == "function" && typeof Symbol.iterator == "object", G = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === _ || !0) ? Symbol.toStringTag : null, ee = Object.prototype.propertyIsEnumerable, se = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(v) {
    return v.__proto__;
  } : null);
  function re(v, x) {
    if (v === 1 / 0 || v === -1 / 0 || v !== v || v && v > -1e3 && v < 1e3 || M.call(/e/, x))
      return x;
    var Q = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof v == "number") {
      var ne = v < 0 ? -k(-v) : k(v);
      if (ne !== v) {
        var ie = String(ne), W = S.call(x, ie.length + 1);
        return b.call(ie, Q, "$&_") + "." + b.call(b.call(W, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return b.call(x, Q, "$&_");
  }
  var J = k1, ge = J.custom, fe = ue(ge) ? ge : null, Ke = {
    __proto__: null,
    double: '"',
    single: "'"
  }, Ne = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  si = function v(x, Q, ne, ie) {
    var W = Q || {};
    if (ve(W, "quoteStyle") && !ve(Ke, W.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ve(W, "maxStringLength") && (typeof W.maxStringLength == "number" ? W.maxStringLength < 0 && W.maxStringLength !== 1 / 0 : W.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Qe = ve(W, "customInspect") ? W.customInspect : !0;
    if (typeof Qe != "boolean" && Qe !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ve(W, "indent") && W.indent !== null && W.indent !== "	" && !(parseInt(W.indent, 10) === W.indent && W.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ve(W, "numericSeparator") && typeof W.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var st = W.numericSeparator;
    if (typeof x > "u")
      return "undefined";
    if (x === null)
      return "null";
    if (typeof x == "boolean")
      return x ? "true" : "false";
    if (typeof x == "string")
      return vt(x, W);
    if (typeof x == "number") {
      if (x === 0)
        return 1 / 0 / x > 0 ? "0" : "-0";
      var Ie = String(x);
      return st ? re(x, Ie) : Ie;
    }
    if (typeof x == "bigint") {
      var et = String(x) + "n";
      return st ? re(x, et) : et;
    }
    var zr = typeof W.depth > "u" ? 5 : W.depth;
    if (typeof ne > "u" && (ne = 0), ne >= zr && zr > 0 && typeof x == "object")
      return j(x) ? "[Array]" : "[Object]";
    var xt = vu(W, ne);
    if (typeof ie > "u")
      ie = [];
    else if (Me(ie, x) >= 0)
      return "[Circular]";
    function Ee(yt, tr, yu) {
      if (tr && (ie = C.call(ie), ie.push(tr)), yu) {
        var Xo = {
          depth: W.depth
        };
        return ve(W, "quoteStyle") && (Xo.quoteStyle = W.quoteStyle), v(yt, Xo, ne + 1, ie);
      }
      return v(yt, W, ne + 1, ie);
    }
    if (typeof x == "function" && !K(x)) {
      var qo = ze(x), Fo = Qt(x, Ee);
      return "[Function" + (qo ? ": " + qo : " (anonymous)") + "]" + (Fo.length > 0 ? " { " + O.call(Fo, ", ") + " }" : "");
    }
    if (ue(x)) {
      var Ho = _ ? b.call(String(x), /^(Symbol\(.*\))_[^)]*$/, "$1") : L.call(x);
      return typeof x == "object" && !_ ? Ze(Ho) : Ho;
    }
    if (Je(x)) {
      for (var Rt = "<" + R.call(String(x.nodeName)), jr = x.attributes || [], er = 0; er < jr.length; er++)
        Rt += " " + jr[er].name + "=" + I($(jr[er].value), "double", W);
      return Rt += ">", x.childNodes && x.childNodes.length && (Rt += "..."), Rt += "</" + R.call(String(x.nodeName)) + ">", Rt;
    }
    if (j(x)) {
      if (x.length === 0)
        return "[]";
      var qr = Qt(x, Ee);
      return xt && !gu(qr) ? "[" + Br(qr, xt) + "]" : "[ " + O.call(qr, ", ") + " ]";
    }
    if (B(x)) {
      var Fr = Qt(x, Ee);
      return !("cause" in Error.prototype) && "cause" in x && !ee.call(x, "cause") ? "{ [" + String(x) + "] " + O.call(E.call("[cause]: " + Ee(x.cause), Fr), ", ") + " }" : Fr.length === 0 ? "[" + String(x) + "]" : "{ [" + String(x) + "] " + O.call(Fr, ", ") + " }";
    }
    if (typeof x == "object" && Qe) {
      if (fe && typeof x[fe] == "function" && J)
        return J(x, { depth: zr - ne });
      if (Qe !== "symbol" && typeof x.inspect == "function")
        return x.inspect();
    }
    if (Ce(x)) {
      var Uo = [];
      return n && n.call(x, function(yt, tr) {
        Uo.push(Ee(tr, x, !0) + " => " + Ee(yt, x));
      }), jo("Map", r.call(x), Uo, xt);
    }
    if (Fe(x)) {
      var Wo = [];
      return c && c.call(x, function(yt) {
        Wo.push(Ee(yt, x));
      }), jo("Set", a.call(x), Wo, xt);
    }
    if (je(x))
      return Dr("WeakMap");
    if (Zt(x))
      return Dr("WeakSet");
    if (qe(x))
      return Dr("WeakRef");
    if (D(x))
      return Ze(Ee(Number(x)));
    if (he(x))
      return Ze(Ee(P.call(x)));
    if (U(x))
      return Ze(m.call(x));
    if (z(x))
      return Ze(Ee(String(x)));
    if (typeof window < "u" && x === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && x === globalThis || typeof Sr < "u" && x === Sr)
      return "{ [object globalThis] }";
    if (!V(x) && !K(x)) {
      var Hr = Qt(x, Ee), Go = se ? se(x) === Object.prototype : x instanceof Object || x.constructor === Object, Ur = x instanceof Object ? "" : "null prototype", Vo = !Go && G && Object(x) === x && G in x ? S.call(Ae(x), 8, -1) : Ur ? "Object" : "", xu = Go || typeof x.constructor != "function" ? "" : x.constructor.name ? x.constructor.name + " " : "", Wr = xu + (Vo || Ur ? "[" + O.call(E.call([], Vo || [], Ur || []), ": ") + "] " : "");
      return Hr.length === 0 ? Wr + "{}" : xt ? Wr + "{" + Br(Hr, xt) + "}" : Wr + "{ " + O.call(Hr, ", ") + " }";
    }
    return String(x);
  };
  function I(v, x, Q) {
    var ne = Q.quoteStyle || x, ie = Ke[ne];
    return ie + v + ie;
  }
  function $(v) {
    return b.call(String(v), /"/g, "&quot;");
  }
  function F(v) {
    return !G || !(typeof v == "object" && (G in v || typeof v[G] < "u"));
  }
  function j(v) {
    return Ae(v) === "[object Array]" && F(v);
  }
  function V(v) {
    return Ae(v) === "[object Date]" && F(v);
  }
  function K(v) {
    return Ae(v) === "[object RegExp]" && F(v);
  }
  function B(v) {
    return Ae(v) === "[object Error]" && F(v);
  }
  function z(v) {
    return Ae(v) === "[object String]" && F(v);
  }
  function D(v) {
    return Ae(v) === "[object Number]" && F(v);
  }
  function U(v) {
    return Ae(v) === "[object Boolean]" && F(v);
  }
  function ue(v) {
    if (_)
      return v && typeof v == "object" && v instanceof Symbol;
    if (typeof v == "symbol")
      return !0;
    if (!v || typeof v != "object" || !L)
      return !1;
    try {
      return L.call(v), !0;
    } catch {
    }
    return !1;
  }
  function he(v) {
    if (!v || typeof v != "object" || !P)
      return !1;
    try {
      return P.call(v), !0;
    } catch {
    }
    return !1;
  }
  var pe = Object.prototype.hasOwnProperty || function(v) {
    return v in this;
  };
  function ve(v, x) {
    return pe.call(v, x);
  }
  function Ae(v) {
    return g.call(v);
  }
  function ze(v) {
    if (v.name)
      return v.name;
    var x = w.call(y.call(v), /^function\s*([\w$]+)/);
    return x ? x[1] : null;
  }
  function Me(v, x) {
    if (v.indexOf)
      return v.indexOf(x);
    for (var Q = 0, ne = v.length; Q < ne; Q++)
      if (v[Q] === x)
        return Q;
    return -1;
  }
  function Ce(v) {
    if (!r || !v || typeof v != "object")
      return !1;
    try {
      r.call(v);
      try {
        a.call(v);
      } catch {
        return !0;
      }
      return v instanceof Map;
    } catch {
    }
    return !1;
  }
  function je(v) {
    if (!u || !v || typeof v != "object")
      return !1;
    try {
      u.call(v, u);
      try {
        d.call(v, d);
      } catch {
        return !0;
      }
      return v instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function qe(v) {
    if (!p || !v || typeof v != "object")
      return !1;
    try {
      return p.call(v), !0;
    } catch {
    }
    return !1;
  }
  function Fe(v) {
    if (!a || !v || typeof v != "object")
      return !1;
    try {
      a.call(v);
      try {
        r.call(v);
      } catch {
        return !0;
      }
      return v instanceof Set;
    } catch {
    }
    return !1;
  }
  function Zt(v) {
    if (!d || !v || typeof v != "object")
      return !1;
    try {
      d.call(v, d);
      try {
        u.call(v, u);
      } catch {
        return !0;
      }
      return v instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Je(v) {
    return !v || typeof v != "object" ? !1 : typeof HTMLElement < "u" && v instanceof HTMLElement ? !0 : typeof v.nodeName == "string" && typeof v.getAttribute == "function";
  }
  function vt(v, x) {
    if (v.length > x.maxStringLength) {
      var Q = v.length - x.maxStringLength, ne = "... " + Q + " more character" + (Q > 1 ? "s" : "");
      return vt(S.call(v, 0, x.maxStringLength), x) + ne;
    }
    var ie = Ne[x.quoteStyle || "single"];
    ie.lastIndex = 0;
    var W = b.call(b.call(v, ie, "\\$1"), /[\x00-\x1f]/g, Pt);
    return I(W, "single", x);
  }
  function Pt(v) {
    var x = v.charCodeAt(0), Q = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[x];
    return Q ? "\\" + Q : "\\x" + (x < 16 ? "0" : "") + A.call(x.toString(16));
  }
  function Ze(v) {
    return "Object(" + v + ")";
  }
  function Dr(v) {
    return v + " { ? }";
  }
  function jo(v, x, Q, ne) {
    var ie = ne ? Br(Q, ne) : O.call(Q, ", ");
    return v + " (" + x + ") {" + ie + "}";
  }
  function gu(v) {
    for (var x = 0; x < v.length; x++)
      if (Me(v[x], `
`) >= 0)
        return !1;
    return !0;
  }
  function vu(v, x) {
    var Q;
    if (v.indent === "	")
      Q = "	";
    else if (typeof v.indent == "number" && v.indent > 0)
      Q = O.call(Array(v.indent + 1), " ");
    else
      return null;
    return {
      base: Q,
      prev: O.call(Array(x + 1), Q)
    };
  }
  function Br(v, x) {
    if (v.length === 0)
      return "";
    var Q = `
` + x.prev + x.base;
    return Q + O.call(v, "," + Q) + `
` + x.prev;
  }
  function Qt(v, x) {
    var Q = j(v), ne = [];
    if (Q) {
      ne.length = v.length;
      for (var ie = 0; ie < v.length; ie++)
        ne[ie] = ve(v, ie) ? x(v[ie], v) : "";
    }
    var W = typeof N == "function" ? N(v) : [], Qe;
    if (_) {
      Qe = {};
      for (var st = 0; st < W.length; st++)
        Qe["$" + W[st]] = W[st];
    }
    for (var Ie in v)
      ve(v, Ie) && (Q && String(Number(Ie)) === Ie && Ie < v.length || _ && Qe["$" + Ie] instanceof Symbol || (M.call(/[^\w$]/, Ie) ? ne.push(x(Ie, v) + ": " + x(v[Ie], v)) : ne.push(Ie + ": " + x(v[Ie], v))));
    if (typeof N == "function")
      for (var et = 0; et < W.length; et++)
        ee.call(v, W[et]) && ne.push("[" + x(W[et]) + "]: " + x(v[W[et]], v));
    return ne;
  }
  return si;
}
var li, jc;
function _1() {
  if (jc) return li;
  jc = 1;
  var e = /* @__PURE__ */ Lr(), t = /* @__PURE__ */ Re(), r = function(c, l, u) {
    for (var f = c, d; (d = f.next) != null; f = d)
      if (d.key === l)
        return f.next = d.next, u || (d.next = /** @type {NonNullable<typeof list.next>} */
        c.next, c.next = d), d;
  }, n = function(c, l) {
    if (c) {
      var u = r(c, l);
      return u && u.value;
    }
  }, i = function(c, l, u) {
    var f = r(c, l);
    f ? f.value = u : c.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: c.next,
      value: u
    };
  }, o = function(c, l) {
    return c ? !!r(c, l) : !1;
  }, a = function(c, l) {
    if (c)
      return r(c, l, !0);
  };
  return li = function() {
    var l, u = {
      assert: function(f) {
        if (!u.has(f))
          throw new t("Side channel does not contain " + e(f));
      },
      delete: function(f) {
        var d = l && l.next, h = a(l, f);
        return h && d && d === h && (l = void 0), !!h;
      },
      get: function(f) {
        return n(l, f);
      },
      has: function(f) {
        return o(l, f);
      },
      set: function(f, d) {
        l || (l = {
          next: void 0
        }), i(
          /** @type {NonNullable<typeof $o>} */
          l,
          f,
          d
        );
      }
    };
    return u;
  }, li;
}
var ui, qc;
function ru() {
  if (qc) return ui;
  qc = 1;
  var e = /* @__PURE__ */ Ye(), t = /* @__PURE__ */ Se(), r = /* @__PURE__ */ Lr(), n = /* @__PURE__ */ Re(), i = e("%Map%", !0), o = t("Map.prototype.get", !0), a = t("Map.prototype.set", !0), c = t("Map.prototype.has", !0), l = t("Map.prototype.delete", !0), u = t("Map.prototype.size", !0);
  return ui = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var d, h = {
      assert: function(p) {
        if (!h.has(p))
          throw new n("Side channel does not contain " + r(p));
      },
      delete: function(p) {
        if (d) {
          var m = l(d, p);
          return u(d) === 0 && (d = void 0), m;
        }
        return !1;
      },
      get: function(p) {
        if (d)
          return o(d, p);
      },
      has: function(p) {
        return d ? c(d, p) : !1;
      },
      set: function(p, m) {
        d || (d = new i()), a(d, p, m);
      }
    };
    return h;
  }, ui;
}
var di, Fc;
function L1() {
  if (Fc) return di;
  Fc = 1;
  var e = /* @__PURE__ */ Ye(), t = /* @__PURE__ */ Se(), r = /* @__PURE__ */ Lr(), n = ru(), i = /* @__PURE__ */ Re(), o = e("%WeakMap%", !0), a = t("WeakMap.prototype.get", !0), c = t("WeakMap.prototype.set", !0), l = t("WeakMap.prototype.has", !0), u = t("WeakMap.prototype.delete", !0);
  return di = o ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var d, h, p = {
        assert: function(m) {
          if (!p.has(m))
            throw new i("Side channel does not contain " + r(m));
        },
        delete: function(m) {
          if (o && m && (typeof m == "object" || typeof m == "function")) {
            if (d)
              return u(d, m);
          } else if (n && h)
            return h.delete(m);
          return !1;
        },
        get: function(m) {
          return o && m && (typeof m == "object" || typeof m == "function") && d ? a(d, m) : h && h.get(m);
        },
        has: function(m) {
          return o && m && (typeof m == "object" || typeof m == "function") && d ? l(d, m) : !!h && h.has(m);
        },
        set: function(m, g) {
          o && m && (typeof m == "object" || typeof m == "function") ? (d || (d = new o()), c(d, m, g)) : n && (h || (h = n()), h.set(m, g));
        }
      };
      return p;
    }
  ) : n, di;
}
var fi, Hc;
function nu() {
  if (Hc) return fi;
  Hc = 1;
  var e = /* @__PURE__ */ Re(), t = /* @__PURE__ */ Lr(), r = _1(), n = ru(), i = L1(), o = i || n || r;
  return fi = function() {
    var c, l = {
      assert: function(u) {
        if (!l.has(u))
          throw new e("Side channel does not contain " + t(u));
      },
      delete: function(u) {
        return !!c && c.delete(u);
      },
      get: function(u) {
        return c && c.get(u);
      },
      has: function(u) {
        return !!c && c.has(u);
      },
      set: function(u, f) {
        c || (c = o()), c.set(u, f);
      }
    };
    return l;
  }, fi;
}
var hi, Uc;
function D1() {
  if (Uc) return hi;
  Uc = 1;
  var e = /* @__PURE__ */ Bo(), t = nu()(), r = /* @__PURE__ */ Re(), n = {
    assert: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new r("`O` is not an object");
      if (typeof o != "string")
        throw new r("`slot` must be a string");
      if (t.assert(i), !n.has(i, o))
        throw new r("`" + o + "` is not present on `O`");
    },
    get: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new r("`O` is not an object");
      if (typeof o != "string")
        throw new r("`slot` must be a string");
      var a = t.get(i);
      return a && a[
        /** @type {SaltedInternalSlot} */
        "$" + o
      ];
    },
    has: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new r("`O` is not an object");
      if (typeof o != "string")
        throw new r("`slot` must be a string");
      var a = t.get(i);
      return !!a && e(
        a,
        /** @type {SaltedInternalSlot} */
        "$" + o
      );
    },
    set: function(i, o, a) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new r("`O` is not an object");
      if (typeof o != "string")
        throw new r("`slot` must be a string");
      var c = t.get(i);
      c || (c = {}, t.set(i, c)), c[
        /** @type {SaltedInternalSlot} */
        "$" + o
      ] = a;
    }
  };
  return Object.freeze && Object.freeze(n), hi = n, hi;
}
var pi, Wc;
function B1() {
  if (Wc) return pi;
  Wc = 1;
  var e = D1(), t = /* @__PURE__ */ No(), r = typeof StopIteration == "object" ? StopIteration : null;
  return pi = function(i) {
    if (!r)
      throw new t("this environment lacks StopIteration");
    e.set(i, "[[Done]]", !1);
    var o = {
      next: (
        /** @type {() => IteratorResult<T>} */
        function() {
          var c = (
            /** @type {typeof origIterator} */
            e.get(this, "[[Iterator]]")
          ), l = !!e.get(c, "[[Done]]");
          try {
            return {
              done: l,
              // eslint-disable-next-line no-extra-parens
              value: l ? void 0 : (
                /** @type {T} */
                c.next()
              )
            };
          } catch (u) {
            if (e.set(c, "[[Done]]", !0), u !== r)
              throw u;
            return {
              done: !0,
              value: void 0
            };
          }
        }
      )
    };
    return e.set(o, "[[Iterator]]", i), o;
  }, pi;
}
var mi, Gc;
function iu() {
  if (Gc) return mi;
  Gc = 1;
  var e = {}.toString;
  return mi = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, mi;
}
var gi, Vc;
function ou() {
  if (Vc) return gi;
  Vc = 1;
  var e = /* @__PURE__ */ Se(), t = e("String.prototype.valueOf"), r = function(c) {
    try {
      return t(c), !0;
    } catch {
      return !1;
    }
  }, n = e("Object.prototype.toString"), i = "[object String]", o = gt()();
  return gi = function(c) {
    return typeof c == "string" ? !0 : !c || typeof c != "object" ? !1 : o ? r(c) : n(c) === i;
  }, gi;
}
var vi, Xc;
function au() {
  if (Xc) return vi;
  Xc = 1;
  var e = typeof Map == "function" && Map.prototype ? Map : null, t = typeof Set == "function" && Set.prototype ? Set : null, r;
  e || (r = function(a) {
    return !1;
  });
  var n = e ? Map.prototype.has : null, i = t ? Set.prototype.has : null;
  return !r && !n && (r = function(a) {
    return !1;
  }), vi = r || function(a) {
    if (!a || typeof a != "object")
      return !1;
    try {
      if (n.call(a), i)
        try {
          i.call(a);
        } catch {
          return !0;
        }
      return a instanceof e;
    } catch {
    }
    return !1;
  }, vi;
}
var xi, Yc;
function cu() {
  if (Yc) return xi;
  Yc = 1;
  var e = typeof Map == "function" && Map.prototype ? Map : null, t = typeof Set == "function" && Set.prototype ? Set : null, r;
  t || (r = function(a) {
    return !1;
  });
  var n = e ? Map.prototype.has : null, i = t ? Set.prototype.has : null;
  return !r && !i && (r = function(a) {
    return !1;
  }), xi = r || function(a) {
    if (!a || typeof a != "object")
      return !1;
    try {
      if (i.call(a), n)
        try {
          n.call(a);
        } catch {
          return !0;
        }
      return a instanceof t;
    } catch {
    }
    return !1;
  }, xi;
}
var Kc;
function z1() {
  if (Kc) return $t.exports;
  Kc = 1;
  var e = /* @__PURE__ */ tu(), t = /* @__PURE__ */ B1();
  if (ko()() || _r()()) {
    var r = Symbol.iterator;
    $t.exports = function(C) {
      if (C != null && typeof C[r] < "u")
        return C[r]();
      if (e(C))
        return Array.prototype[r].call(C);
    };
  } else {
    var n = iu(), i = ou(), o = /* @__PURE__ */ Ye(), a = o("%Map%", !0), c = o("%Set%", !0), l = Zl(), u = l("Array.prototype.push"), f = l("String.prototype.charCodeAt"), d = l("String.prototype.slice"), h = function(C, k) {
      var P = C.length;
      if (k + 1 >= P)
        return k + 1;
      var N = f(C, k);
      if (N < 55296 || N > 56319)
        return k + 1;
      var L = f(C, k + 1);
      return L < 56320 || L > 57343 ? k + 1 : k + 2;
    }, p = function(C) {
      var k = 0;
      return {
        next: function() {
          var N = k >= C.length, L;
          return N || (L = C[k], k += 1), {
            done: N,
            value: L
          };
        }
      };
    }, m = function(C, k) {
      if (n(C) || e(C))
        return p(C);
      if (i(C)) {
        var P = 0;
        return {
          next: function() {
            var L = h(C, P), _ = d(C, P, L);
            return P = L, {
              done: L > C.length,
              value: _
            };
          }
        };
      }
      if (k && typeof C["_es6-shim iterator_"] < "u")
        return C["_es6-shim iterator_"]();
    };
    if (!a && !c)
      $t.exports = function(C) {
        if (C != null)
          return m(C, !0);
      };
    else {
      var g = /* @__PURE__ */ au(), y = /* @__PURE__ */ cu(), w = l("Map.prototype.forEach", !0), S = l("Set.prototype.forEach", !0);
      if (typeof process > "u" || !process.versions || !process.versions.node)
        var b = l("Map.prototype.iterator", !0), A = l("Set.prototype.iterator", !0);
      var R = l("Map.prototype.@@iterator", !0) || l("Map.prototype._es6-shim iterator_", !0), M = l("Set.prototype.@@iterator", !0) || l("Set.prototype._es6-shim iterator_", !0), E = function(C) {
        if (g(C)) {
          if (b)
            return t(b(C));
          if (R)
            return R(C);
          if (w) {
            var k = [];
            return w(C, function(N, L) {
              u(k, [L, N]);
            }), p(k);
          }
        }
        if (y(C)) {
          if (A)
            return t(A(C));
          if (M)
            return M(C);
          if (S) {
            var P = [];
            return S(C, function(N) {
              u(P, N);
            }), p(P);
          }
        }
      };
      $t.exports = function(C) {
        return E(C) || m(C);
      };
    }
  }
  return $t.exports;
}
var yi, Jc;
function su() {
  if (Jc) return yi;
  Jc = 1;
  var e = function(t) {
    return t !== t;
  };
  return yi = function(r, n) {
    return r === 0 && n === 0 ? 1 / r === 1 / n : !!(r === n || e(r) && e(n));
  }, yi;
}
var bi, Zc;
function lu() {
  if (Zc) return bi;
  Zc = 1;
  var e = su();
  return bi = function() {
    return typeof Object.is == "function" ? Object.is : e;
  }, bi;
}
var wi, Qc;
function j1() {
  if (Qc) return wi;
  Qc = 1;
  var e = lu(), t = mt();
  return wi = function() {
    var n = e();
    return t(Object, { is: n }, {
      is: function() {
        return Object.is !== n;
      }
    }), n;
  }, wi;
}
var Si, es;
function q1() {
  if (es) return Si;
  es = 1;
  var e = mt(), t = Ot(), r = su(), n = lu(), i = j1(), o = t(n(), Object);
  return e(o, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), Si = o, Si;
}
var Ai, ts;
function uu() {
  if (ts) return Ai;
  ts = 1;
  var e = Ot(), t = /* @__PURE__ */ Se(), r = /* @__PURE__ */ Ye(), n = r("%ArrayBuffer%", !0), i = t("ArrayBuffer.prototype.byteLength", !0), o = t("Object.prototype.toString"), a = !!n && !i && new n(0).slice, c = !!a && e(a);
  return Ai = i || c ? function(u) {
    if (!u || typeof u != "object")
      return !1;
    try {
      return i ? i(u) : c(u, 0), !0;
    } catch {
      return !1;
    }
  } : n ? function(u) {
    return o(u) === "[object ArrayBuffer]";
  } : function(u) {
    return !1;
  }, Ai;
}
var Ci, rs;
function F1() {
  if (rs) return Ci;
  rs = 1;
  var e = /* @__PURE__ */ Se(), t = e("Date.prototype.getDay"), r = function(c) {
    try {
      return t(c), !0;
    } catch {
      return !1;
    }
  }, n = e("Object.prototype.toString"), i = "[object Date]", o = gt()();
  return Ci = function(c) {
    return typeof c != "object" || c === null ? !1 : o ? r(c) : n(c) === i;
  }, Ci;
}
var Ii, ns;
function du() {
  if (ns) return Ii;
  ns = 1;
  var e = /* @__PURE__ */ Se(), t = gt()(), r = /* @__PURE__ */ Bo(), n = /* @__PURE__ */ pt(), i;
  if (t) {
    var o = e("RegExp.prototype.exec"), a = {}, c = function() {
      throw a;
    }, l = {
      toString: c,
      valueOf: c
    };
    typeof Symbol.toPrimitive == "symbol" && (l[Symbol.toPrimitive] = c), i = function(h) {
      if (!h || typeof h != "object")
        return !1;
      var p = (
        /** @type {NonNullable<typeof gOPD>} */
        n(
          /** @type {{ lastIndex?: unknown }} */
          h,
          "lastIndex"
        )
      ), m = p && r(p, "value");
      if (!m)
        return !1;
      try {
        o(
          h,
          /** @type {string} */
          /** @type {unknown} */
          l
        );
      } catch (g) {
        return g === a;
      }
    };
  } else {
    var u = e("Object.prototype.toString"), f = "[object RegExp]";
    i = function(h) {
      return !h || typeof h != "object" && typeof h != "function" ? !1 : u(h) === f;
    };
  }
  return Ii = i, Ii;
}
var Ti, is;
function H1() {
  if (is) return Ti;
  is = 1;
  var e = /* @__PURE__ */ Se(), t = e("SharedArrayBuffer.prototype.byteLength", !0);
  return Ti = t ? function(n) {
    if (!n || typeof n != "object")
      return !1;
    try {
      return t(n), !0;
    } catch {
      return !1;
    }
  } : function(n) {
    return !1;
  }, Ti;
}
var Oi, os;
function U1() {
  if (os) return Oi;
  os = 1;
  var e = /* @__PURE__ */ Se(), t = e("Number.prototype.toString"), r = function(c) {
    try {
      return t(c), !0;
    } catch {
      return !1;
    }
  }, n = e("Object.prototype.toString"), i = "[object Number]", o = gt()();
  return Oi = function(c) {
    return typeof c == "number" ? !0 : !c || typeof c != "object" ? !1 : o ? r(c) : n(c) === i;
  }, Oi;
}
var Pi, as;
function W1() {
  if (as) return Pi;
  as = 1;
  var e = /* @__PURE__ */ Se(), t = e("Boolean.prototype.toString"), r = e("Object.prototype.toString"), n = function(c) {
    try {
      return t(c), !0;
    } catch {
      return !1;
    }
  }, i = "[object Boolean]", o = gt()();
  return Pi = function(c) {
    return typeof c == "boolean" ? !0 : c === null || typeof c != "object" ? !1 : o ? n(c) : r(c) === i;
  }, Pi;
}
var cr = { exports: {} }, Ri, cs;
function G1() {
  if (cs) return Ri;
  cs = 1;
  var e = /* @__PURE__ */ Se(), t = du(), r = e("RegExp.prototype.exec"), n = /* @__PURE__ */ Re();
  return Ri = function(o) {
    if (!t(o))
      throw new n("`regex` must be a RegExp");
    return function(c) {
      return r(o, c) !== null;
    };
  }, Ri;
}
var ss;
function V1() {
  if (ss) return cr.exports;
  ss = 1;
  var e = /* @__PURE__ */ Se(), t = e("Object.prototype.toString"), r = ko()(), n = /* @__PURE__ */ G1();
  if (r) {
    var i = e("Symbol.prototype.toString"), o = n(/^Symbol\(.*\)$/), a = function(l) {
      return typeof l.valueOf() != "symbol" ? !1 : o(i(l));
    };
    cr.exports = function(l) {
      if (typeof l == "symbol")
        return !0;
      if (!l || typeof l != "object" || t(l) !== "[object Symbol]")
        return !1;
      try {
        return a(l);
      } catch {
        return !1;
      }
    };
  } else
    cr.exports = function(l) {
      return !1;
    };
  return cr.exports;
}
var sr = { exports: {} }, Ni, ls;
function X1() {
  if (ls) return Ni;
  ls = 1;
  var e = typeof BigInt < "u" && BigInt;
  return Ni = function() {
    return typeof e == "function" && typeof BigInt == "function" && typeof e(42) == "bigint" && typeof BigInt(42) == "bigint";
  }, Ni;
}
var us;
function Y1() {
  if (us) return sr.exports;
  us = 1;
  var e = X1()();
  if (e) {
    var t = BigInt.prototype.valueOf, r = function(i) {
      try {
        return t.call(i), !0;
      } catch {
      }
      return !1;
    };
    sr.exports = function(i) {
      return i === null || typeof i > "u" || typeof i == "boolean" || typeof i == "string" || typeof i == "number" || typeof i == "symbol" || typeof i == "function" ? !1 : typeof i == "bigint" ? !0 : r(i);
    };
  } else
    sr.exports = function(i) {
      return !1;
    };
  return sr.exports;
}
var Mi, ds;
function K1() {
  if (ds) return Mi;
  ds = 1;
  var e = ou(), t = U1(), r = W1(), n = V1(), i = Y1();
  return Mi = function(a) {
    if (a == null || typeof a != "object" && typeof a != "function")
      return null;
    if (e(a))
      return "String";
    if (t(a))
      return "Number";
    if (r(a))
      return "Boolean";
    if (n(a))
      return "Symbol";
    if (i(a))
      return "BigInt";
  }, Mi;
}
var Ei, fs;
function J1() {
  if (fs) return Ei;
  fs = 1;
  var e = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap : null, t = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet : null, r;
  e || (r = function(a) {
    return !1;
  });
  var n = e ? e.prototype.has : null, i = t ? t.prototype.has : null;
  return !r && !n && (r = function(a) {
    return !1;
  }), Ei = r || function(a) {
    if (!a || typeof a != "object")
      return !1;
    try {
      if (n.call(a, n), i)
        try {
          i.call(a, i);
        } catch {
          return !0;
        }
      return a instanceof e;
    } catch {
    }
    return !1;
  }, Ei;
}
var lr = { exports: {} }, hs;
function Z1() {
  if (hs) return lr.exports;
  hs = 1;
  var e = /* @__PURE__ */ Ye(), t = /* @__PURE__ */ Se(), r = e("%WeakSet%", !0), n = t("WeakSet.prototype.has", !0);
  if (n) {
    var i = t("WeakMap.prototype.has", !0);
    lr.exports = function(a) {
      if (!a || typeof a != "object")
        return !1;
      try {
        if (n(a, n), i)
          try {
            i(a, i);
          } catch {
            return !0;
          }
        return a instanceof r;
      } catch {
      }
      return !1;
    };
  } else
    lr.exports = function(a) {
      return !1;
    };
  return lr.exports;
}
var $i, ps;
function Q1() {
  if (ps) return $i;
  ps = 1;
  var e = /* @__PURE__ */ au(), t = /* @__PURE__ */ cu(), r = J1(), n = /* @__PURE__ */ Z1();
  return $i = function(o) {
    if (o && typeof o == "object") {
      if (e(o))
        return "Map";
      if (t(o))
        return "Set";
      if (r(o))
        return "WeakMap";
      if (n(o))
        return "WeakSet";
    }
    return !1;
  }, $i;
}
var ki, ms;
function e0() {
  if (ms) return ki;
  ms = 1;
  var e = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, r, n;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      r = Object.defineProperty({}, "length", {
        get: function() {
          throw n;
        }
      }), n = {}, t(function() {
        throw 42;
      }, null, r);
    } catch (S) {
      S !== n && (t = null);
    }
  else
    t = null;
  var i = /^\s*class\b/, o = function(b) {
    try {
      var A = e.call(b);
      return i.test(A);
    } catch {
      return !1;
    }
  }, a = function(b) {
    try {
      return o(b) ? !1 : (e.call(b), !0);
    } catch {
      return !1;
    }
  }, c = Object.prototype.toString, l = "[object Object]", u = "[object Function]", f = "[object GeneratorFunction]", d = "[object HTMLAllCollection]", h = "[object HTML document.all class]", p = "[object HTMLCollection]", m = typeof Symbol == "function" && !!Symbol.toStringTag, g = !(0 in [,]), y = function() {
    return !1;
  };
  if (typeof document == "object") {
    var w = document.all;
    c.call(w) === c.call(document.all) && (y = function(b) {
      if ((g || !b) && (typeof b > "u" || typeof b == "object"))
        try {
          var A = c.call(b);
          return (A === d || A === h || A === p || A === l) && b("") == null;
        } catch {
        }
      return !1;
    });
  }
  return ki = t ? function(b) {
    if (y(b))
      return !0;
    if (!b || typeof b != "function" && typeof b != "object")
      return !1;
    try {
      t(b, null, r);
    } catch (A) {
      if (A !== n)
        return !1;
    }
    return !o(b) && a(b);
  } : function(b) {
    if (y(b))
      return !0;
    if (!b || typeof b != "function" && typeof b != "object")
      return !1;
    if (m)
      return a(b);
    if (o(b))
      return !1;
    var A = c.call(b);
    return A !== u && A !== f && !/^\[object HTML/.test(A) ? !1 : a(b);
  }, ki;
}
var _i, gs;
function t0() {
  if (gs) return _i;
  gs = 1;
  var e = e0(), t = Object.prototype.toString, r = Object.prototype.hasOwnProperty, n = function(l, u, f) {
    for (var d = 0, h = l.length; d < h; d++)
      r.call(l, d) && (f == null ? u(l[d], d, l) : u.call(f, l[d], d, l));
  }, i = function(l, u, f) {
    for (var d = 0, h = l.length; d < h; d++)
      f == null ? u(l.charAt(d), d, l) : u.call(f, l.charAt(d), d, l);
  }, o = function(l, u, f) {
    for (var d in l)
      r.call(l, d) && (f == null ? u(l[d], d, l) : u.call(f, l[d], d, l));
  };
  function a(c) {
    return t.call(c) === "[object Array]";
  }
  return _i = function(l, u, f) {
    if (!e(u))
      throw new TypeError("iterator must be a function");
    var d;
    arguments.length >= 3 && (d = f), a(l) ? n(l, u, d) : typeof l == "string" ? i(l, u, d) : o(l, u, d);
  }, _i;
}
var Li, vs;
function r0() {
  return vs || (vs = 1, Li = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), Li;
}
var Di, xs;
function n0() {
  if (xs) return Di;
  xs = 1;
  var e = /* @__PURE__ */ r0(), t = typeof globalThis > "u" ? Sr : globalThis;
  return Di = function() {
    for (var n = [], i = 0; i < e.length; i++)
      typeof t[e[i]] == "function" && (n[n.length] = e[i]);
    return n;
  }, Di;
}
var Bi, ys;
function i0() {
  if (ys) return Bi;
  ys = 1;
  var e = t0(), t = /* @__PURE__ */ n0(), r = Ot(), n = /* @__PURE__ */ Se(), i = /* @__PURE__ */ pt(), o = n("Object.prototype.toString"), a = gt()(), c = typeof globalThis > "u" ? Sr : globalThis, l = t(), u = n("String.prototype.slice"), f = Object.getPrototypeOf, d = n("Array.prototype.indexOf", !0) || function(y, w) {
    for (var S = 0; S < y.length; S += 1)
      if (y[S] === w)
        return S;
    return -1;
  }, h = { __proto__: null };
  a && i && f ? e(l, function(g) {
    var y = new c[g]();
    if (Symbol.toStringTag in y) {
      var w = f(y), S = i(w, Symbol.toStringTag);
      if (!S) {
        var b = f(w);
        S = i(b, Symbol.toStringTag);
      }
      h["$" + g] = r(S.get);
    }
  }) : e(l, function(g) {
    var y = new c[g](), w = y.slice || y.set;
    w && (h["$" + g] = r(w));
  });
  var p = function(y) {
    var w = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      h,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(S, b) {
        if (!w)
          try {
            "$" + S(y) === b && (w = u(b, 1));
          } catch {
          }
      }
    ), w;
  }, m = function(y) {
    var w = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      h,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(S, b) {
        if (!w)
          try {
            S(y), w = u(b, 1);
          } catch {
          }
      }
    ), w;
  };
  return Bi = function(y) {
    if (!y || typeof y != "object")
      return !1;
    if (!a) {
      var w = u(o(y), 8, -1);
      return d(l, w) > -1 ? w : w !== "Object" ? !1 : m(y);
    }
    return i ? p(y) : null;
  }, Bi;
}
var zi, bs;
function o0() {
  if (bs) return zi;
  bs = 1;
  var e = /* @__PURE__ */ Se(), t = e("ArrayBuffer.prototype.byteLength", !0), r = /* @__PURE__ */ uu();
  return zi = function(i) {
    return r(i) ? t ? t(i) : i.byteLength : NaN;
  }, zi;
}
var ji, ws;
function a0() {
  if (ws) return ji;
  ws = 1;
  var e = O1(), t = Zl(), r = M1(), n = /* @__PURE__ */ Ye(), i = z1(), o = nu(), a = q1(), c = /* @__PURE__ */ tu(), l = iu(), u = /* @__PURE__ */ uu(), f = /* @__PURE__ */ F1(), d = du(), h = /* @__PURE__ */ H1(), p = Ro(), m = K1(), g = /* @__PURE__ */ Q1(), y = /* @__PURE__ */ i0(), w = /* @__PURE__ */ o0(), S = t("SharedArrayBuffer.prototype.byteLength", !0), b = t("Date.prototype.getTime"), A = Object.getPrototypeOf, R = t("Object.prototype.toString"), M = n("%Set%", !0), E = t("Map.prototype.has", !0), O = t("Map.prototype.get", !0), C = t("Map.prototype.size", !0), k = t("Set.prototype.add", !0), P = t("Set.prototype.delete", !0), N = t("Set.prototype.has", !0), L = t("Set.prototype.size", !0);
  function _(I, $, F, j) {
    for (var V = i(I), K; (K = V.next()) && !K.done; )
      if (J($, K.value, F, j))
        return P(I, K.value), !0;
    return !1;
  }
  function G(I) {
    if (typeof I > "u")
      return null;
    if (typeof I != "object")
      return typeof I == "symbol" ? !1 : typeof I == "string" || typeof I == "number" ? +I == +I : !0;
  }
  function ee(I, $, F, j, V, K) {
    var B = G(F);
    if (B != null)
      return B;
    var z = O($, B), D = e({}, V, { strict: !1 });
    return typeof z > "u" && !E($, B) || !J(j, z, D, K) ? !1 : !E(I, B) && J(j, z, D, K);
  }
  function se(I, $, F) {
    var j = G(F);
    return j ?? (N($, j) && !N(I, j));
  }
  function re(I, $, F, j, V, K) {
    for (var B = i(I), z, D; (z = B.next()) && !z.done; )
      if (D = z.value, // eslint-disable-next-line no-use-before-define
      J(F, D, V, K) && J(j, O($, D), V, K))
        return P(I, D), !0;
    return !1;
  }
  function J(I, $, F, j) {
    var V = F || {};
    if (V.strict ? a(I, $) : I === $)
      return !0;
    var K = m(I), B = m($);
    if (K !== B)
      return !1;
    if (!I || !$ || typeof I != "object" && typeof $ != "object")
      return V.strict ? a(I, $) : I == $;
    var z = j.has(I), D = j.has($), U;
    if (z && D) {
      if (j.get(I) === j.get($))
        return !0;
    } else
      U = {};
    return z || j.set(I, U), D || j.set($, U), Ne(I, $, V, j);
  }
  function ge(I) {
    return !I || typeof I != "object" || typeof I.length != "number" || typeof I.copy != "function" || typeof I.slice != "function" || I.length > 0 && typeof I[0] != "number" ? !1 : !!(I.constructor && I.constructor.isBuffer && I.constructor.isBuffer(I));
  }
  function fe(I, $, F, j) {
    if (L(I) !== L($))
      return !1;
    for (var V = i(I), K = i($), B, z, D; (B = V.next()) && !B.done; )
      if (B.value && typeof B.value == "object")
        D || (D = new M()), k(D, B.value);
      else if (!N($, B.value)) {
        if (F.strict || !se(I, $, B.value))
          return !1;
        D || (D = new M()), k(D, B.value);
      }
    if (D) {
      for (; (z = K.next()) && !z.done; )
        if (z.value && typeof z.value == "object") {
          if (!_(D, z.value, F.strict, j))
            return !1;
        } else if (!F.strict && !N(I, z.value) && !_(D, z.value, F.strict, j))
          return !1;
      return L(D) === 0;
    }
    return !0;
  }
  function Ke(I, $, F, j) {
    if (C(I) !== C($))
      return !1;
    for (var V = i(I), K = i($), B, z, D, U, ue, he; (B = V.next()) && !B.done; )
      if (U = B.value[0], ue = B.value[1], U && typeof U == "object")
        D || (D = new M()), k(D, U);
      else if (he = O($, U), typeof he > "u" && !E($, U) || !J(ue, he, F, j)) {
        if (F.strict || !ee(I, $, U, ue, F, j))
          return !1;
        D || (D = new M()), k(D, U);
      }
    if (D) {
      for (; (z = K.next()) && !z.done; )
        if (U = z.value[0], he = z.value[1], U && typeof U == "object") {
          if (!re(D, I, U, he, F, j))
            return !1;
        } else if (!F.strict && (!I.has(U) || !J(O(I, U), he, F, j)) && !re(D, I, U, he, e({}, F, { strict: !1 }), j))
          return !1;
      return L(D) === 0;
    }
    return !0;
  }
  function Ne(I, $, F, j) {
    var V, K;
    if (typeof I != typeof $ || I == null || $ == null || R(I) !== R($) || c(I) !== c($))
      return !1;
    var B = l(I), z = l($);
    if (B !== z)
      return !1;
    var D = I instanceof Error, U = $ instanceof Error;
    if (D !== U || (D || U) && (I.name !== $.name || I.message !== $.message))
      return !1;
    var ue = d(I), he = d($);
    if (ue !== he || (ue || he) && (I.source !== $.source || r(I) !== r($)))
      return !1;
    var pe = f(I), ve = f($);
    if (pe !== ve || (pe || ve) && b(I) !== b($) || F.strict && A && A(I) !== A($))
      return !1;
    var Ae = y(I), ze = y($);
    if (Ae !== ze)
      return !1;
    if (Ae || ze) {
      if (I.length !== $.length)
        return !1;
      for (V = 0; V < I.length; V++)
        if (I[V] !== $[V])
          return !1;
      return !0;
    }
    var Me = ge(I), Ce = ge($);
    if (Me !== Ce)
      return !1;
    if (Me || Ce) {
      if (I.length !== $.length)
        return !1;
      for (V = 0; V < I.length; V++)
        if (I[V] !== $[V])
          return !1;
      return !0;
    }
    var je = u(I), qe = u($);
    if (je !== qe)
      return !1;
    if (je || qe)
      return w(I) !== w($) ? !1 : typeof Uint8Array == "function" && J(new Uint8Array(I), new Uint8Array($), F, j);
    var Fe = h(I), Zt = h($);
    if (Fe !== Zt)
      return !1;
    if (Fe || Zt)
      return S(I) !== S($) ? !1 : typeof Uint8Array == "function" && J(new Uint8Array(I), new Uint8Array($), F, j);
    if (typeof I != typeof $)
      return !1;
    var Je = p(I), vt = p($);
    if (Je.length !== vt.length)
      return !1;
    for (Je.sort(), vt.sort(), V = Je.length - 1; V >= 0; V--)
      if (Je[V] != vt[V])
        return !1;
    for (V = Je.length - 1; V >= 0; V--)
      if (K = Je[V], !J(I[K], $[K], F, j))
        return !1;
    var Pt = g(I), Ze = g($);
    return Pt !== Ze ? !1 : Pt === "Set" || Ze === "Set" ? fe(I, $, F, j) : Pt === "Map" ? Ke(I, $, F, j) : !0;
  }
  return ji = function($, F, j) {
    return J($, F, j, o());
  }, ji;
}
var c0 = a0();
const s0 = /* @__PURE__ */ o1(c0);
function l0(e) {
  return e;
}
function u0(e, t, r, n) {
  const i = l0, [o, a] = Y(i(r)), c = We(o);
  return le(() => {
    const l = () => {
      const u = { ...r, ...e.getAttributes(t) };
      Object.keys(u).forEach((d) => {
        (u[d] === null || u[d] === void 0) && (u[d] = r ? r[d] : null);
      });
      const f = i(u);
      s0(c.current, f) || (a(f), c.current = f);
    };
    return e.on("selectionUpdate", l), e.on("transaction", l), () => {
      e.off("selectionUpdate", l), e.off("transaction", l);
    };
  }, [e, r, t, i]), o;
}
function d0({ editor: e }) {
  const { t } = me(), { width: r, height: n, src: i } = u0(e, bt.name, {
    width: 0,
    height: 0,
    src: "",
    defaultShowPicker: !1
  }), [o, a] = Y(!1), [c, l] = Y(""), u = te(() => {
    a(!1);
  }, [a]);
  le(() => {
    o && l(i);
  }, [o, i]);
  const f = te(() => {
    const y = Hl(c);
    e.chain().updateAttributes(bt.name, {
      src: (y == null ? void 0 : y.src) || c
    }).setNodeSelection(e.state.selection.from).focus().run(), a(!1);
  }, [e, c, a]), d = te(() => {
    window.open(i, "_blank");
  }, [i]), h = te(() => {
    a(!0);
  }, [a]), p = te(
    (y) => {
      e.chain().updateAttributes(bt.name, y).setNodeSelection(e.state.selection.from).focus().run();
    },
    [e]
  ), m = te(() => e.isActive(bt.name) && !i, [e, i]), g = te(() => Rl(bt.name, e), [e]);
  return /* @__PURE__ */ T(de, { children: [
    /* @__PURE__ */ s(
      at,
      {
        className: "bubble-menu",
        editor: e,
        pluginKey: "iframe-bubble-menu",
        shouldShow: m,
        tippyOptions: {
          popperOptions: {
            modifiers: [{ name: "flip", enabled: !1 }]
          },
          placement: "bottom-start",
          offset: [-2, 16],
          zIndex: 9999
          // onHidden: () => {
          //   toggleVisible(false)
          // },
        },
        children: /* @__PURE__ */ T("div", { className: "richtext-pointer-events-auto richtext-w-auto richtext-select-none richtext-rounded-sm !richtext-border richtext-border-neutral-200 richtext-bg-background richtext-px-3 richtext-py-2 richtext-shadow-sm richtext-transition-all dark:richtext-border-neutral-800", children: [
          /* @__PURE__ */ s(
            q,
            {
              action: d,
              icon: "Eye",
              tooltip: "Visit Link"
            }
          ),
          /* @__PURE__ */ s(
            q,
            {
              action: h,
              icon: "Pencil",
              tooltip: "Open Edit Link"
            }
          ),
          /* @__PURE__ */ s(
            Ly,
            {
              height: n,
              onOk: p,
              width: r,
              children: /* @__PURE__ */ s(
                q,
                {
                  icon: "Settings",
                  tooltip: t("editor.settings")
                }
              )
            }
          ),
          /* @__PURE__ */ s(
            q,
            {
              action: g,
              icon: "Trash2",
              tooltip: t("editor.delete")
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ T(
      Pr,
      {
        onOpenChange: a,
        open: o,
        children: [
          /* @__PURE__ */ s(Rr, {}),
          /* @__PURE__ */ T(Xt, { children: [
            /* @__PURE__ */ s(Al, { children: /* @__PURE__ */ s(Yt, { children: "Edit Link Iframe" }) }),
            /* @__PURE__ */ s(
              Oe,
              {
                autoFocus: !0,
                onInput: (y) => l(y.target.value),
                placeholder: "Enter link",
                type: "url",
                value: c
              }
            ),
            /* @__PURE__ */ T(Ao, { children: [
              /* @__PURE__ */ s(be, { onClick: u, children: "Cancel" }),
              /* @__PURE__ */ s(be, { onClick: f, children: "OK" })
            ] })
          ] })
        ]
      }
    )
  ] });
}
function f0({ editor: e, disabled: t, bubbleMenu: r }) {
  const n = e.extensionManager.extensions.map((o) => o.name), i = () => {
    var o, a, c, l, u, f, d, h, p, m;
    return [
      n.includes("columns") && !((o = r == null ? void 0 : r.columnConfig) != null && o.hidden) ? /* @__PURE__ */ s(
        gy,
        {
          editor: e
        },
        "columns"
      ) : null,
      n.includes("table") && !((a = r == null ? void 0 : r.tableConfig) != null && a.hidden) ? /* @__PURE__ */ s(
        Tx,
        {
          actions: (c = r == null ? void 0 : r.tableConfig) == null ? void 0 : c.actions,
          editor: e
        },
        "table"
      ) : null,
      n.includes("link") && !((l = r == null ? void 0 : r.linkConfig) != null && l.hidden) ? /* @__PURE__ */ s(
        Rx,
        {
          disabled: t,
          editor: e
        },
        "link"
      ) : null,
      n.includes(qt.name) && !((u = r == null ? void 0 : r.imageConfig) != null && u.hidden) ? /* @__PURE__ */ s(
        ly,
        {
          disabled: t,
          editor: e
        },
        "image"
      ) : null,
      n.includes(Tl.name) && !((f = r == null ? void 0 : r.imageGifConfig) != null && f.hidden) ? /* @__PURE__ */ s(
        uy,
        {
          disabled: t,
          editor: e
        },
        "imageGif"
      ) : null,
      n.includes("video") && !((d = r == null ? void 0 : r.videoConfig) != null && d.hidden) ? /* @__PURE__ */ s(
        dy,
        {
          disabled: t,
          editor: e
        },
        "video"
      ) : null,
      n.includes("iframe") && !((h = r == null ? void 0 : r.iframeConfig) != null && h.hidden) ? /* @__PURE__ */ s(
        d0,
        {
          disabled: t,
          editor: e
        },
        "iframe"
      ) : null,
      (p = r == null ? void 0 : r.floatingMenuConfig) != null && p.hidden ? null : /* @__PURE__ */ s(
        Zv,
        {
          disabled: t,
          editor: e
        },
        "content"
      ),
      (m = r == null ? void 0 : r.textConfig) != null && m.hidden ? null : /* @__PURE__ */ s(
        tx,
        {
          disabled: t,
          editor: e
        },
        "text"
      )
    ];
  };
  return r != null && r.render ? r.render({ editor: e, disabled: t || !1, extensionsNames: n, bubbleMenu: r }, i()) : i().filter(Boolean);
}
function Ss() {
  return /* @__PURE__ */ s("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", children: /* @__PURE__ */ s("path", { fill: "currentColor", d: "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31m-.88 3.12L12.5 12.5L5.27 5.27L4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6c1.52 0 2.9-.57 3.96-1.5l2.63 2.63l1.27-1.27z" }) });
}
function h0(e) {
  const { t } = me(), {
    highlight: r = !1,
    disabled: n = !1,
    selectedColor: i,
    setSelectedColor: o,
    onChange: a,
    colors: c = _u
  } = e, l = ye(() => {
    const p = c, m = [];
    for (let g = 0; g < p.length; g += 10)
      m.push(p.slice(g, g + 10));
    return m;
  }, [c]), [u, f] = Y([]), d = (p) => {
    const m = [...u], g = m.indexOf(p);
    g !== -1 && m.splice(g, 1), m.unshift(p), m.length > 10 && m.pop(), f(m);
  };
  function h(p) {
    if (p === void 0) {
      o == null || o(p), a == null || a(p);
      return;
    }
    /^#([\da-f]{3}){1,2}$/i.test(p) && (o == null || o(p), a == null || a(p), d(p));
  }
  return /* @__PURE__ */ T(Er, { modal: !0, children: [
    /* @__PURE__ */ s(
      $r,
      {
        asChild: !0,
        className: "!richtext-p-0",
        disabled: n,
        children: e == null ? void 0 : e.children
      }
    ),
    /* @__PURE__ */ s(
      Kt,
      {
        align: "start",
        className: "richtext-size-full richtext-p-2",
        hideWhenDetached: !0,
        side: "bottom",
        children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-flex-col", children: [
          r ? /* @__PURE__ */ T(
            "div",
            {
              className: "rd-1 richtext-flex richtext-cursor-pointer richtext-items-center richtext-gap-[4px] richtext-p-1 hover:richtext-bg-accent",
              onClick: () => h(void 0),
              children: [
                /* @__PURE__ */ s(Ss, {}),
                /* @__PURE__ */ s("span", { className: "richtext-ml-1 richtext-text-sm", children: t("editor.nofill") })
              ]
            }
          ) : /* @__PURE__ */ T(
            "div",
            {
              className: "rd-1 richtext-flex richtext-cursor-pointer richtext-items-center richtext-gap-[4px] richtext-p-1 hover:richtext-bg-accent",
              onClick: () => {
                h(void 0);
              },
              children: [
                /* @__PURE__ */ s(Ss, {}),
                /* @__PURE__ */ s("span", { className: "richtext-ml-1 richtext-text-sm", children: t("editor.default") })
              ]
            }
          ),
          l.map((p, m) => /* @__PURE__ */ s(
            "span",
            {
              className: "richtext-relative richtext-flex richtext-h-auto richtext-w-full richtext-p-0 last:richtext-pb-2",
              children: p.map((g, y) => /* @__PURE__ */ s(
                "span",
                {
                  className: "richtext-inline-block richtext-size-6 richtext-flex-[0_0_auto] richtext-cursor-pointer richtext-rounded-sm !richtext-border richtext-border-transparent richtext-p-0.5 hover:richtext-border-border hover:richtext-shadow-sm",
                  onClick: () => h(g),
                  children: /* @__PURE__ */ s(
                    "span",
                    {
                      className: "richtext-relative richtext-block richtext-size-[18px] richtext-rounded-[2px] richtext-border-transparent",
                      style: {
                        backgroundColor: g
                      },
                      children: g === i ? /* @__PURE__ */ s(
                        "svg",
                        {
                          className: "richtext-absolute -richtext-top-px richtext-left-px richtext-block richtext-size-3",
                          viewBox: "0 0 18 18",
                          style: {
                            fill: "rgb(255, 255, 255)"
                          },
                          children: /* @__PURE__ */ s("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
                        }
                      ) : /* @__PURE__ */ s(
                        "svg",
                        {
                          viewBox: "0 0 18 18",
                          style: {
                            fill: "rgb(255, 255, 255)",
                            display: "none"
                          },
                          children: /* @__PURE__ */ s("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
                        }
                      )
                    }
                  )
                },
                `sub-color-${y}`
              ))
            },
            m
          )),
          /* @__PURE__ */ T("div", { children: [
            /* @__PURE__ */ s("div", { className: "richtext-my-1 richtext-text-sm", children: t("editor.recent") }),
            /* @__PURE__ */ s("span", { className: "richtext-relative richtext-flex richtext-h-auto richtext-w-full richtext-p-0 last:richtext-pb-2", children: u == null ? void 0 : u.map((p, m) => /* @__PURE__ */ s(
              "span",
              {
                className: "richtext-inline-block richtext-size-6 richtext-flex-[0_0_auto] richtext-cursor-pointer richtext-rounded-sm !richtext-border richtext-border-transparent richtext-p-0.5 hover:richtext-border-border hover:richtext-shadow-sm",
                onClick: () => h(p),
                children: /* @__PURE__ */ s(
                  "span",
                  {
                    className: "richtext-relative richtext-block richtext-size-[18px] richtext-rounded-[2px] richtext-border-transparent",
                    style: {
                      backgroundColor: p
                    },
                    children: /* @__PURE__ */ s(
                      "svg",
                      {
                        viewBox: "0 0 18 18",
                        style: {
                          fill: "rgb(255, 255, 255)",
                          display: "none"
                        },
                        children: /* @__PURE__ */ s("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
                      }
                    )
                  }
                )
              },
              `sub-color-recent-${m}`
            )) })
          ] }),
          /* @__PURE__ */ s(p0, { setColor: h })
        ] })
      }
    )
  ] });
}
function p0({ setColor: e }) {
  const [t, r] = Y("#000000"), [n, i] = Y(!1), { t: o } = me();
  return le(() => () => {
    i(!1);
  }, []), /* @__PURE__ */ T(Er, { open: n, children: [
    /* @__PURE__ */ s($r, { asChild: !0, children: /* @__PURE__ */ T(
      "div",
      {
        className: "richtext-p-1.5 richtext-text-sm hover:richtext-cursor-pointer hover:richtext-bg-accent",
        onClick: (a) => {
          a.preventDefault(), i(!0);
        },
        children: [
          o("editor.color.more"),
          "..."
        ]
      }
    ) }),
    /* @__PURE__ */ T(Kt, { children: [
      /* @__PURE__ */ T("div", { className: "richtext-flex richtext-flex-col richtext-items-center richtext-justify-center", children: [
        /* @__PURE__ */ s(
          yf,
          {
            color: t,
            onChange: r
          }
        ),
        /* @__PURE__ */ s(
          Oe,
          {
            className: "richtext-mt-[8px] richtext-w-full",
            type: "text",
            value: t.slice(1),
            onChange: (a) => {
              a.preventDefault(), r(`#${a.target.value}`);
            }
          }
        )
      ] }),
      /* @__PURE__ */ s(_e, { className: "richtext-my-[10px]" }),
      /* @__PURE__ */ s(
        be,
        {
          className: "richtext-w-full",
          onClick: (a) => {
            a.preventDefault(), e(t), i(!1);
          },
          children: /* @__PURE__ */ s(Ps, { size: 16 })
        }
      )
    ] })
  ] });
}
function m0({ editor: e, disabled: t, toolbar: r }) {
  const { t: n, lang: i } = me(), o = ye(() => {
    const u = [...e.extensionManager.extensions].sort((d, h) => {
      const p = d.options.sort ?? -1, m = h.options.sort ?? -1;
      return p - m;
    });
    let f = [];
    for (const d of u) {
      const {
        button: h,
        divider: p = !1,
        spacer: m = !1,
        toolbar: g = !0
      } = d.options;
      if (!h || !ry(h) || !g)
        continue;
      const y = h({
        editor: e,
        extension: d,
        t: n
      });
      if (Array.isArray(y)) {
        const w = y.map((S, b) => ({
          button: S,
          divider: b === y.length - 1 ? p : !1,
          spacer: b === 0 ? m : !1,
          type: d.type,
          name: d.name
        }));
        f = [...f, ...w];
        continue;
      }
      f.push({
        button: y,
        divider: p,
        spacer: m,
        type: d.type,
        name: d.name
      });
    }
    return f;
  }, [e, n, i]), a = (l) => /* @__PURE__ */ s(
    "div",
    {
      className: "richtext-px-1 richtext-py-2 !richtext-border-b",
      style: {
        pointerEvents: t ? "none" : "auto",
        opacity: t ? 0.5 : 1
      },
      children: /* @__PURE__ */ s("div", { className: "richtext-relative richtext-flex richtext-flex-wrap richtext-h-auto richtext-gap-y-1 richtext-gap-x-1", children: l })
    }
  ), c = o.map((l, u) => {
    var d, h;
    const f = l.button.component;
    return /* @__PURE__ */ T("div", { className: "richtext-flex richtext-items-center", children: [
      (l == null ? void 0 : l.spacer) && /* @__PURE__ */ s(_e, { orientation: "vertical", className: "!richtext-h-[16px] !richtext-mx-[10px]" }),
      /* @__PURE__ */ s(
        f,
        {
          ...l.button.componentProps,
          disabled: t || ((h = (d = l == null ? void 0 : l.button) == null ? void 0 : d.componentProps) == null ? void 0 : h.disabled)
        }
      ),
      (l == null ? void 0 : l.divider) && /* @__PURE__ */ s(_e, { orientation: "vertical", className: "!richtext-h-auto !richtext-mx-2" })
    ] }, `toolbar-item-${u}`);
  });
  return r && (r != null && r.render) ? r.render({ editor: e, disabled: t || !1 }, o, c, a) : a(c);
}
function g0({ editor: e, extensions: t }) {
  const { t: r } = me(), n = ye(() => {
    var i, o, a;
    return (a = (o = (i = t == null ? void 0 : t.find((c) => c.name === "base-kit")) == null ? void 0 : i.options) == null ? void 0 : o.characterCount) == null ? void 0 : a.limit;
  }, [t]);
  return n ? /* @__PURE__ */ s("div", { className: "richtext-flex richtext-items-center richtext-justify-between richtext-p-3 richtext-border-t", children: /* @__PURE__ */ s("div", { className: "richtext-flex richtext-flex-col", children: /* @__PURE__ */ s("div", { className: "richtext-flex richtext-justify-end richtext-gap-3 richtext-text-sm", children: /* @__PURE__ */ T("span", { children: [
    e.storage.characterCount.characters(),
    "/",
    n,
    " ",
    r("editor.characters")
  ] }) }) }) }) : /* @__PURE__ */ s("div", { className: "richtext-flex richtext-items-center richtext-justify-between richtext-p-3 richtext-border-t", children: /* @__PURE__ */ s("div", { className: "richtext-flex richtext-flex-col", children: /* @__PURE__ */ s("div", { className: "richtext-flex richtext-justify-end richtext-gap-3 richtext-text-sm", children: /* @__PURE__ */ T("span", { children: [
    e.storage.characterCount.characters(),
    " ",
    r("editor.characters")
  ] }) }) }) });
}
function v0() {
  const { toasts: e } = ky();
  return /* @__PURE__ */ T(Cy, { children: [
    e.map(({ id: t, title: r, description: n, action: i, ...o }) => /* @__PURE__ */ T(
      _l,
      {
        ...o,
        children: [
          /* @__PURE__ */ T("div", { className: "richtext-grid richtext-gap-1", children: [
            r && /* @__PURE__ */ s(Dl, { children: r }),
            n && /* @__PURE__ */ s(Bl, { children: n })
          ] }),
          i,
          /* @__PURE__ */ s(Ll, {})
        ]
      },
      t
    )),
    /* @__PURE__ */ s(kl, {})
  ] });
}
const x0 = `
.reactjs-tiptap-editor,
.richtext-dialog-content {
  button,
  input:where([type=button]),
  input:where([type=reset]),
  input:where([type=submit]) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
  }

  input,
  optgroup,
  select {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }

  button {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: hsl(var(--richtext-border));
  }

  background-color: hsl(var(--richtext-background));
  color: hsl(var(--richtext-foreground));

  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp,
  pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
    font-feature-settings: normal;
    font-variation-settings: normal;
    font-size: 1em;
  }

  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }

  input {
    border-width: 1px;
  }


  input::placeholder {
    opacity: 1;
    color: #9ca3af;
  }

  button, input {
    cursor: pointer;
    color: inherit;
  }

  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
    vertical-align: middle;
  }

  img,
  video {
    max-width: 100%;
    height: auto;
  }
}

div[data-radix-popper-content-wrapper],
div[data-tippy-root] {
  *,
  ::before,
  ::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: hsl(var(--richtext-border));
  }

  background-color: hsl(var(--richtext-background));
  color: hsl(var(--richtext-foreground));

  button, input {
    cursor: pointer;
    color: inherit;
  }
}
`, y0 = Tu(({ children: e, id: t }) => {
  const [, r] = Cl((a) => a.value), [, n] = Il((a) => a.value), i = (a) => {
    r({
      value: a.detail
    });
  }, o = (a) => {
    n({
      value: a.detail
    });
  };
  return le(() => {
    const a = br(ut.EDIT(t), i), c = br(ut.UPDATE_THEME(t), o);
    return () => {
      a(), c();
    };
  }, []), /* @__PURE__ */ s(de, { children: e });
});
function b0({ children: e, id: t }) {
  return /* @__PURE__ */ s(Dx, { children: /* @__PURE__ */ s(Bx, { children: /* @__PURE__ */ s(y0, { id: t, children: e }) }) });
}
function Z0() {
  const [e] = Il((t) => t.value);
  return e;
}
const w0 = {
  setTheme: (e, t) => {
    Co(ut.UPDATE_THEME(e), t);
  }
}, As = "data-rc-order", Cs = "data-rc-priority", S0 = "rc-util-key", oo = /* @__PURE__ */ new Map();
function A0(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  let r = t;
  for (; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
function fu({ mark: e } = {}) {
  return e ? e.startsWith("data-") ? e : `data-${e}` : S0;
}
function zo(e) {
  return e.attachTo ? e.attachTo : document.querySelector("head") || document.body;
}
function C0(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function hu(e) {
  return [...(oo.get(e) || e).children].filter(
    (t) => t.tagName === "STYLE"
  );
}
function pu(e, t = {}) {
  const { csp: r, prepend: n, priority: i = 0 } = t, o = C0(n), a = o === "prependQueue", c = document.createElement("style");
  c.setAttribute(As, o), a && i && c.setAttribute(Cs, `${i}`), r != null && r.nonce && (c.nonce = r == null ? void 0 : r.nonce), c.innerHTML = e;
  const l = zo(t), { firstChild: u } = l;
  if (n) {
    if (a) {
      const f = hu(l).filter((d) => {
        if (!["prepend", "prependQueue"].includes(d.getAttribute(As)))
          return !1;
        const h = Number(d.getAttribute(Cs) || 0);
        return i >= h;
      });
      if (f.length > 0)
        return l.insertBefore(c, f.at(-1).nextSibling), c;
    }
    u.before(c);
  } else
    l.append(c);
  return c;
}
function mu(e, t = {}) {
  const r = zo(t);
  return hu(r).find((n) => n.getAttribute(fu(t)) === e);
}
function I0(e, t = {}) {
  const r = mu(e, t);
  r && r.remove();
}
function T0(e, t) {
  const r = oo.get(e);
  if (!r || !A0(document, r)) {
    const n = pu("", t), { parentNode: i } = n;
    oo.set(e, i), n.remove();
  }
}
function O0(e, t, r = {}) {
  var a, c, l;
  const n = zo(r);
  T0(n, r);
  const i = mu(t, r);
  if (i)
    return (a = r.csp) != null && a.nonce && i.nonce !== ((c = r.csp) == null ? void 0 : c.nonce) && (i.nonce = (l = r.csp) == null ? void 0 : l.nonce), i.innerHTML !== e && (i.innerHTML = e), i;
  const o = pu(e, r);
  return o.setAttribute(fu(r), t), o;
}
function P0(e, t) {
  const { content: r, extensions: n, useEditorOptions: i = {} } = e, o = Pu(), a = ye(() => {
    const d = Mg(n, n, "name");
    return [...n.map((p) => {
      const m = n.find((g) => g.name === p.name);
      return m ? p.configure(m.options) : p;
    }), ...d].map((p, m) => p.configure({ sort: m }));
  }, [n]), c = jt((d) => {
    var p;
    const h = u(d, e.output);
    (p = e == null ? void 0 : e.onChangeContent) == null || p.call(e, h);
  }, Lu), l = Mu({
    extensions: a,
    content: r,
    onUpdate: ({ editor: d }) => {
      c && c(d);
    },
    ...i
  });
  Ru(t, () => ({
    editor: l
  })), le(() => {
    document.documentElement.classList.toggle("dark", e.dark), w0.setTheme(o, e.dark ? "dark" : "light");
  }, [e.dark]), le(() => {
    l == null || l.setEditable(!(e != null && e.disabled)), t1.setDisable(o, !(e != null && e.disabled));
  }, [l, e == null ? void 0 : e.disabled]), le(() => ((e == null ? void 0 : e.resetCSS) !== !1 && O0(x0, "react-tiptap-reset"), () => {
    I0("react-tiptap-reset");
  }), [e == null ? void 0 : e.resetCSS]);
  function u(d, h) {
    return e != null && e.removeDefaultWrapper ? h === "html" ? d.isEmpty ? "" : d.getHTML() : h === "json" ? d.isEmpty ? {} : d.getJSON() : h === "text" ? d.isEmpty ? "" : d.getText() : "" : h === "html" ? d.getHTML() : h === "json" ? d.getJSON() : h === "text" ? d.getText() : "";
  }
  Nu(() => {
    l && (l.id = o);
  }, [o, l]), le(() => () => {
    var d;
    (d = l == null ? void 0 : l.destroy) == null || d.call(l);
  }, []);
  const f = iy(l, "characterCount");
  return l ? /* @__PURE__ */ T("div", { className: "reactjs-tiptap-editor", children: [
    /* @__PURE__ */ s(
      b0,
      {
        id: o,
        children: /* @__PURE__ */ s(
          Py,
          {
            delayDuration: 0,
            disableHoverableContent: !0,
            children: /* @__PURE__ */ s("div", { className: "richtext-overflow-hidden richtext-rounded-[0.5rem] richtext-bg-background richtext-shadow richtext-outline richtext-outline-1", children: /* @__PURE__ */ T("div", { className: "richtext-flex richtext-max-h-full richtext-w-full richtext-flex-col", children: [
              !(e != null && e.hideToolbar) && /* @__PURE__ */ s(
                m0,
                {
                  disabled: !!(e != null && e.disabled),
                  editor: l,
                  toolbar: e.toolbar
                }
              ),
              /* @__PURE__ */ s(
                Eu,
                {
                  className: `richtext-relative ${(e == null ? void 0 : e.contentClass) || ""}`,
                  editor: l
                }
              ),
              f && /* @__PURE__ */ s(
                g0,
                {
                  editor: l,
                  extensions: n
                }
              ),
              !(e != null && e.hideBubble) && /* @__PURE__ */ s(
                f0,
                {
                  bubbleMenu: e == null ? void 0 : e.bubbleMenu,
                  disabled: e == null ? void 0 : e.disabled,
                  editor: l
                }
              )
            ] }) })
          }
        )
      }
    ),
    /* @__PURE__ */ s(v0, {})
  ] }) : /* @__PURE__ */ s(de, {});
}
const Q0 = Ou(P0);
export {
  G0 as $,
  q as A,
  be as B,
  h0 as C,
  vy as D,
  ut as E,
  Ao as F,
  _x as G,
  Ix as H,
  to as I,
  jt as J,
  Y0 as K,
  it as L,
  sx as M,
  wl as N,
  u0 as O,
  Er as P,
  Z0 as Q,
  Ox as R,
  El as S,
  jl as T,
  qt as U,
  zx as V,
  Ol as W,
  X0 as X,
  vx as Y,
  gx as Z,
  e1 as _,
  ql as a,
  W0 as a0,
  V0 as a1,
  o1 as a2,
  F0 as a3,
  _e as a4,
  Rl as a5,
  Ly as a6,
  H0 as a7,
  Pl as a8,
  wr as a9,
  Q0 as aa,
  a1 as ab,
  Sr as ac,
  ky as ad,
  iy as ae,
  Tl as af,
  my as ag,
  J0 as ah,
  bt as ai,
  Po as b,
  U0 as c,
  X as d,
  xy as e,
  Nl as f,
  kv as g,
  yy as h,
  bl as i,
  K0 as j,
  xe as k,
  br as l,
  $r as m,
  Kt as n,
  Oe as o,
  s0 as p,
  Co as q,
  zl as r,
  $v as s,
  Or as t,
  Ml as u,
  Sy as v,
  Pr as w,
  Rr as x,
  Xt as y,
  Yt as z
};
